window.FREYA_IMPORTED_RECIPES = [
  {
    "slug": "carkifelek-somon-ceviche",
    "title": "Çarkıfelek Somon Ceviche",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_somon_ceviche.jpg?v=1712565830",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "2 Kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ]
    ],
    "time": "Hazırlama 15 dk",
    "ingredients": [
      "250 gr somon fileto",
      "1 kırmızı soğan, küçük doğranmış",
      "1 yeşil biber, küçük doğranmış",
      "150 gr Freya Gurme Çarkıfelek Sos",
      "15 ml soya sos",
      "10 ml limon suyu",
      "10 gr kişniş",
      "2 gr tuz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "250 gr somon fileto",
          "1 kırmızı soğan, küçük doğranmış",
          "1 yeşil biber, küçük doğranmış",
          "150 gr Freya Gurme Çarkıfelek Sos",
          "15 ml soya sos",
          "10 ml limon suyu",
          "10 gr kişniş",
          "2 gr tuz"
        ]
      }
    ],
    "steps": [
      "Somonları küp küp kesiniz",
      "Soya sosu, soğanı, biberi ve kişnişi ekleyiniz ve karıştırınız",
      "Çarkıfelek sosunu, limonu ve tuzu ekleyiniz",
      "Servis tabağına koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Somonları küp küp kesiniz",
          "Soya sosu, soğanı, biberi ve kişnişi ekleyiniz ve karıştırınız",
          "Çarkıfelek sosunu, limonu ve tuzu ekleyiniz",
          "Servis tabağına koyunuz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelekli-somon-ceviche",
    "sourceId": "gid://shopify/Article/605705732380",
    "aliases": [
      "carkifelekli-somon-ceviche"
    ]
  },
  {
    "slug": "fool-mango-ve-carkifelek",
    "title": "Fool Mango & Çarkıfelek",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_fool_mango.jpg?v=1712566874",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "4 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Bekletme",
        "2 Saat buzdolabında soğutma"
      ]
    ],
    "time": "Hazırlama 10 dk · Bekletme 2 Saat buzdolabında soğutma",
    "ingredients": [
      "2 olgun mango",
      "150 ml krema",
      "250 gr yoğurt",
      "30 gr pudra şekeri",
      "225 gr Freya Gurme Çarkıfelek Sosu",
      "100 gr file badem kavrulmuş"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 olgun mango",
          "150 ml krema",
          "250 gr yoğurt",
          "30 gr pudra şekeri",
          "225 gr Freya Gurme Çarkıfelek Sosu",
          "100 gr file badem kavrulmuş"
        ]
      }
    ],
    "steps": [
      "Mangoları küp küp doğrayın ve bir kenara alınız",
      "Krema ve pudra şekerini bir kasede karıştırınız",
      "Yoğurdu ilave edip karıştırmaya devam ediniz",
      "Çarkıfelek sosunu yoğurt karışımına koyunuz",
      "Cam kaselerin içine önce karışımı sonra mangoyu ilave ediniz",
      "Buzdolabında yaklaşık 2 saat soğutunuz",
      "Üzerine kavrulmuş file bademleriyle servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Mangoları küp küp doğrayın ve bir kenara alınız",
          "Krema ve pudra şekerini bir kasede karıştırınız",
          "Yoğurdu ilave edip karıştırmaya devam ediniz",
          "Çarkıfelek sosunu yoğurt karışımına koyunuz",
          "Cam kaselerin içine önce karışımı sonra mangoyu ilave ediniz",
          "Buzdolabında yaklaşık 2 saat soğutunuz",
          "Üzerine kavrulmuş file bademleriyle servis ediniz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/fool-mango-ve-carkifelek",
    "sourceId": "gid://shopify/Article/605705765148",
    "aliases": [
      "fool-mango-ve-carkifelek"
    ]
  },
  {
    "slug": "carkifelekli-ton-balikli-sandvic",
    "title": "Çarkıfelek Ton Balıklı Sandviç",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_ton_sandvic.jpg?v=1712566111",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "10 dakika"
      ]
    ],
    "time": "Hazırlama 10 dakika",
    "ingredients": [
      "Bagel , arzu ettiğiniz herhangi bir ekmek olabilir",
      "Yeşillik, arzu ettiğiniz herhangi bir yeşillik",
      "1 salatalık, ince kesim",
      "5 gr jalepeno dilim turşu",
      "50 gr ton balığı",
      "30 gr Freya Gurme Çarkıfelek Sos"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Bagel , arzu ettiğiniz herhangi bir ekmek olabilir",
          "Yeşillik, arzu ettiğiniz herhangi bir yeşillik",
          "1 salatalık, ince kesim",
          "5 gr jalepeno dilim turşu",
          "50 gr ton balığı",
          "30 gr Freya Gurme Çarkıfelek Sos"
        ]
      }
    ],
    "steps": [
      "Bir kasenin içerisinde çarkıfelek sosunuzu ve ton balığını karıştırınız",
      "Bagelin içerisine salatalıkları, dilim turşuyu, ton balığını ve yeşillikleri koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Bir kasenin içerisinde çarkıfelek sosunuzu ve ton balığını karıştırınız",
          "Bagelin içerisine salatalıkları, dilim turşuyu, ton balığını ve yeşillikleri koyunuz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelekli-ton-balikli-sandvic",
    "sourceId": "gid://shopify/Article/605705797916",
    "aliases": [
      "carkifelekli-ton-balikli-sandvic"
    ]
  },
  {
    "slug": "carkifelekli-karidesli-pad-thai",
    "title": "Çarkıfelek Karidesli Pad Thai",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_pad_thai.jpg?v=1712565267",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "6 kişilik",
    "times": [
      [
        "Hazırlama",
        "25 dakika"
      ],
      [
        "Pişirme",
        "20 dakika"
      ]
    ],
    "time": "Hazırlama 25 dakika · Pişirme 20 dakika",
    "ingredients": [
      "400 gr pirinç makarnası",
      "200 gr Freya Gurme Çarkıfelek sos",
      "300 gr karides",
      "4 diş sarımsak",
      "4 adet kırmızı biber",
      "4 adet kuru acı biber",
      "20 ml zeytinyağ",
      "2 gr tuz",
      "2 gr kara biber",
      "5 gr frenk soğanı",
      "10 ml lime suyu"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "400 gr pirinç makarnası",
          "200 gr Freya Gurme Çarkıfelek sos",
          "300 gr karides",
          "4 diş sarımsak",
          "4 adet kırmızı biber",
          "4 adet kuru acı biber",
          "20 ml zeytinyağ",
          "2 gr tuz",
          "2 gr kara biber",
          "5 gr frenk soğanı",
          "10 ml lime suyu"
        ]
      }
    ],
    "steps": [
      "Pirinç makarnanızı 12-14 dakika kadar haşlayınız",
      "Wok tencerenize zeytinyağ koyup ince kıyılmış sarımsakları ilave ediniz ve sotelemeye başlayınız",
      "İnce doğranmış taze ve kuru biberleri ekleyip karideslerinizi koyunuz ve sotelemeye devam ediniz",
      "Sos kalıbına çarkıfelek sosunu, lime suyunu, tuz ve karabiberi ekleyip karıştırınız ve bir kenara alınız",
      "Haşlanmış Pirinç makarnasını süzerek wok tavaya koyunuz",
      "Sosu ilave ediniz",
      "2-3 dakika kısık ateşte pişiriniz",
      "Servis tabağına koyunuz ve ince kesdiğiniz soğanları ekleyerek servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Pirinç makarnanızı 12-14 dakika kadar haşlayınız",
          "Wok tencerenize zeytinyağ koyup ince kıyılmış sarımsakları ilave ediniz ve sotelemeye başlayınız",
          "İnce doğranmış taze ve kuru biberleri ekleyip karideslerinizi koyunuz ve sotelemeye devam ediniz",
          "Sos kalıbına çarkıfelek sosunu, lime suyunu, tuz ve karabiberi ekleyip karıştırınız ve bir kenara alınız",
          "Haşlanmış Pirinç makarnasını süzerek wok tavaya koyunuz",
          "Sosu ilave ediniz",
          "2-3 dakika kısık ateşte pişiriniz",
          "Servis tabağına koyunuz ve ince kesdiğiniz soğanları ekleyerek servis ediniz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelekli-karidesli-pad-thai",
    "sourceId": "gid://shopify/Article/605705830684",
    "aliases": [
      "carkifelekli-karidesli-pad-thai"
    ]
  },
  {
    "slug": "carkifelek-catni",
    "title": "Çarkıfelek Çatni",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/CARKIFELEK_Catni.jpg?v=1712566706",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "4 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "45 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 45 dk",
    "ingredients": [
      "200 gr Freya Gurme Çarkıfelek Sos",
      "1 adet kırmızı orta boy soğan",
      "3 diş sarımsak, dövülmüş",
      "2 adet jalepeno biber",
      "2 adet misket limon suyu",
      "40 ml zeytinyağ",
      "35 gr hindistan cevizi şekeri",
      "5 gr nane",
      "2 gr acı kırmızı toz biber",
      "2 gr tuz",
      "2 gr karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr Freya Gurme Çarkıfelek Sos",
          "1 adet kırmızı orta boy soğan",
          "3 diş sarımsak, dövülmüş",
          "2 adet jalepeno biber",
          "2 adet misket limon suyu",
          "40 ml zeytinyağ",
          "35 gr hindistan cevizi şekeri",
          "5 gr nane",
          "2 gr acı kırmızı toz biber",
          "2 gr tuz",
          "2 gr karabiber"
        ]
      }
    ],
    "steps": [
      "Tavanın içerisine zeytinyağı koyunuz ve sırasıyla ince doğranmış soğanı, biberleri ve sarımsakları yaklaşık 25-30 dk soteleyiniz",
      "Bir kasenin içine çarkıfelek sosunu, limon suyunu ve şekeri ilave edip karıştırınız",
      "Soğan karışımının altını kısınız ve sosu yavaş yavaş ilave ediniz",
      "Kıvam alıncaya kadar karıştırmaya devam ediniz",
      "Ocaktan aldıktan sonra servis tabağına alınız ve nanelerle süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tavanın içerisine zeytinyağı koyunuz ve sırasıyla ince doğranmış soğanı, biberleri ve sarımsakları yaklaşık 25-30 dk soteleyiniz",
          "Bir kasenin içine çarkıfelek sosunu, limon suyunu ve şekeri ilave edip karıştırınız",
          "Soğan karışımının altını kısınız ve sosu yavaş yavaş ilave ediniz",
          "Kıvam alıncaya kadar karıştırmaya devam ediniz",
          "Ocaktan aldıktan sonra servis tabağına alınız ve nanelerle süsleyiniz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelek-catni",
    "sourceId": "gid://shopify/Article/605705863452",
    "aliases": [
      "carkifelek-catni"
    ]
  },
  {
    "slug": "cilek-jalepenolu-beef-wellington",
    "title": "Çilek Jalepeno Beef Wellington",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/CILEK_JALEPENO_BEEF_WELLINGTON.jpg?v=1712566992",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "8 kişilik",
    "times": [
      [
        "Hazırlama",
        "40 dk"
      ],
      [
        "Dinlendirme",
        "30 dk"
      ],
      [
        "Pişirme",
        "50 dk"
      ]
    ],
    "time": "Hazırlama 40 dk · Dinlendirme 30 dk",
    "ingredients": [
      "1 yumurta",
      "25 gr toz şeker",
      "100 ml süt",
      "100 ml su",
      "5 gr zeytinyağ",
      "50 gr eritilmiş sade yağ",
      "50 gr zeytinyağ",
      "100 ml süt",
      "100 ml su",
      "1 yumurta",
      "25 gr tuz",
      "25 gr Freya Gurme hindistan cevizi şekeri",
      "5 gr kabartma tozu",
      "300 gr un",
      "500 gr mantar",
      "3 diş sarımsak",
      "1 adet soğan",
      "50 gr tereyağ",
      "1 gr tuz",
      "1 gr karabiber",
      "600 gr tüm bonfile",
      "200 gr Freya Gurme Çilek Jalapeno Sos",
      "5 gr tuz",
      "5 gr karabiber",
      "15 gr sade yağ",
      "1 çırpılmış yumurta",
      "5 gr eritilmiş tereyağ"
    ],
    "ingredientGroups": [
      {
        "title": "Krep için",
        "items": [
          "1 yumurta",
          "25 gr toz şeker",
          "100 ml süt",
          "100 ml su",
          "5 gr zeytinyağ"
        ]
      },
      {
        "title": "Hamur için",
        "items": [
          "50 gr eritilmiş sade yağ",
          "50 gr zeytinyağ",
          "100 ml süt",
          "100 ml su",
          "1 yumurta",
          "25 gr tuz",
          "25 gr Freya Gurme hindistan cevizi şekeri",
          "5 gr kabartma tozu",
          "300 gr un"
        ]
      },
      {
        "title": "Etin iç harcı için",
        "items": [
          "500 gr mantar",
          "3 diş sarımsak",
          "1 adet soğan",
          "50 gr tereyağ",
          "1 gr tuz",
          "1 gr karabiber",
          "600 gr tüm bonfile",
          "200 gr Freya Gurme Çilek Jalapeno Sos",
          "5 gr tuz",
          "5 gr karabiber",
          "15 gr sade yağ"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "1 çırpılmış yumurta",
          "5 gr eritilmiş tereyağ"
        ]
      }
    ],
    "steps": [
      "Sade yağ ve zeytinyağı bir tavanın içerisinde eritiniz",
      "Bir kabın içerisine yumurtayı kırınız, süt ve suyu ilave edip karıştırınız",
      "Erittiğiniz yağı ilave ediniz",
      "Tuz, şeker ve unu ilave ederek yavaş yavaş karıştırınız",
      "Kıvam alınca streç filme sarıp 30 dakika buzdolabında dinlendiriniz",
      "Şeker ve yumurtayı bir kabın içerisinde iyice karıştırınız",
      "Süt, su ve unu ilave ederek karıştırmaya devam ediniz",
      "Krep tavanızı ısıtınız ve zeytinyağ sürünüz",
      "Kreplerinizi pişirin ve bir kenara soğumaya bırakınız",
      "Tavanın içerisine tereyağ ve zeytinyağ koyunuz ve ısıtınız",
      "Yemeklik doğranmış soğanları ve sarımsakları koyunuz ve kavurunuz",
      "İnce doğranmış mantarları ilave ediniz",
      "Karabiber ve tuzunu ekleyip altını kapatınız",
      "Bonfilenizi mühürleyin",
      "Mühürlediğiniz etin üzerine karabiber ve tuz serpin",
      "Bir tavanın içerisinde tereyağ eritiniz, etinizi koyup, yağda çeviriniz",
      "Bir tabağa alınız ve freya gurme çilek jalapeno sosunu tüm bonfilenize sürünüz",
      "Dinlendirdiğiniz hamurunuzu yağlı kağıdın boyutunda merdane ile açınız",
      "Streç filmin üzerine kreplerinizi yerleştiriniz",
      "Üzerine iç harcı ilave ediniz ve etinizi koyunuz",
      "Streç film yardımıyla rulo haline getiriniz",
      "Açtığınız hamurun ortasına yerleştiriniz",
      "Tekrar rulo yapınız",
      "Fazla gelen hamurunuzu kesip, çatal yardımıyla kapatınız",
      "Üzerine yumurta ve eritilmiş tereyağ sürünüz",
      "Önceden ısıtılmış 200c fırında pişiriniz"
    ],
    "stepGroups": [
      {
        "title": "Hamur",
        "items": [
          "Sade yağ ve zeytinyağı bir tavanın içerisinde eritiniz",
          "Bir kabın içerisine yumurtayı kırınız, süt ve suyu ilave edip karıştırınız",
          "Erittiğiniz yağı ilave ediniz",
          "Tuz, şeker ve unu ilave ederek yavaş yavaş karıştırınız",
          "Kıvam alınca streç filme sarıp 30 dakika buzdolabında dinlendiriniz"
        ]
      },
      {
        "title": "Krep",
        "items": [
          "Şeker ve yumurtayı bir kabın içerisinde iyice karıştırınız",
          "Süt, su ve unu ilave ederek karıştırmaya devam ediniz",
          "Krep tavanızı ısıtınız ve zeytinyağ sürünüz",
          "Kreplerinizi pişirin ve bir kenara soğumaya bırakınız"
        ]
      },
      {
        "title": "İç harç",
        "items": [
          "Tavanın içerisine tereyağ ve zeytinyağ koyunuz ve ısıtınız",
          "Yemeklik doğranmış soğanları ve sarımsakları koyunuz ve kavurunuz",
          "İnce doğranmış mantarları ilave ediniz",
          "Karabiber ve tuzunu ekleyip altını kapatınız"
        ]
      },
      {
        "title": "Bonfile",
        "items": [
          "Bonfilenizi mühürleyin",
          "Mühürlediğiniz etin üzerine karabiber ve tuz serpin",
          "Bir tavanın içerisinde tereyağ eritiniz, etinizi koyup, yağda çeviriniz",
          "Bir tabağa alınız ve freya gurme çilek jalapeno sosunu tüm bonfilenize sürünüz",
          "Dinlendirdiğiniz hamurunuzu yağlı kağıdın boyutunda merdane ile açınız",
          "Streç filmin üzerine kreplerinizi yerleştiriniz",
          "Üzerine iç harcı ilave ediniz ve etinizi koyunuz",
          "Streç film yardımıyla rulo haline getiriniz",
          "Açtığınız hamurun ortasına yerleştiriniz",
          "Tekrar rulo yapınız",
          "Fazla gelen hamurunuzu kesip, çatal yardımıyla kapatınız",
          "Üzerine yumurta ve eritilmiş tereyağ sürünüz",
          "Önceden ısıtılmış 200c fırında pişiriniz"
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepenolu-beef-wellington",
    "sourceId": "gid://shopify/Article/605705896220",
    "aliases": [
      "cilek-jalepenolu-beef-wellington"
    ]
  },
  {
    "slug": "cilek-jalepenolu-kizarmis-peynir",
    "title": "Çilek Jalepeno Kızarmış Peynir",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/CILEK_JALEPENOLU_KIZARMIS_PEYNIR.jpg?v=1712567311",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "6 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "20 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 20 dk",
    "ingredients": [
      "300 gr parmesan peyniri",
      "150 gr panko",
      "60 gr un",
      "1 yumurta, çırpılmış",
      "100 gr panko",
      "15 ml zeytinyağ",
      "200 ml kızartma yağı",
      "2 gr kırmızı biber",
      "2 gr kuru biberiye",
      "150 ml Freya Gurme Çilek Jalepeno sos"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "300 gr parmesan peyniri",
          "150 gr panko",
          "60 gr un",
          "1 yumurta, çırpılmış",
          "100 gr panko",
          "15 ml zeytinyağ",
          "200 ml kızartma yağı",
          "2 gr kırmızı biber",
          "2 gr kuru biberiye",
          "150 ml Freya Gurme Çilek Jalepeno sos"
        ]
      }
    ],
    "steps": [
      "Parmesan peyniri küp küp kesiniz",
      "Baharatları ve zeytinyağı koyunuz ve karıştırınız",
      "3 ayrı kaseye yumurta, panko ve un koyunuz",
      "İlk önce yumurtaya ardından una ve en son pankoya batırınız",
      "Kızgın yağda kızartınız",
      "Servis tabağına alınız ve Çilek sosunuzla servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Parmesan peyniri küp küp kesiniz",
          "Baharatları ve zeytinyağı koyunuz ve karıştırınız",
          "3 ayrı kaseye yumurta, panko ve un koyunuz",
          "İlk önce yumurtaya ardından una ve en son pankoya batırınız",
          "Kızgın yağda kızartınız",
          "Servis tabağına alınız ve Çilek sosunuzla servis ediniz"
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepenolu-kizarmis-peynir",
    "sourceId": "gid://shopify/Article/605705928988",
    "aliases": [
      "cilek-jalepenolu-kizarmis-peynir"
    ]
  },
  {
    "slug": "cilek-jalepenolu-et-sis",
    "title": "Çilek Jalepeno Et Şiş",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/CILEK_JALEPENO_ET_SIS.jpg?v=1712566945",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ],
      [
        "Dinlendirme",
        "2 saat"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 30 dk",
    "ingredients": [
      "1 kg dana bonfile",
      "80 ml zeytinyağ",
      "4 sarımsak dövülmüş",
      "10 gr kimyon",
      "10 gr karabiber",
      "2 adet kuru acı biber",
      "20 gr maydanoz, doğranmış",
      "10 gr nane, doğranmış",
      "1 adet jalepeno, ince doğranmış",
      "200 gr Freya Gurme Çilek Jalepeno Sos"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 kg dana bonfile",
          "80 ml zeytinyağ",
          "4 sarımsak dövülmüş",
          "10 gr kimyon",
          "10 gr karabiber",
          "2 adet kuru acı biber",
          "20 gr maydanoz, doğranmış",
          "10 gr nane, doğranmış",
          "1 adet jalepeno, ince doğranmış",
          "200 gr Freya Gurme Çilek Jalepeno Sos"
        ]
      }
    ],
    "steps": [
      "Büyük bir kabın içerisine tüm malzemeleri koyunuz ve karıştırınız",
      "Etlerinizi orta büyüklükte küp şeklinde kesiniz ve karışıma ilave ediniz",
      "Buzdolabında 2 saat kadar bekletiniz",
      "Izgaranızı çok sıcak derecede ısıtınız",
      "Etlerinizi şişlere takınız ve istediğiniz kıvama göre pişiriniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Büyük bir kabın içerisine tüm malzemeleri koyunuz ve karıştırınız",
          "Etlerinizi orta büyüklükte küp şeklinde kesiniz ve karışıma ilave ediniz",
          "Buzdolabında 2 saat kadar bekletiniz",
          "Izgaranızı çok sıcak derecede ısıtınız",
          "Etlerinizi şişlere takınız ve istediğiniz kıvama göre pişiriniz"
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepenolu-et-sis",
    "sourceId": "gid://shopify/Article/605705961756",
    "aliases": [
      "cilek-jalepenolu-et-sis"
    ]
  },
  {
    "slug": "maviyemis-ve-lavantali-biskuvi",
    "title": "Maviyemiş Lavanta Bisküvi",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Maviyemis_Lavanta_biskuvi.jpg?v=1712646836",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "8 kişilik",
    "times": [
      [
        "Hazırlama",
        "25 dk"
      ],
      [
        "Pişirme",
        "45 dk"
      ]
    ],
    "time": "Hazırlama 25 dk · Pişirme 45 dk",
    "ingredients": [
      "450 gr un",
      "170 ml süt",
      "125 gr yağ oda derecesinde",
      "50 gr hindistan cevizi şekeri",
      "5 gr çay kaşığı kabartma tozu",
      "1 limon rendesi",
      "2 gr tuz",
      "1 çay kaşığı vanilya özütü",
      "150 gr Freya Gurme Maviyemiş Lavanta Sos",
      "15 ml limon suyu"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "450 gr un",
          "170 ml süt",
          "125 gr yağ oda derecesinde",
          "50 gr hindistan cevizi şekeri",
          "5 gr çay kaşığı kabartma tozu",
          "1 limon rendesi",
          "2 gr tuz",
          "1 çay kaşığı vanilya özütü",
          "150 gr Freya Gurme Maviyemiş Lavanta Sos",
          "15 ml limon suyu"
        ]
      }
    ],
    "steps": [
      "Fırını 200 c ısıtınız",
      "Süt ve limon suyu hariç tüm malzemeleri koyup 10-15 dakika karıştırınız",
      "Süt ve limon suyunu ekleyiniz",
      "Hamur kıvamına getiriniz",
      "Hamuru fırın kaplarına koyunuz",
      "45 dakika pişiriniz",
      "Fırından çıkarınız ve ılımaya bırakınız",
      "Ortasından kesip eşit miktarda sosunuzu sürerek servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 200 c ısıtınız",
          "Süt ve limon suyu hariç tüm malzemeleri koyup 10-15 dakika karıştırınız",
          "Süt ve limon suyunu ekleyiniz",
          "Hamur kıvamına getiriniz",
          "Hamuru fırın kaplarına koyunuz",
          "45 dakika pişiriniz",
          "Fırından çıkarınız ve ılımaya bırakınız",
          "Ortasından kesip eşit miktarda sosunuzu sürerek servis ediniz"
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemis-ve-lavantali-biskuvi",
    "sourceId": "gid://shopify/Article/605706027292",
    "aliases": [
      "maviyemis-ve-lavantali-biskuvi"
    ]
  },
  {
    "slug": "maviyemisli-vegan-kek",
    "title": "Maviyemiş Lavanta Vegan Kek",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/MAVIYEMIS_Lavanta_vegan_cake.jpg?v=1712567789",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "6 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Pişirme",
        "20 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Pişirme 20 dk",
    "ingredients": [
      "170 gr badem unu",
      "100 gr hindistan cevizi şekeri",
      "5 gr kabartma tozu",
      "2 gr karbonat",
      "75 gr vegan yağ",
      "200 gr pisilyum",
      "300 gr yulaf unu",
      "200 ml sıcak su",
      "200 gr Freya Gurme Maviyemiş Lavanta sosu"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "170 gr badem unu",
          "100 gr hindistan cevizi şekeri",
          "5 gr kabartma tozu",
          "2 gr karbonat",
          "75 gr vegan yağ",
          "200 gr pisilyum",
          "300 gr yulaf unu",
          "200 ml sıcak su",
          "200 gr Freya Gurme Maviyemiş Lavanta sosu"
        ]
      }
    ],
    "steps": [
      "Derin bir kabın içerisine maviyemiş sos hariç tüm malzemeleri koyunuz.",
      "homojen kıvama gelinceye kadar el mikserinde çırpınız.",
      "Önceden ısıttığınız 170c fırında 20 dakika pişiriniz .",
      "Soğumaya bırakınız.",
      "Freya Gurme sosunuzu ekleyip taze maviyemişlerle süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Derin bir kabın içerisine maviyemiş sos hariç tüm malzemeleri koyunuz.",
          "homojen kıvama gelinceye kadar el mikserinde çırpınız.",
          "Önceden ısıttığınız 170c fırında 20 dakika pişiriniz .",
          "Soğumaya bırakınız.",
          "Freya Gurme sosunuzu ekleyip taze maviyemişlerle süsleyiniz."
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemisli-vegan-kek",
    "sourceId": "gid://shopify/Article/605706060060",
    "aliases": [
      "maviyemisli-vegan-kek"
    ]
  },
  {
    "slug": "maviyemis-clafoutis",
    "title": "Maviyemiş Lavanta Clafoutis",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/MAVIYEMIS_LAVANTA_CLAFOUTIS_93370418-134f-44dc-b8f3-ee0169c0b8ec.jpg?v=1756962418",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 30 dk",
    "ingredients": [
      "80 gr un",
      "80 gr hindistan cevizi şekeri",
      "200 gr Freya Gurme Maviyemiş Lavanta sos",
      "30 gr sadeyağ, erimiş ve soğumuş",
      "2 yumurta",
      "10 gr şekerli vanilin",
      "130 ml süt",
      "130 gr krema",
      "1 limon kabuğu rendesi",
      "Vanilyalı dondurma, isteğe bağlı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "80 gr un",
          "80 gr hindistan cevizi şekeri",
          "200 gr Freya Gurme Maviyemiş Lavanta sos",
          "30 gr sadeyağ, erimiş ve soğumuş",
          "2 yumurta",
          "10 gr şekerli vanilin",
          "130 ml süt",
          "130 gr krema",
          "1 limon kabuğu rendesi",
          "Vanilyalı dondurma, isteğe bağlı"
        ]
      }
    ],
    "steps": [
      "Fırını 190c ısıtınız",
      "Büyük bir kabın içerisinde şeker ve yumurtaları el çırpıcısıyla çırpınız",
      "Şekerli vanilin, krema ve sütü ilave edip karıştırmaya devam ediniz",
      "Yağ ve unu ilave ediniz",
      "Fırın kabına karışımı koyunuz ve üzerine Maviyemiş Lavanta sosunu ekleyiniz ve limon kabuğunu rendeleyiniz ve fırına veriniz",
      "30 dakika pişiriniz",
      "Fırından alınız ve ılık servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 190c ısıtınız",
          "Büyük bir kabın içerisinde şeker ve yumurtaları el çırpıcısıyla çırpınız",
          "Şekerli vanilin, krema ve sütü ilave edip karıştırmaya devam ediniz",
          "Yağ ve unu ilave ediniz",
          "Fırın kabına karışımı koyunuz ve üzerine Maviyemiş Lavanta sosunu ekleyiniz ve limon kabuğunu rendeleyiniz ve fırına veriniz",
          "30 dakika pişiriniz",
          "Fırından alınız ve ılık servis ediniz"
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemis-clafoutis",
    "sourceId": "gid://shopify/Article/605706125596",
    "aliases": [
      "maviyemis-clafoutis"
    ]
  },
  {
    "slug": "maviyemis-cobbler",
    "title": "Maviyemiş Lavanta Cobbler",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/maviyemis_lavanta_cobbler.jpg?v=1712567365",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dakika"
      ],
      [
        "Pişirme",
        "30 dakika"
      ]
    ],
    "time": "Hazırlama 15 dakika · Pişirme 30 dakika",
    "ingredients": [
      "500 gr Freya Gurme Maviyemiş Lavanta sos",
      "200 gr un",
      "50 gr hindistan cevizi şekeri",
      "10 gr kabartma tozu",
      "95 gr yağ, oda sıcaklığında",
      "200 ml krema",
      "2 gr tuz",
      "Vanilyalı dondurma, isteğe bağlı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "500 gr Freya Gurme Maviyemiş Lavanta sos",
          "200 gr un",
          "50 gr hindistan cevizi şekeri",
          "10 gr kabartma tozu",
          "95 gr yağ, oda sıcaklığında",
          "200 ml krema",
          "2 gr tuz",
          "Vanilyalı dondurma, isteğe bağlı"
        ]
      }
    ],
    "steps": [
      "Fırını 190c ayarlayınız",
      "Büyük bir kasenin içerisine un, tuz, kabartma tozu ve şekeri koyunuz ve karıştırınız",
      "Yağ ekleyiniz ve küçük kırıntılar kıvamına gelecek şekilde yoğurunuz",
      "Kremayı ekleyiniz ve karıştırınız",
      "Fırın kabına Maviyemiş Lavanta sosunu koyunuz",
      "Üzerine hazırladığınız hamuru eşit biçimde bölerek koyunuz",
      "Fırında 30 dakika pişiriniz",
      "Ilk servis ediniz, arzuya göre dondurma koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 190c ayarlayınız",
          "Büyük bir kasenin içerisine un, tuz, kabartma tozu ve şekeri koyunuz ve karıştırınız",
          "Yağ ekleyiniz ve küçük kırıntılar kıvamına gelecek şekilde yoğurunuz",
          "Kremayı ekleyiniz ve karıştırınız",
          "Fırın kabına Maviyemiş Lavanta sosunu koyunuz",
          "Üzerine hazırladığınız hamuru eşit biçimde bölerek koyunuz",
          "Fırında 30 dakika pişiriniz",
          "Ilk servis ediniz, arzuya göre dondurma koyunuz"
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemis-cobbler",
    "sourceId": "gid://shopify/Article/605706158364",
    "aliases": [
      "maviyemis-cobbler"
    ]
  },
  {
    "slug": "visneli-balli-mahmudiye",
    "title": "Vişne Işkın Ballı Mahmudiye",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_MAHMUDIYE.jpg?v=1712566458",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "4 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "50 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 50 dk",
    "ingredients": [
      "500 gr tavuk göğsü sote",
      "500 gr tavuk but sote (kemiksiz)",
      "3 orta boy soğan",
      "50 gr sultani üzüm",
      "50 gr kuş üzümü",
      "100 gr badem içi",
      "100 gr tereyağ",
      "25 gr taze kekik",
      "5 gr tuz",
      "8 gr karabiber",
      "10 gr tarçın",
      "40 gr bal",
      "150 gr Freya Gurme Vişne Işkın Sos"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "500 gr tavuk göğsü sote",
          "500 gr tavuk but sote (kemiksiz)",
          "3 orta boy soğan",
          "50 gr sultani üzüm",
          "50 gr kuş üzümü",
          "100 gr badem içi",
          "100 gr tereyağ",
          "25 gr taze kekik",
          "5 gr tuz",
          "8 gr karabiber",
          "10 gr tarçın",
          "40 gr bal",
          "150 gr Freya Gurme Vişne Işkın Sos"
        ]
      }
    ],
    "steps": [
      "Bir tencerede kaynayan suyun içerisine sote tavukları ve 1 soğanı",
      "(kabukları soyulmuş) yaklaşık 15 dakika kaynatınız",
      "Suyunu süzünüz ve bir tarafa alınız",
      "Tereyağını eritiniz tavuklarınızı koyunuz ve kavurmaya başlayınız",
      "2 orta boy piyazlık doğranmış soğanınızı ekleyiniz ve yaklaşık 25 dakika daha kavurunuz",
      "Bademlerinizi ilave edip kavurmaya devam ediniz",
      "Tuz ve karabiberi ekleyiniz",
      "Suda ıslatılan üzümleri süzünüz ve içine ilave ediniz",
      "Tarçın ekleyiniz ve sotelemeye devam ediniz",
      "Ayırdığınız 50 ml tavuk suyunu koyunuz ve kısık ateşte suyunu çekene kadar pişiriniz",
      "Suyunu çektikten sonra altını kapatınız.",
      "bal ve Vişne Işkın sosunuzu ekleyiniz, hızlıca karıştırınız",
      "Taze kekik ile süsleyerek servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Bir tencerede kaynayan suyun içerisine sote tavukları ve 1 soğanı",
          "(kabukları soyulmuş) yaklaşık 15 dakika kaynatınız",
          "Suyunu süzünüz ve bir tarafa alınız",
          "Tereyağını eritiniz tavuklarınızı koyunuz ve kavurmaya başlayınız",
          "2 orta boy piyazlık doğranmış soğanınızı ekleyiniz ve yaklaşık 25 dakika daha kavurunuz",
          "Bademlerinizi ilave edip kavurmaya devam ediniz",
          "Tuz ve karabiberi ekleyiniz",
          "Suda ıslatılan üzümleri süzünüz ve içine ilave ediniz",
          "Tarçın ekleyiniz ve sotelemeye devam ediniz",
          "Ayırdığınız 50 ml tavuk suyunu koyunuz ve kısık ateşte suyunu çekene kadar pişiriniz",
          "Suyunu çektikten sonra altını kapatınız.",
          "bal ve Vişne Işkın sosunuzu ekleyiniz, hızlıca karıştırınız",
          "Taze kekik ile süsleyerek servis ediniz."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visneli-balli-mahmudiye",
    "sourceId": "gid://shopify/Article/605706191132",
    "aliases": [
      "visneli-balli-mahmudiye"
    ]
  },
  {
    "slug": "visne-iskinli-armut",
    "title": "Vişne Işkın Armut",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_ARMUT.jpg?v=1712566824",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "8 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 25 dk",
    "ingredients": [
      "4 orta boy armut",
      "200 gr rokfor peynir",
      "150 gr Freya Vişne Işkın Otu Sosu",
      "100 gr ayıklanmış ceviz",
      "Süslemek için; bal"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "4 orta boy armut",
          "200 gr rokfor peynir",
          "150 gr Freya Vişne Işkın Otu Sosu",
          "100 gr ayıklanmış ceviz",
          "Süslemek için; bal"
        ]
      }
    ],
    "steps": [
      "Fırını 180 c önceden ısıtınız.",
      "Armutların çekirdek kısmını kaşık yardımıyla çıkarınız.",
      "Bir kabın içerisine küçük parçalara ayırdığınız peyniri,",
      "Vişne Işkın sosunuzu ve küçük parçalara ayırdığınız cevizleri koyup karıştırınız",
      "Fırın kabına armutları diziniz ve peynir karışımını ortasına koyunuz.",
      "Fırında 25 dakika kadar pişiriniz.",
      "Tabaklara balla süsleyerek servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 180 c önceden ısıtınız.",
          "Armutların çekirdek kısmını kaşık yardımıyla çıkarınız.",
          "Bir kabın içerisine küçük parçalara ayırdığınız peyniri,",
          "Vişne Işkın sosunuzu ve küçük parçalara ayırdığınız cevizleri koyup karıştırınız",
          "Fırın kabına armutları diziniz ve peynir karışımını ortasına koyunuz.",
          "Fırında 25 dakika kadar pişiriniz.",
          "Tabaklara balla süsleyerek servis ediniz."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskinli-armut",
    "sourceId": "gid://shopify/Article/605706223900",
    "aliases": [
      "visne-iskinli-armut"
    ]
  },
  {
    "slug": "visne-iskinli-galette",
    "title": "Vişne Işkın Galette",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_GALETTA.jpg?v=1712567465",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "6 kişilik",
    "times": [
      [
        "Hazırlama",
        "50 dakika"
      ],
      [
        "Dinlendirme",
        "25 dakika"
      ],
      [
        "Pişirme",
        "35 dakika"
      ]
    ],
    "time": "Hazırlama 50 dakika · Dinlendirme 25 dakika",
    "ingredients": [
      "225 gr un",
      "25 gr hindistan cevizi şeker",
      "200 gr tuzsuz yağ oda sıcaklığında",
      "250 gr krem peynir",
      "30 gr hindistan cevizi şekeri",
      "125 gr Freya Gurme Vişne Işkın Sos",
      "20 gr kavrulmuş badem",
      "1 yumurta sarısı",
      "Yeterince buzlu su",
      "Vanilyalı dondurma, arzuya göre"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "225 gr un",
          "25 gr hindistan cevizi şeker",
          "200 gr tuzsuz yağ oda sıcaklığında",
          "250 gr krem peynir",
          "30 gr hindistan cevizi şekeri",
          "125 gr Freya Gurme Vişne Işkın Sos",
          "20 gr kavrulmuş badem",
          "1 yumurta sarısı",
          "Yeterince buzlu su",
          "Vanilyalı dondurma, arzuya göre"
        ]
      }
    ],
    "steps": [
      "Unu eleyiniz ve şeker ile geniş bir kabın içerisine koyup iyice karıştırınız",
      "Yağı, tuzu ve suyu ekleyip yoğurunuz",
      "Hamur kıvamına getiriniz",
      "Krem peyniri ilave ediniz",
      "Çatal yardımıyla yumuşayıncaya kadar karıştırınız",
      "Streç filme sarıp 25 dakika dinlendiriniz",
      "Fırını 210c ısıtınız",
      "Unladığınız tezgahta hamurunuzu 28 cm genişliğinde açınız",
      "Fırın kağıdının üzerine koyunuz",
      "Başka bir kapta freya vişne ışkın sosu ve bademleri karıştırıp hamurun içerisine kenarları 5 cm boşluk kalacak şekilde koyunuz",
      "Kenarlarını kapatınız ve yumurta sarısını sürünüz",
      "Yaklaşık 30-35 dakika pişiriniz",
      "Galetinizi çıkarıp arzuya göre dondurma ile servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Unu eleyiniz ve şeker ile geniş bir kabın içerisine koyup iyice karıştırınız",
          "Yağı, tuzu ve suyu ekleyip yoğurunuz",
          "Hamur kıvamına getiriniz",
          "Krem peyniri ilave ediniz",
          "Çatal yardımıyla yumuşayıncaya kadar karıştırınız",
          "Streç filme sarıp 25 dakika dinlendiriniz",
          "Fırını 210c ısıtınız",
          "Unladığınız tezgahta hamurunuzu 28 cm genişliğinde açınız",
          "Fırın kağıdının üzerine koyunuz",
          "Başka bir kapta freya vişne ışkın sosu ve bademleri karıştırıp hamurun içerisine kenarları 5 cm boşluk kalacak şekilde koyunuz",
          "Kenarlarını kapatınız ve yumurta sarısını sürünüz",
          "Yaklaşık 30-35 dakika pişiriniz",
          "Galetinizi çıkarıp arzuya göre dondurma ile servis ediniz"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskinli-galette",
    "sourceId": "gid://shopify/Article/605706256668",
    "aliases": [
      "visne-iskinli-galette"
    ]
  },
  {
    "slug": "visne-iskinli-tavuklu-sandvic",
    "title": "Vişne Işkın Tavuklu Sandviç",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_TAVUKLU_SANDVIC.jpg?v=1712567234",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "15 dakika"
      ]
    ],
    "time": "Hazırlama 15 dakika",
    "ingredients": [
      "2 dilim herhangi bir ekmek",
      "10 gr brüksel lahanası",
      "2 adet pırasa",
      "15 gr haşlanmış, ayıklanmış tavuk",
      "50 gr Freya Gurme Vişne Işkın Sos",
      "Yeterince tuz, karabiber",
      "15 ml zeytinyağ"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 dilim herhangi bir ekmek",
          "10 gr brüksel lahanası",
          "2 adet pırasa",
          "15 gr haşlanmış, ayıklanmış tavuk",
          "50 gr Freya Gurme Vişne Işkın Sos",
          "Yeterince tuz, karabiber",
          "15 ml zeytinyağ"
        ]
      }
    ],
    "steps": [
      "Tavanın içerisine sebzeleri soteleyiniz",
      "Tavukları içerisine koyunuz, tuz ve karabiber ekleyiniz",
      "Ekmeğinize vişne sosunuzu sürünüz",
      "Harcınızı koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tavanın içerisine sebzeleri soteleyiniz",
          "Tavukları içerisine koyunuz, tuz ve karabiber ekleyiniz",
          "Ekmeğinize vişne sosunuzu sürünüz",
          "Harcınızı koyunuz"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskinli-tavuklu-sandvic",
    "sourceId": "gid://shopify/Article/605706289436",
    "aliases": [
      "visne-iskinli-tavuklu-sandvic"
    ]
  },
  {
    "slug": "visne-iskinli-asmali-arpa-pilavi",
    "title": "Vişne Işkın Asmalı Arpa Pilavı",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_ASMA_PILAV.jpg?v=1712567734",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "40-45 dk"
      ],
      [
        "Dinlendirme",
        "15 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 40-45 dk",
    "ingredients": [
      "1 orta boy soğan",
      "250 gr arpa şehriyesi",
      "250 gr Freya Gurme Vişne Işkın Otu Sos",
      "30 gr dolmalık fıstık",
      "5 gr tuz",
      "5 gr karabiber",
      "2 gr tarçın",
      "30 gr yenibahar",
      "50 adet asma yaprağı, doğranmış",
      "30 ml zeytinyağ",
      "750 ml sıcak su"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 orta boy soğan",
          "250 gr arpa şehriyesi",
          "250 gr Freya Gurme Vişne Işkın Otu Sos",
          "30 gr dolmalık fıstık",
          "5 gr tuz",
          "5 gr karabiber",
          "2 gr tarçın",
          "30 gr yenibahar",
          "50 adet asma yaprağı, doğranmış",
          "30 ml zeytinyağ",
          "750 ml sıcak su"
        ]
      }
    ],
    "steps": [
      "Pilav tenceresine zeytinyağı koyunuz ve küp küp doğranmış soğanları ilave ederek 5-6 dakika kavurunuz",
      "Dolmalık fıstığı ekleyiniz",
      "Arpa şehriyesinide ilave ediniz ve kısık ateşte 5-6 dakika daha kavurunuz",
      "Baharatlarını ekleyiniz",
      "Asma yapraklarını ilave ediniz",
      "Vişne sosunuzu ekleyip bir karıştırınız",
      "Suyunu koyup, kaynadıktan sonra kısık ateşe getirip yaklaşık 30 dk kadar pişiriniz",
      "Altını kapatıp 15 dakika kadar dinlendiriniz",
      "İstediğiniz tabaklarda servis edebilirsiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Pilav tenceresine zeytinyağı koyunuz ve küp küp doğranmış soğanları ilave ederek 5-6 dakika kavurunuz",
          "Dolmalık fıstığı ekleyiniz",
          "Arpa şehriyesinide ilave ediniz ve kısık ateşte 5-6 dakika daha kavurunuz",
          "Baharatlarını ekleyiniz",
          "Asma yapraklarını ilave ediniz",
          "Vişne sosunuzu ekleyip bir karıştırınız",
          "Suyunu koyup, kaynadıktan sonra kısık ateşe getirip yaklaşık 30 dk kadar pişiriniz",
          "Altını kapatıp 15 dakika kadar dinlendiriniz",
          "İstediğiniz tabaklarda servis edebilirsiniz"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskinli-asmali-arpa-pilavi",
    "sourceId": "gid://shopify/Article/605706354972",
    "aliases": [
      "visne-iskinli-asmali-arpa-pilavi"
    ]
  },
  {
    "slug": "visne-iskinli-mousse",
    "title": "Vişne Işkın Mousse",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_MOOUSE.jpg?v=1712567079",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "6 kişilik",
    "times": [
      [
        "Hazırlama",
        "25 dk"
      ],
      [
        "Pişirme",
        "15 dk"
      ],
      [
        "Soğutma",
        "2-3 saat"
      ]
    ],
    "time": "Hazırlama 25 dk · Pişirme 15 dk",
    "ingredients": [
      "3 yumurta, beyaz ve sarısı ayrılmış",
      "120 gr Freya Gurme Vişne Işkın Sos",
      "125 ml krema",
      "180 gr bitter çikolata",
      "60 gr tereyağ",
      "50 gr şeker",
      "2 gr tuz",
      "5 ml vanilya özütü",
      "10 gr granül kahve",
      "10 ml sıcak su"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "3 yumurta, beyaz ve sarısı ayrılmış",
          "120 gr Freya Gurme Vişne Işkın Sos",
          "125 ml krema",
          "180 gr bitter çikolata",
          "60 gr tereyağ",
          "50 gr şeker",
          "2 gr tuz",
          "5 ml vanilya özütü",
          "10 gr granül kahve",
          "10 ml sıcak su"
        ]
      }
    ],
    "steps": [
      "Fırını 190c ayarlayınız",
      "Sos tenceresinin içerisine yağ ve çikolatayı koyunuz",
      "Sıcak suya kahveyi koyunuz, karıştırınız ve sos tenceresine koyunuz",
      "Kremayı ekleyiniz ve karıştırmaya devam ediniz",
      "Vişne sosunuzu ilave edip 2-3 dakika kadar daha karıştırınız",
      "Ocaktan alınız ve soğumaya bırakınız",
      "Yumurta sarılarını 25 gr şeker ile el mikserinde çırpınız, küçük bir fırın kabına koyunuz",
      "Kabı su dolu bir kaba koyunuz ve önceden ısıtılmış fırında 2-3 dakika pişiriniz",
      "Fırından çıkarın ve soğumaya bırakınız",
      "Yumurta beyazını tuz ile el mikserinde iyice çırpınız ve kalan şekeri ekleyip 2-3 dakika kadar daha çırpın",
      "Yumurta sarısı karışımı vişne çikolata sosuna ekleyiniz ve karıştırınız",
      "Yumurta beyazlarını yavaş yavaş ekleyiniz ve karıştırınız",
      "İstediğiniz kapla eşit miktarda koyunuz ve 2 saate yakın buzdolabında soğutunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 190c ayarlayınız",
          "Sos tenceresinin içerisine yağ ve çikolatayı koyunuz",
          "Sıcak suya kahveyi koyunuz, karıştırınız ve sos tenceresine koyunuz",
          "Kremayı ekleyiniz ve karıştırmaya devam ediniz",
          "Vişne sosunuzu ilave edip 2-3 dakika kadar daha karıştırınız",
          "Ocaktan alınız ve soğumaya bırakınız",
          "Yumurta sarılarını 25 gr şeker ile el mikserinde çırpınız, küçük bir fırın kabına koyunuz",
          "Kabı su dolu bir kaba koyunuz ve önceden ısıtılmış fırında 2-3 dakika pişiriniz",
          "Fırından çıkarın ve soğumaya bırakınız",
          "Yumurta beyazını tuz ile el mikserinde iyice çırpınız ve kalan şekeri ekleyip 2-3 dakika kadar daha çırpın",
          "Yumurta sarısı karışımı vişne çikolata sosuna ekleyiniz ve karıştırınız",
          "Yumurta beyazlarını yavaş yavaş ekleyiniz ve karıştırınız",
          "İstediğiniz kapla eşit miktarda koyunuz ve 2 saate yakın buzdolabında soğutunuz"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskinli-mousse",
    "sourceId": "gid://shopify/Article/605706387740",
    "aliases": [
      "visne-iskinli-mousse"
    ]
  },
  {
    "slug": "ejder-meyveli-tart",
    "title": "Ejder Meyveli Tart",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/EJDER_MEYVELI_TART.jpg?v=1712566613",
    "productSlug": "ejder-meyvesi-sosu",
    "product": "Ejder Meyvesi Sosu",
    "summary": "",
    "serves": "8 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Dinlendirme",
        "15 dk"
      ],
      [
        "Pişirme",
        "35 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Dinlendirme 15 dk",
    "ingredients": [
      "1 yumurta",
      "30 gr tereyağ",
      "80 gr sade yağ",
      "25 gr yoğurt",
      "25 gr portakal kabuğu",
      "40 gr freya hindistan cevizi şekeri",
      "25 gr badem unu",
      "25 gr kabartma tozu",
      "50 gr sıvı yağ",
      "25 ml portakal suyu",
      "300 gr Freya Gurme Ejder Meyvesi Sosu",
      "Taze ejder meyvesi",
      "Vanilyalı dondurma"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 yumurta",
          "30 gr tereyağ",
          "80 gr sade yağ",
          "25 gr yoğurt",
          "25 gr portakal kabuğu",
          "40 gr freya hindistan cevizi şekeri",
          "25 gr badem unu",
          "25 gr kabartma tozu",
          "50 gr sıvı yağ",
          "25 ml portakal suyu",
          "300 gr Freya Gurme Ejder Meyvesi Sosu"
        ]
      },
      {
        "title": "Süslemek için",
        "items": [
          "Taze ejder meyvesi",
          "Vanilyalı dondurma"
        ]
      }
    ],
    "steps": [
      "Derin bir kabın içerisine tereyağ, sade yağ, yoğurt, portakal rendesi, Hindistan cevizi şekeri, sıvıyağ ve yumurtayı koyunuz ve iyice karıştırınız",
      "Ununuzun yarısını karışıma koyunuz ve yoğurunuz",
      "Kabartma tozunu, portakal suyu ve kalan ununuzu ekleyip karıştırıp yoğurmaya devam ediniz",
      "Streç filme sarıp 15 dakika buzdolabında dinlendiriniz",
      "Yağlı kağıdın üzerinde hamurunuzun %60 merdane yardımıyla tart kalıbınıza göre açınız",
      "Kenarlarını bıçak yardımıyla düzeltiniz",
      "İçerisine Ejder Meyvesi sosunu ekleyiniz",
      "Geri kalan hamurunuzu açıp, dikdörtgen şeklinde kesiniz ve üzerine yerleştiriniz",
      "180 c önceden ısıttığınız fırında pişiriniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Derin bir kabın içerisine tereyağ, sade yağ, yoğurt, portakal rendesi, Hindistan cevizi şekeri, sıvıyağ ve yumurtayı koyunuz ve iyice karıştırınız",
          "Ununuzun yarısını karışıma koyunuz ve yoğurunuz",
          "Kabartma tozunu, portakal suyu ve kalan ununuzu ekleyip karıştırıp yoğurmaya devam ediniz",
          "Streç filme sarıp 15 dakika buzdolabında dinlendiriniz",
          "Yağlı kağıdın üzerinde hamurunuzun %60 merdane yardımıyla tart kalıbınıza göre açınız",
          "Kenarlarını bıçak yardımıyla düzeltiniz",
          "İçerisine Ejder Meyvesi sosunu ekleyiniz",
          "Geri kalan hamurunuzu açıp, dikdörtgen şeklinde kesiniz ve üzerine yerleştiriniz",
          "180 c önceden ısıttığınız fırında pişiriniz"
        ]
      }
    ],
    "source": "Ejder Meyvesi Soslu Tarifler",
    "sourceBlog": "ejder-meyvesi-soslu-tarifler",
    "sourcePath": "/blogs/ejder-meyvesi-soslu-tarifler/ejder-meyveli-tart",
    "sourceId": "gid://shopify/Article/605706420508",
    "aliases": [
      "ejder-meyveli-tart"
    ]
  },
  {
    "slug": "ejder-meyveli-milfoy",
    "title": "Ejder Meyveli Milföy",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/EJDER_MEYVELI_MILFOY.jpg?v=1712566038",
    "productSlug": "ejder-meyvesi-sosu",
    "product": "Ejder Meyvesi Sosu",
    "summary": "",
    "serves": "4 kişilik",
    "times": [
      [
        "Hazırlama",
        "30 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ],
      [
        "Dinlendirme",
        "50 dk"
      ]
    ],
    "time": "Hazırlama 30 dk · Pişirme 25 dk",
    "ingredients": [
      "300 gr un",
      "300 gr yağ, oda sıcaklığında",
      "2 gr tuz",
      "Yeterince buzlu su",
      "1 yumurta, çırpılmış",
      "250 gr Freya Gurme Ejder Mevyesi Sosu",
      "370 ml süt",
      "3 yumurta, sarısı",
      "80 gr şeker",
      "25 gr mısır nişastası",
      "15 gr un",
      "20 gr tereyağ",
      "5 ml vanilya özütü"
    ],
    "ingredientGroups": [
      {
        "title": "Hamur için",
        "items": [
          "300 gr un",
          "300 gr yağ, oda sıcaklığında",
          "2 gr tuz",
          "Yeterince buzlu su",
          "1 yumurta, çırpılmış"
        ]
      },
      {
        "title": "Krema için",
        "items": [
          "250 gr Freya Gurme Ejder Mevyesi Sosu",
          "370 ml süt",
          "3 yumurta, sarısı",
          "80 gr şeker",
          "25 gr mısır nişastası",
          "15 gr un",
          "20 gr tereyağ",
          "5 ml vanilya özütü"
        ]
      }
    ],
    "steps": [
      "Büyük bir kabın içerisine un ve yağı koyunuz ve karıştırınız",
      "Tuzu ekleyiniz ve yoğurunuz",
      "Kıvamına göre buzlu su ekleyiniz ve yoğurmaya devam ediniz",
      "Hamur istediğiniz kıvama gelince streçe sarınız ve yaklaşık 25 dakika dinlemeye bırakınız",
      "Kremayı hazırlamak için, yumurtayı sos tenceresine alınız ve çırpınız",
      "Sütü ekleyiniz ve altını açınız",
      "Şeker ve tereyağ ekleyiniz ve karıştırmaya devam ediniz",
      "Un, nişastası ekleyiniz, karıştırınız ve altını kısınız",
      "Ejder meyvesi sosunuzu ve vanilya özütü ekleyiniz ve 2-3 dakika kadar karıştırmaya devam ediniz",
      "Sosunuzu kenara alınız",
      "Hamurunuzu dikdörtgen şekle göre açınız",
      "Kenarlarından kapatınız, kare şekline getiriniz ve tekrar açınız",
      "Bu işlemi dört kez yapınız",
      "Un kaplı yüzeyde hamurunuzu açınız ve istediğiniz ebatta kesiniz",
      "Üzerine çırpılmış yumurta sürünüz ve 190c önceden ısıtılmış fırınınızda 10 dk pişiriniz",
      "Fırından alınız ve soğumaya bırakınız",
      "Milföylerinizin üzerine hazırladığınız Ejder Meyvesi sosunu sürünüz",
      "Arzu ettiğiniz şekilde süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Büyük bir kabın içerisine un ve yağı koyunuz ve karıştırınız",
          "Tuzu ekleyiniz ve yoğurunuz",
          "Kıvamına göre buzlu su ekleyiniz ve yoğurmaya devam ediniz",
          "Hamur istediğiniz kıvama gelince streçe sarınız ve yaklaşık 25 dakika dinlemeye bırakınız",
          "Kremayı hazırlamak için, yumurtayı sos tenceresine alınız ve çırpınız",
          "Sütü ekleyiniz ve altını açınız",
          "Şeker ve tereyağ ekleyiniz ve karıştırmaya devam ediniz",
          "Un, nişastası ekleyiniz, karıştırınız ve altını kısınız",
          "Ejder meyvesi sosunuzu ve vanilya özütü ekleyiniz ve 2-3 dakika kadar karıştırmaya devam ediniz",
          "Sosunuzu kenara alınız",
          "Hamurunuzu dikdörtgen şekle göre açınız",
          "Kenarlarından kapatınız, kare şekline getiriniz ve tekrar açınız",
          "Bu işlemi dört kez yapınız",
          "Un kaplı yüzeyde hamurunuzu açınız ve istediğiniz ebatta kesiniz",
          "Üzerine çırpılmış yumurta sürünüz ve 190c önceden ısıtılmış fırınınızda 10 dk pişiriniz",
          "Fırından alınız ve soğumaya bırakınız",
          "Milföylerinizin üzerine hazırladığınız Ejder Meyvesi sosunu sürünüz",
          "Arzu ettiğiniz şekilde süsleyiniz"
        ]
      }
    ],
    "source": "Ejder Meyvesi Soslu Tarifler",
    "sourceBlog": "ejder-meyvesi-soslu-tarifler",
    "sourcePath": "/blogs/ejder-meyvesi-soslu-tarifler/ejder-meyveli-milfoy",
    "sourceId": "gid://shopify/Article/605706453276",
    "aliases": [
      "ejder-meyveli-milfoy"
    ]
  },
  {
    "slug": "pitayali-pavlova",
    "title": "Ejder Meyveli Pavlova",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/EJDER_MEYVELIPAVLOVA.jpg?v=1712567041",
    "productSlug": "ejder-meyvesi-sosu",
    "product": "Ejder Meyvesi Sosu",
    "summary": "",
    "serves": "8-10 Kişilik",
    "times": [
      [
        "Hazırlama",
        "10-15 dakika"
      ],
      [
        "Pişirme",
        "1 saat"
      ],
      [
        "Bekletme",
        "2 saat"
      ]
    ],
    "time": "Hazırlama 10-15 dakika · Pişirme 1 saat",
    "ingredients": [
      "4 yumurta",
      "200 gr pudra şekeri",
      "5 gr mısır nişastası",
      "30 gr beyaz kuvertür çikolata",
      "250 gr Freya Gurme Ejder Meyvesi Sosu",
      "Taze meyve"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "4 yumurta",
          "200 gr pudra şekeri",
          "5 gr mısır nişastası",
          "30 gr beyaz kuvertür çikolata",
          "250 gr Freya Gurme Ejder Meyvesi Sosu",
          "Taze meyve"
        ]
      }
    ],
    "steps": [
      "Fırını 120c turboya getiriniz",
      "Yumurta aklarını mikser kabınıza alınız",
      "En yüksek hızda yaklaşık 3 dakika çırpınız",
      "Pudra şekerini yavaşça ekleyiniz ve 6 dakika kadar çırpınız",
      "Nişastayı ekleyin, karıştırın ve kapatınız",
      "Fırın tepsisine pişirme kağıdı koyunuz",
      "Spatula yardımıyla karışımı koyunuz ve şekil veriniz",
      "Fırında 1 saat pişiriniz",
      "Fırını kapatınız ve 2 saat içinde bekletiniz",
      "Beyaz çikolatayı benmari usulü eritiniz",
      "Servis tabağına aldığınız pavlovayı önce beyaz çikolatayı sonra Ejder Meyvesi sosunu koyunuz",
      "Taze meyvelerle süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 120c turboya getiriniz",
          "Yumurta aklarını mikser kabınıza alınız",
          "En yüksek hızda yaklaşık 3 dakika çırpınız",
          "Pudra şekerini yavaşça ekleyiniz ve 6 dakika kadar çırpınız",
          "Nişastayı ekleyin, karıştırın ve kapatınız",
          "Fırın tepsisine pişirme kağıdı koyunuz",
          "Spatula yardımıyla karışımı koyunuz ve şekil veriniz",
          "Fırında 1 saat pişiriniz",
          "Fırını kapatınız ve 2 saat içinde bekletiniz",
          "Beyaz çikolatayı benmari usulü eritiniz",
          "Servis tabağına aldığınız pavlovayı önce beyaz çikolatayı sonra Ejder Meyvesi sosunu koyunuz",
          "Taze meyvelerle süsleyiniz"
        ]
      }
    ],
    "source": "Ejder Meyvesi Soslu Tarifler",
    "sourceBlog": "ejder-meyvesi-soslu-tarifler",
    "sourcePath": "/blogs/ejder-meyvesi-soslu-tarifler/pitayali-pavlova",
    "sourceId": "gid://shopify/Article/605706584348",
    "aliases": [
      "pitayali-pavlova"
    ]
  },
  {
    "slug": "pancar-havlicanli-falafel",
    "title": "Pancar Havlıcan Falafel",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/FreyaYeni2118.jpg?v=1692886945",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "6 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "15 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 15 dk",
    "ingredients": [
      "250 gr haşlanmış nohut",
      "150 gr Freya Gurme Pancar Havlıcan sos",
      "1 soğan",
      "3 diş sarımsak",
      "50 gr maydanoz, kıyılmış",
      "25 gr kişniş, kıyılmış",
      "45 gr tam buğday unu",
      "5 gr kabartma tozu",
      "5 gr tuz",
      "3 gr karabiber",
      "3 gr kırmızı toz biber",
      "300 ml kızartma yağı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "250 gr haşlanmış nohut",
          "150 gr Freya Gurme Pancar Havlıcan sos",
          "1 soğan",
          "3 diş sarımsak",
          "50 gr maydanoz, kıyılmış",
          "25 gr kişniş, kıyılmış",
          "45 gr tam buğday unu",
          "5 gr kabartma tozu",
          "5 gr tuz",
          "3 gr karabiber",
          "3 gr kırmızı toz biber",
          "300 ml kızartma yağı"
        ]
      }
    ],
    "steps": [
      "Haşlanmış ve kuruttuğunuz nohutları, soğanı, sarımsak ve baharatları rondoya alınız ve çekiniz",
      "Karışımı bir kaba alınız",
      "Pancar Havlıcan sosu, un ve kabartma tozunu ekleyerek köfte kıvamına getiriniz",
      "Yağın altını yakınız ve ceviz büyüklüğünde falafellerinizi kızartınız",
      "Servis tabağına alınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Haşlanmış ve kuruttuğunuz nohutları, soğanı, sarımsak ve baharatları rondoya alınız ve çekiniz",
          "Karışımı bir kaba alınız",
          "Pancar Havlıcan sosu, un ve kabartma tozunu ekleyerek köfte kıvamına getiriniz",
          "Yağın altını yakınız ve ceviz büyüklüğünde falafellerinizi kızartınız",
          "Servis tabağına alınız"
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlicanli-falafel",
    "sourceId": "gid://shopify/Article/605706617116",
    "aliases": [
      "pancar-havlicanli-falafel"
    ]
  },
  {
    "slug": "pancar-havlican-strudel",
    "title": "Pancar Havlıcan Strudel",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/PANCAR_HAVLICAN_STRUDEL.jpg?v=1712565504",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "30-40 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 30-40 dk",
    "ingredients": [
      "1 yumurta",
      "185 gr un",
      "2 gr tuz",
      "5 gr şeker",
      "100 gr yağ",
      "2 ml sirke",
      "Yeterince buzlu su",
      "200 gr Freya Gurme Pancar Havlıcan Sosu",
      "350 gr ricotta peynir",
      "1 yumurta",
      "1 Limon kabuğu rendesi",
      "30 gr ekmek kırıntısı"
    ],
    "ingredientGroups": [
      {
        "title": "Hamur için",
        "items": [
          "1 yumurta",
          "185 gr un",
          "2 gr tuz",
          "5 gr şeker",
          "100 gr yağ",
          "2 ml sirke",
          "Yeterince buzlu su"
        ]
      },
      {
        "title": "İç harcı için",
        "items": [
          "200 gr Freya Gurme Pancar Havlıcan Sosu",
          "350 gr ricotta peynir",
          "1 yumurta",
          "1 Limon kabuğu rendesi",
          "30 gr ekmek kırıntısı"
        ]
      }
    ],
    "steps": [
      "Fırını 190c ısıtınız",
      "Büyük bir kasenin içerisinde tuz, şeker ve unu karıştırınız",
      "30 gr yağı ilave ediniz, ekmek kırıntısı kıvamına getiriniz",
      "Yumurta, sirke ve 60 ml kadar suyu bir kapta karıştırınız",
      "Sıvıları katı malzemeye koyunuz",
      "Hamur kıvamına gelinceye kadar yoğurunuz",
      "Temiz bir mutfak havlusunun üzerine hamuru koyunuz ve dikdörtgen şeklinde açınız",
      "Kalan yağınızı hamurunuza sürünüz",
      "İç harç için; limon kabuk rendesi hariç tüm malzemeleri rondodan geçiriniz.",
      "Hamurunuzun alt kısmına iç harcı sürünüz ve limon kabuğu rendesini serpiniz,",
      "Hamurunuzu kapatınız.",
      "30-40 dk pişiriniz.",
      "Servis tabağına alınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 190c ısıtınız",
          "Büyük bir kasenin içerisinde tuz, şeker ve unu karıştırınız",
          "30 gr yağı ilave ediniz, ekmek kırıntısı kıvamına getiriniz",
          "Yumurta, sirke ve 60 ml kadar suyu bir kapta karıştırınız",
          "Sıvıları katı malzemeye koyunuz",
          "Hamur kıvamına gelinceye kadar yoğurunuz",
          "Temiz bir mutfak havlusunun üzerine hamuru koyunuz ve dikdörtgen şeklinde açınız",
          "Kalan yağınızı hamurunuza sürünüz",
          "İç harç için; limon kabuk rendesi hariç tüm malzemeleri rondodan geçiriniz.",
          "Hamurunuzun alt kısmına iç harcı sürünüz ve limon kabuğu rendesini serpiniz,",
          "Hamurunuzu kapatınız.",
          "30-40 dk pişiriniz.",
          "Servis tabağına alınız"
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlican-strudel",
    "sourceId": "gid://shopify/Article/605706649884",
    "aliases": [
      "pancar-havlican-strudel"
    ]
  },
  {
    "slug": "pancar-havlicanli-rulo-pasta",
    "title": "Pancar Havlıcan Rulo Pasta",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/PANCAR_HAVLICAN_rULO_PASTA.jpg?v=1712562059",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "30-35 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 30-35 dk",
    "ingredients": [
      "5 yumurta beyazı",
      "260 gr şeker",
      "20 ml beyaz sirke",
      "18 gr mısır nişastası",
      "350 gr mascarpone peyniri",
      "250 gr krema",
      "250 gr Freya Gurme Pancar Havlıcan Sos",
      "10 gr şekerli vanilin",
      "1 misket limon kabuğu rendesi"
    ],
    "ingredientGroups": [
      {
        "title": "Kek için",
        "items": [
          "5 yumurta beyazı",
          "260 gr şeker",
          "20 ml beyaz sirke",
          "18 gr mısır nişastası"
        ]
      },
      {
        "title": "İç harç İçin",
        "items": [
          "350 gr mascarpone peyniri",
          "250 gr krema",
          "250 gr Freya Gurme Pancar Havlıcan Sos",
          "10 gr şekerli vanilin",
          "1 misket limon kabuğu rendesi"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 175c ısıtınız",
      "Yumurtaları tezgah üstü blender ile en yüksek hızda 5-6 dk karıştırınız",
      "Şekeri ekleyiniz ve karıştırmaya devam ediniz",
      "Sirke ve nişastayı ilave ediniz ve karıştırınız",
      "Fırın tepsisine pişirme kağıdı seriniz ve kekinizi düzelterek koyunuz",
      "30-35 dk pişiriniz",
      "temiz bir mutfak örtüsü seriniz",
      "İç harcı için limon kabuğu rendesi hariç tüm malzemeleri karıştırınız",
      "Kekinizi başka bir mutfak örtüsünün üzerine koyunuz, iç harcınızı sürün ve limon kabuğunu rendeleyiniz",
      "Mutfak örtüsü yardımıyla rulo haline getiriniz",
      "Servis tabağına alınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 175c ısıtınız",
          "Yumurtaları tezgah üstü blender ile en yüksek hızda 5-6 dk karıştırınız",
          "Şekeri ekleyiniz ve karıştırmaya devam ediniz",
          "Sirke ve nişastayı ilave ediniz ve karıştırınız",
          "Fırın tepsisine pişirme kağıdı seriniz ve kekinizi düzelterek koyunuz",
          "30-35 dk pişiriniz"
        ]
      },
      {
        "title": "Piştikten sonra fırından alınız ve üzerine kurumaması için",
        "items": [
          "temiz bir mutfak örtüsü seriniz",
          "İç harcı için limon kabuğu rendesi hariç tüm malzemeleri karıştırınız",
          "Kekinizi başka bir mutfak örtüsünün üzerine koyunuz, iç harcınızı sürün ve limon kabuğunu rendeleyiniz",
          "Mutfak örtüsü yardımıyla rulo haline getiriniz",
          "Servis tabağına alınız"
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlicanli-rulo-pasta",
    "sourceId": "gid://shopify/Article/605706682652",
    "aliases": [
      "pancar-havlicanli-rulo-pasta"
    ]
  },
  {
    "slug": "baharatli-balkabakli-muffin",
    "title": "Baharatlı Balkabaklı Muffin",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Baharatli_Balkabakli_muffin.jpg?v=1712566400",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "12 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "18 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 18 dk",
    "ingredients": [
      "245 gr un",
      "2 yumurta",
      "200 gr hindistan cevizi şekeri",
      "10 gr kabartma tozu",
      "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
      "120 ml yağ10 gr şekerli vanilin",
      "5 gr karbonat (üzerine birkaç damla limon suyu)",
      "1 yumurta sarısı",
      "50 gr şeker",
      "10 gr şekerli vanilin",
      "230 gr krem peynir"
    ],
    "ingredientGroups": [
      {
        "title": "Kek harcı için",
        "items": [
          "245 gr un",
          "2 yumurta",
          "200 gr hindistan cevizi şekeri",
          "10 gr kabartma tozu",
          "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
          "120 ml yağ10 gr şekerli vanilin",
          "5 gr karbonat (üzerine birkaç damla limon suyu)"
        ]
      },
      {
        "title": "Peynir sosu için",
        "items": [
          "1 yumurta sarısı",
          "50 gr şeker",
          "10 gr şekerli vanilin",
          "230 gr krem peynir"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 190c ısıtınız",
      "Yumurta ve şekeri 6-8 dk tezgah üstü blender ile karıştırınız",
      "Şekerli vanilin ekleyiniz",
      "Freya sosunuzu koyunuz ve limonlu karbonatı ekleyiniz",
      "Yağı ekleyiniz",
      "Başka bir kapda un, kabartma tozu ve tuzu karıştırınız ve kek karışımına ilave ediniz",
      "Muffin kalıplarına koyunuz",
      "Krem peynir sosu için tüm malzemeleri rondodan geçiriniz ve keklerin üzerine koyunuz ve kürdan yardımıyla şekil veriniz",
      "18-20 dk pişiriniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 190c ısıtınız",
          "Yumurta ve şekeri 6-8 dk tezgah üstü blender ile karıştırınız",
          "Şekerli vanilin ekleyiniz",
          "Freya sosunuzu koyunuz ve limonlu karbonatı ekleyiniz",
          "Yağı ekleyiniz",
          "Başka bir kapda un, kabartma tozu ve tuzu karıştırınız ve kek karışımına ilave ediniz",
          "Muffin kalıplarına koyunuz",
          "Krem peynir sosu için tüm malzemeleri rondodan geçiriniz ve keklerin üzerine koyunuz ve kürdan yardımıyla şekil veriniz",
          "18-20 dk pişiriniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabakli-muffin",
    "sourceId": "gid://shopify/Article/606079746332",
    "aliases": [
      "baharatli-balkabakli-muffin"
    ]
  },
  {
    "slug": "baharatli-balkabagi-kahve",
    "title": "Baharatlı Balkabaklı Kahve",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/balkabakli_kahve.jpg?v=1712565581",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "350 ml filtre kahve",
      "100 ml badem sütü",
      "70 gr Freya Gurme Baharatlı Balkabağı sosu"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "350 ml filtre kahve",
          "100 ml badem sütü",
          "70 gr Freya Gurme Baharatlı Balkabağı sosu"
        ]
      }
    ],
    "steps": [
      "Tüm malzemeleri el blender ile karıştırınız",
      "İster soğuk ister sıcak tüketebilirsiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tüm malzemeleri el blender ile karıştırınız",
          "İster soğuk ister sıcak tüketebilirsiniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-kahve",
    "sourceId": "gid://shopify/Article/606079779100",
    "aliases": [
      "baharatli-balkabagi-kahve"
    ]
  },
  {
    "slug": "baharatli-balkabakli-mac-n-cheese",
    "title": "Baharatlı Balkabaklı Mac N Cheese",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/balkabakali_mac_and_chhese.jpg?v=1712565966",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 25 dk",
    "ingredients": [
      "500 gr burgu makarna",
      "30 gr sadeyağ",
      "60 gr un",
      "500 ml süt",
      "240 gr cheddar peyniri",
      "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
      "2 gr tuz",
      "Yeterince tuz",
      "Süslemek için 100 gr burger peyniri"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "500 gr burgu makarna",
          "30 gr sadeyağ",
          "60 gr un",
          "500 ml süt",
          "240 gr cheddar peyniri",
          "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
          "2 gr tuz",
          "Yeterince tuz",
          "Süslemek için 100 gr burger peyniri"
        ]
      }
    ],
    "steps": [
      "Büyük bir tencerede makarnanızı haşlayınız",
      "Sos tenceresinde yağı eritiniz",
      "Unu ilave ediniz ve hafif kahverengi olana kadar kavurunuz",
      "Sütü ilave ediniz ve karıştırmaya devam ediniz",
      "Balkabağı sosunu, tuz ve karabiberi ilave ediniz ve hızlıca karıştırınız",
      "Sosun altını kısınız",
      "Makarnanızı süzün ve servis tabağına alınız",
      "Sosunuzu koyunuz ve karıştırınız",
      "Burger peynirleriyle süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Büyük bir tencerede makarnanızı haşlayınız",
          "Sos tenceresinde yağı eritiniz",
          "Unu ilave ediniz ve hafif kahverengi olana kadar kavurunuz",
          "Sütü ilave ediniz ve karıştırmaya devam ediniz",
          "Balkabağı sosunu, tuz ve karabiberi ilave ediniz ve hızlıca karıştırınız",
          "Sosun altını kısınız",
          "Makarnanızı süzün ve servis tabağına alınız",
          "Sosunuzu koyunuz ve karıştırınız",
          "Burger peynirleriyle süsleyiniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabakli-mac-n-cheese",
    "sourceId": "gid://shopify/Article/606079811868",
    "aliases": [
      "baharatli-balkabakli-mac-n-cheese"
    ]
  },
  {
    "slug": "baharatli-balkabagi-kurabiye",
    "title": "Baharatlı Balkabaklı Kurabiye",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/baharatli_balkabakli_kurabiye.jpg?v=1712565754",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "12 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Pişirme",
        "12-14 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Pişirme 12-14 dk",
    "ingredients": [
      "120gr bitter çikolata",
      "250 gr Freya Gurme Balkabağı sosu",
      "250 gr un",
      "120 gr erimiş tereyağ",
      "100 gr hindistan cevizi şekeri",
      "1 çay kaşığı karbonat, 3 damla limon suyu",
      "1 çay kaşığı tuz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "120gr bitter çikolata",
          "250 gr Freya Gurme Balkabağı sosu",
          "250 gr un",
          "120 gr erimiş tereyağ",
          "100 gr hindistan cevizi şekeri",
          "1 çay kaşığı karbonat, 3 damla limon suyu",
          "1 çay kaşığı tuz"
        ]
      }
    ],
    "steps": [
      "Fırınınızı altüst moduna 200 dereceye ayarlayınız",
      "Çikolata hariç tüm malzemeleri karıştırınız",
      "Çikolataları bıçak yardımıyla parçalara ayırınız",
      "Hamurunuzun içine koyunuz",
      "Yağlı kağıt serdiğiniz fırın tepsisine istediğiniz büyüklükte parçalara ayırıp koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı altüst moduna 200 dereceye ayarlayınız",
          "Çikolata hariç tüm malzemeleri karıştırınız",
          "Çikolataları bıçak yardımıyla parçalara ayırınız",
          "Hamurunuzun içine koyunuz",
          "Yağlı kağıt serdiğiniz fırın tepsisine istediğiniz büyüklükte parçalara ayırıp koyunuz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-kurabiye",
    "sourceId": "gid://shopify/Article/606079877404",
    "aliases": [
      "baharatli-balkabagi-kurabiye"
    ]
  },
  {
    "slug": "baharatli-balkabagi-truffles",
    "title": "Baharatlı Balkabaklı Truffles",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-truffles_480x480_57eccf17-4a74-43d7-adaa-40a962689597.webp?v=1699263220",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "10-12 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Dinlenme",
        "35 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Dinlenme 35 dk",
    "ingredients": [
      "115 gr Hindistan cevizi yağı erimiş soğumuş",
      "100 gr Freya Gurme Balkabağı sosu",
      "110 gr Hindistan cevizi unu",
      "150 gr pretzel",
      "1 çay kaşığı vanilya özütü",
      "120 gr beyaz çikolata",
      "10 gr Hindistan cevizi yağı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "115 gr Hindistan cevizi yağı erimiş soğumuş",
          "100 gr Freya Gurme Balkabağı sosu",
          "110 gr Hindistan cevizi unu",
          "150 gr pretzel",
          "1 çay kaşığı vanilya özütü",
          "120 gr beyaz çikolata",
          "10 gr Hindistan cevizi yağı"
        ]
      }
    ],
    "steps": [
      "Yağ, vanilya özütü ve",
      "Balkabağı sosunu karıştırınız",
      "Unu yavaş yavaş ekleyerek karıştırınız",
      "Pretzelleri küçük parçalara bölünüz",
      "Tüm malzemeleri karıştırınız ve top şekline getiriniz",
      "15 dk buzlukta dondurunuz",
      "Beyaz çikolataya hindistan cevizi yağı koyarak benmari usülü eritiniz",
      "Buzluktan çıkardığınız topları çikolataya batırınız",
      "20 dk buzdolabında bekletiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Yağ, vanilya özütü ve",
          "Balkabağı sosunu karıştırınız",
          "Unu yavaş yavaş ekleyerek karıştırınız",
          "Pretzelleri küçük parçalara bölünüz",
          "Tüm malzemeleri karıştırınız ve top şekline getiriniz",
          "15 dk buzlukta dondurunuz",
          "Beyaz çikolataya hindistan cevizi yağı koyarak benmari usülü eritiniz",
          "Buzluktan çıkardığınız topları çikolataya batırınız",
          "20 dk buzdolabında bekletiniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-truffles",
    "sourceId": "gid://shopify/Article/606079910172",
    "aliases": [
      "baharatli-balkabagi-truffles"
    ]
  },
  {
    "slug": "zencefil-aci-armut-soslu-pilav",
    "title": "Zencefil Acı Armut Soslu Pilav",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Zencefil_Acili_Armut_Pilav.jpg?v=1712566234",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 25 dk",
    "ingredients": [
      "300 gr basmati pirinç",
      "1 kuru soğan",
      "200 gr haşlanmış bezelye",
      "200 gr haşlanmış bakla",
      "100 gr ince kıyılmış dereotu",
      "200 gr FreyaGurme zencefil Acılı Armut sosu",
      "Zeytinyağ",
      "Tuz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "300 gr basmati pirinç",
          "1 kuru soğan",
          "200 gr haşlanmış bezelye",
          "200 gr haşlanmış bakla",
          "100 gr ince kıyılmış dereotu",
          "200 gr FreyaGurme zencefil Acılı Armut sosu",
          "Zeytinyağ",
          "Tuz"
        ]
      }
    ],
    "steps": [
      "Su dolu sıcak bir kapda pirinçinizi 15 dk kaynatınız",
      "Soğanı ay biçiminde doğrayınız ve zeytinyağ koyduğunuz tavada soteleyiniz",
      "Pirinçinizi süzünüz ve soğan karışımına koyunuz",
      "Sebzeleri ilave ediniz",
      "Sosunuzu ve tuzu ilave edip altını kapatınız",
      "Dereotu ile süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Su dolu sıcak bir kapda pirinçinizi 15 dk kaynatınız",
          "Soğanı ay biçiminde doğrayınız ve zeytinyağ koyduğunuz tavada soteleyiniz",
          "Pirinçinizi süzünüz ve soğan karışımına koyunuz",
          "Sebzeleri ilave ediniz",
          "Sosunuzu ve tuzu ilave edip altını kapatınız",
          "Dereotu ile süsleyiniz"
        ]
      }
    ],
    "source": "Zencefil Acılı Armut Soslu Tarifler",
    "sourceBlog": "zencefil-acili-armut-soslu-tarifler",
    "sourcePath": "/blogs/zencefil-acili-armut-soslu-tarifler/zencefil-aci-armut-soslu-pilav",
    "sourceId": "gid://shopify/Article/606079975708",
    "aliases": [
      "zencefil-aci-armut-soslu-pilav"
    ]
  },
  {
    "slug": "baharatli-balkabakli-makarna",
    "title": "Baharatlı Balkabaklı Makarna",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/baharatli_balkabakli_makarna.jpg?v=1712566289",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "6-8 kisilik",
    "times": [
      [
        "Hazirlama",
        "25 dk"
      ],
      [
        "Pişirme",
        "20 dk"
      ]
    ],
    "time": "Hazirlama 25 dk · Pişirme 20 dk",
    "ingredients": [
      "150 gr ceviziçi",
      "15 gr hindistan cevizi şekeri",
      "20 gr tereyağ",
      "10 dal fesleğen",
      "1 küçük boy soğan",
      "3 diş sarımsak",
      "200 gr Freya Gurme Baharatlı Balkabağı",
      "200 gr krema",
      "200 ml tavuk ya da sebze suyu",
      "100 gr toz parmesan",
      "Tuz karabiber",
      "Tercihe göre bir paket makarna"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "150 gr ceviziçi",
          "15 gr hindistan cevizi şekeri",
          "20 gr tereyağ",
          "10 dal fesleğen",
          "1 küçük boy soğan",
          "3 diş sarımsak",
          "200 gr Freya Gurme Baharatlı Balkabağı",
          "200 gr krema",
          "200 ml tavuk ya da sebze suyu",
          "100 gr toz parmesan",
          "Tuz karabiber",
          "Tercihe göre bir paket makarna"
        ]
      }
    ],
    "steps": [
      "Makarnanızı tavuk ya da sebze suyuyla al dente kıvamına göre pişiriniz",
      "Ceviz içlerini bıçak yardımıyla küçük parçalara bölünüz ve tavaya alınız",
      "Yağ ve hindistan cevizi şekeri ilave ediniz ve kavurmaya devam ediniz",
      "5 yaprak fesleğeni ince ince kıyınız ve cevizlerin içine koyun altını kapatın ve bir kenara alınız",
      "Başka bir tavada ince ince doğradığınız soğanları ve sarımsakları hafif kahverengileşene kadar kavurunuz.",
      "Balkabağı sosunuzu ve kremayı koyunuz ve karıştırınız",
      "Tuz ve karabiberi ekleyiniz",
      "Pişirdiğiniz makarnayı sosun içine koyunuz karıştırınız",
      "Peyniriniz koyunuz",
      "Servis tabağına makarnanızı üzerine ceviz içlerinizi koyarak servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Makarnanızı tavuk ya da sebze suyuyla al dente kıvamına göre pişiriniz",
          "Ceviz içlerini bıçak yardımıyla küçük parçalara bölünüz ve tavaya alınız",
          "Yağ ve hindistan cevizi şekeri ilave ediniz ve kavurmaya devam ediniz",
          "5 yaprak fesleğeni ince ince kıyınız ve cevizlerin içine koyun altını kapatın ve bir kenara alınız",
          "Başka bir tavada ince ince doğradığınız soğanları ve sarımsakları hafif kahverengileşene kadar kavurunuz.",
          "Balkabağı sosunuzu ve kremayı koyunuz ve karıştırınız",
          "Tuz ve karabiberi ekleyiniz",
          "Pişirdiğiniz makarnayı sosun içine koyunuz karıştırınız",
          "Peyniriniz koyunuz",
          "Servis tabağına makarnanızı üzerine ceviz içlerinizi koyarak servis ediniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabakli-makarna",
    "sourceId": "gid://shopify/Article/606080008476",
    "aliases": [
      "baharatli-balkabakli-makarna"
    ]
  },
  {
    "slug": "dragon-heaven-crumble-cake",
    "title": "Dragon Heaven Crumble Cake",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Dragon_Heaven_Crumble_Cake.jpg?v=1712566327",
    "productSlug": "ejder-meyvesi-sosu",
    "product": "Ejder Meyvesi Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "40 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 40 dk",
    "ingredients": [
      "2 yumurta",
      "160 gr yoğurt",
      "160 gr hindistan cevizi şekeri",
      "200 gr un",
      "130 ml sıvıyağ",
      "10 gr kabrtma tozu",
      "10 ml vanilya özütü",
      "250 gr Freya Gurme Ejder Meyvesi sosu",
      "60 gr un",
      "30 gr pudra şekeri",
      "30 gr soğuk tereyağ"
    ],
    "ingredientGroups": [
      {
        "title": "Kek için",
        "items": [
          "2 yumurta",
          "160 gr yoğurt",
          "160 gr hindistan cevizi şekeri",
          "200 gr un",
          "130 ml sıvıyağ",
          "10 gr kabrtma tozu",
          "10 ml vanilya özütü",
          "250 gr Freya Gurme Ejder Meyvesi sosu"
        ]
      },
      {
        "title": "Crumble için",
        "items": [
          "60 gr un",
          "30 gr pudra şekeri",
          "30 gr soğuk tereyağ"
        ]
      }
    ],
    "steps": [
      "Fırınızı alt üst ayarda 180 dereceye getiriniz",
      "Yağ ve şekeri tezgahüstü çırpıcıda 5 dk yüksek hızda çırpınız",
      "Teker teker yumurtaları ekleyiniz",
      "Yoğurt , sıvı yağ ve vanilya özütünü ilave ediniz ve çırpmaya devam ediniz",
      "Kabartma tozunu una ekleyiniz ve karıştırınız",
      "Mikserinizi durdurun unlu karışımı yavaşça yedirerek ekleyiniz",
      "Yağladığınız fırın kabına kel harcınız dökünüz",
      "Üzerine Freya Gurme Ejder meyvesi sosonu dökünüz",
      "Crumble için tüm malzemeleri elinizle karıştırınız ve parçalar halinde sosun üzerine yerleştiriniz",
      "Pişiriniz ve arzuya göre vanilyalı dondurma ile servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınızı alt üst ayarda 180 dereceye getiriniz",
          "Yağ ve şekeri tezgahüstü çırpıcıda 5 dk yüksek hızda çırpınız",
          "Teker teker yumurtaları ekleyiniz",
          "Yoğurt , sıvı yağ ve vanilya özütünü ilave ediniz ve çırpmaya devam ediniz",
          "Kabartma tozunu una ekleyiniz ve karıştırınız",
          "Mikserinizi durdurun unlu karışımı yavaşça yedirerek ekleyiniz",
          "Yağladığınız fırın kabına kel harcınız dökünüz",
          "Üzerine Freya Gurme Ejder meyvesi sosonu dökünüz",
          "Crumble için tüm malzemeleri elinizle karıştırınız ve parçalar halinde sosun üzerine yerleştiriniz",
          "Pişiriniz ve arzuya göre vanilyalı dondurma ile servis ediniz"
        ]
      }
    ],
    "source": "Ejder Meyvesi Soslu Tarifler",
    "sourceBlog": "ejder-meyvesi-soslu-tarifler",
    "sourcePath": "/blogs/ejder-meyvesi-soslu-tarifler/dragon-heaven-crumble-cake",
    "sourceId": "gid://shopify/Article/606130667804",
    "aliases": [
      "dragon-heaven-crumble-cake"
    ]
  },
  {
    "slug": "carkifelek-soslu-somon",
    "title": "Çarkıfelek Soslu Somon",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_soslu_somon.jpg?v=1712564091",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "2 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Bekleme",
        "60 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Bekleme 60 dk",
    "ingredients": [
      "2 parça fileto somon",
      "50 ml Freya Gurme Çarkıfelek Sos",
      "30 ml soya sos, tercihen az tuzlu",
      "30 ml terriyaki sos",
      "1 küçük boy kırmızı soğan küpküp kesilmiş",
      "2 adet jalepeno biber küçük küçük doğranmış",
      "5 gr susam"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 parça fileto somon",
          "50 ml Freya Gurme Çarkıfelek Sos",
          "30 ml soya sos, tercihen az tuzlu",
          "30 ml terriyaki sos",
          "1 küçük boy kırmızı soğan küpküp kesilmiş",
          "2 adet jalepeno biber küçük küçük doğranmış",
          "5 gr susam"
        ]
      }
    ],
    "steps": [
      "Tüm malzemeleri derin bir kabın içerisine alınız ve somonunuzu koyunuz",
      "Üstünü kapatınız ve buzdolabında yaklaşık 1 saat dinlendiriniz",
      "Fırını 180 derece altüst ayara getiriniz",
      "Servis tabağına alınız somonlarınızı koyunuz",
      "Üzerine susam koyarak servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tüm malzemeleri derin bir kabın içerisine alınız ve somonunuzu koyunuz",
          "Üstünü kapatınız ve buzdolabında yaklaşık 1 saat dinlendiriniz",
          "Fırını 180 derece altüst ayara getiriniz",
          "Servis tabağına alınız somonlarınızı koyunuz",
          "Üzerine susam koyarak servis ediniz"
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelek-soslu-somon",
    "sourceId": "gid://shopify/Article/606151115036",
    "aliases": [
      "carkifelek-soslu-somon"
    ]
  },
  {
    "slug": "dragon-heaven-moouse",
    "title": "Dragon Heaven Moouse",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Dragon_Heaven_MOOUSE.jpg?v=1712565893",
    "productSlug": "ejder-meyvesi-sosu",
    "product": "Ejder Meyvesi Sosu",
    "summary": "",
    "serves": "2 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Bekleme",
        "2 saat"
      ]
    ],
    "time": "Hazırlama 5 dk · Bekleme 2 saat",
    "ingredients": [
      "200 gr krema",
      "120 gr şeker",
      "150 gr Freya Gurme Ejder Meyvesi sosu",
      "1 limon kabuğu rendesi",
      "Taze ejder meyvesi"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr krema",
          "120 gr şeker",
          "150 gr Freya Gurme Ejder Meyvesi sosu",
          "1 limon kabuğu rendesi",
          "Taze ejder meyvesi"
        ]
      }
    ],
    "steps": [
      "El mikserinde krema ve şekeri çırpınız",
      "Limon kabuğunu ve sosu ekleyip karıştırınız",
      "İstediğiniz kaplara koyunuz",
      "Buzdolabında 2 saat bekletiniz",
      "Taze ejder meyveleri ile süsleyiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "El mikserinde krema ve şekeri çırpınız",
          "Limon kabuğunu ve sosu ekleyip karıştırınız",
          "İstediğiniz kaplara koyunuz",
          "Buzdolabında 2 saat bekletiniz",
          "Taze ejder meyveleri ile süsleyiniz"
        ]
      }
    ],
    "source": "Ejder Meyvesi Soslu Tarifler",
    "sourceBlog": "ejder-meyvesi-soslu-tarifler",
    "sourcePath": "/blogs/ejder-meyvesi-soslu-tarifler/dragon-heaven-moouse",
    "sourceId": "gid://shopify/Article/606172741916",
    "aliases": [
      "dragon-heaven-moouse"
    ]
  },
  {
    "slug": "yufkali-zencefil-ve-acili-armut-sosu",
    "title": "Yufkalı Zencefil Acılı Armut",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Zencefil_Acili_Armut_yufka.jpg?v=1712646873",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Pişirme 25 dk",
    "ingredients": [
      "4 adet baklavalik yufka",
      "150 gr brie peynir",
      "150 gr Freya Gurme Zencefil ve Acılı Armut Sosu",
      "1 armut",
      "200 ml krema",
      "2 yumurta",
      "Tuz karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "4 adet baklavalik yufka",
          "150 gr brie peynir",
          "150 gr Freya Gurme Zencefil ve Acılı Armut Sosu",
          "1 armut",
          "200 ml krema",
          "2 yumurta",
          "Tuz karabiber"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 180 derece altüst ayara getiriniz",
      "Fırın kabınıza yufkalarınız buruşturarak koyunuz",
      "Peynir ve armutunuzu ince dilimlere ayırınız",
      "Yufkalarınızın arasına koyunuz",
      "Sosunuzu da yufkalarınızın arasına koyunuz",
      "Bir kabın içerisinde yumurtaları çırpınız kremayı koyarak çırpınız",
      "Fırına koyunuz ve üzerleri kızarıncaya kadar yaklaşık 25 dk pişiriniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 180 derece altüst ayara getiriniz",
          "Fırın kabınıza yufkalarınız buruşturarak koyunuz",
          "Peynir ve armutunuzu ince dilimlere ayırınız",
          "Yufkalarınızın arasına koyunuz",
          "Sosunuzu da yufkalarınızın arasına koyunuz",
          "Bir kabın içerisinde yumurtaları çırpınız kremayı koyarak çırpınız",
          "Fırına koyunuz ve üzerleri kızarıncaya kadar yaklaşık 25 dk pişiriniz"
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/yufkali-zencefil-ve-acili-armut-sosu",
    "sourceId": "gid://shopify/Article/606190895388",
    "aliases": [
      "yufkali-zencefil-ve-acili-armut-sosu"
    ]
  },
  {
    "slug": "zencefil-acili-armut-sos-ve-kuru-et-tabagi",
    "title": "Zencefil & Acılı Armut Sos ve Kuru Et Tabağı",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/zencefil_acili_armut_sarkuteri_tabagi.jpg?v=1712563715",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [],
    "ingredientGroups": [],
    "steps": [
      "Zencefil & Acılı Armut sos kuru et tabaklarına ve şaraba mükemmel eşlik ediyor. Sizde dilediğiniz kuru etlerle evinizde kolaylıkla hazırlayabilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Zencefil & Acılı Armut sos kuru et tabaklarına ve şaraba mükemmel eşlik ediyor. Sizde dilediğiniz kuru etlerle evinizde kolaylıkla hazırlayabilirsiniz."
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/zencefil-acili-armut-sos-ve-kuru-et-tabagi",
    "sourceId": "gid://shopify/Article/606197448988",
    "aliases": [
      "zencefil-acili-armut-sos-ve-kuru-et-tabagi"
    ]
  },
  {
    "slug": "pancar-dip",
    "title": "Pancar Dip",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/pancar_dip.jpg?v=1712564170",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "8-10 kisilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 10 dk",
    "ingredients": [
      "Küçük boy kırmızı soğan",
      "250 gr yoğurt",
      "150 gr Freya Gurme Pancar Havlıcan sos",
      "60 gr ince kıyılmış dereotu",
      "Yeterine tuz",
      "İsteğe göre kokteyl siyah zeytin veya küçük ceviz parçalarıyla süsleyebilirsiniz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Küçük boy kırmızı soğan",
          "250 gr yoğurt",
          "150 gr Freya Gurme Pancar Havlıcan sos",
          "60 gr ince kıyılmış dereotu",
          "Yeterine tuz",
          "İsteğe göre kokteyl siyah zeytin veya küçük ceviz parçalarıyla süsleyebilirsiniz"
        ]
      }
    ],
    "steps": [
      "Soğanı küp küp doğrayınız",
      "Derin bir kasenin içerisine tüm malzemeleri karıştırınız",
      "İstediğiniz servise koyunuz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Soğanı küp küp doğrayınız",
          "Derin bir kasenin içerisine tüm malzemeleri karıştırınız",
          "İstediğiniz servise koyunuz"
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/pancar-dip",
    "sourceId": "gid://shopify/Article/606208262428",
    "aliases": [
      "pancar-dip"
    ]
  },
  {
    "slug": "cilek-jalepeno-peynir-tabagi",
    "title": "Çilek & Jalepeno Peynir Tabağı",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/cilek_jalepeno_peynir_tabagi.jpg?v=1712563915",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [],
    "ingredientGroups": [],
    "steps": [
      "Dilediğiniz peynirlerle kolaylıkla hazırlayabilirsiniz.",
      "Özellikle brie peynirine mükemmel eşlik ediyor."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Dilediğiniz peynirlerle kolaylıkla hazırlayabilirsiniz.",
          "Özellikle brie peynirine mükemmel eşlik ediyor."
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/cilek-jalepeno-peynir-tabagi",
    "sourceId": "gid://shopify/Article/606236803356",
    "aliases": [
      "cilek-jalepeno-peynir-tabagi"
    ]
  },
  {
    "slug": "visne-salsa-bolognese",
    "title": "Vişne & Salsa Spagetti Bolognese",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230266.jpg?v=1701612785",
    "productSlug": "visne-salsa-sosu",
    "product": "Vişne & Salsa Sosu",
    "summary": "",
    "serves": "4-6 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "35 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 35 dk",
    "ingredients": [
      "300 gr kıyma",
      "1 orta boy soğan",
      "500 gr makarna",
      "250 gr Freya Gurme Vişne Salsa sosu",
      "Yeterince tuz ve karabiber",
      "Zeytinyağ"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "300 gr kıyma",
          "1 orta boy soğan",
          "500 gr makarna",
          "250 gr Freya Gurme Vişne Salsa sosu",
          "Yeterince tuz ve karabiber",
          "Zeytinyağ"
        ]
      }
    ],
    "steps": [
      "Bir tavanın içerisine zeytinyağ koyunuz",
      "Küpküp doğradığınız soğanları koyunuz ve pembeleşinceye kadar kavurunuz",
      "Kıymanızı ilave ediniz ve kavurunuz",
      "Diğer bir tencerede makarnanızı 9 dk haşlayınız",
      "Kavurduğunuz kıymanıza Freya Gurme Vişne Salsa sosunuzu koyunuz ve makarnanınızı da ilave edip karıştırınız",
      "İstediğiniz şekilde servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Bir tavanın içerisine zeytinyağ koyunuz",
          "Küpküp doğradığınız soğanları koyunuz ve pembeleşinceye kadar kavurunuz",
          "Kıymanızı ilave ediniz ve kavurunuz",
          "Diğer bir tencerede makarnanızı 9 dk haşlayınız",
          "Kavurduğunuz kıymanıza Freya Gurme Vişne Salsa sosunuzu koyunuz ve makarnanınızı da ilave edip karıştırınız",
          "İstediğiniz şekilde servis ediniz"
        ]
      }
    ],
    "source": "Vişne & Salsa Soslu Tarifler",
    "sourceBlog": "visne-salsa-soslu-tarifler",
    "sourcePath": "/blogs/visne-salsa-soslu-tarifler/visne-salsa-bolognese",
    "sourceId": "gid://shopify/Article/606239719708",
    "aliases": [
      "visne-salsa-bolognese"
    ]
  },
  {
    "slug": "baharatli-balkabagi-dip",
    "title": "Baharatlı Balkabaklı Dip",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/baharatli_balkabakli_dip.jpg?v=1712563624",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ]
    ],
    "time": "Hazırlama 5 dk",
    "ingredients": [
      "200 gr krem peynir",
      "50 gr Freya Gurme Baharatlı Balkabağı sosu",
      "15 gr ayıklanmış ayçekirdeği"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr krem peynir",
          "50 gr Freya Gurme Baharatlı Balkabağı sosu",
          "15 gr ayıklanmış ayçekirdeği"
        ]
      }
    ],
    "steps": [
      "Peynir ve sosu el blenderında pürüzsüz kıvam alıncaya kadar karıştırınız",
      "Çekirdekleriniz bıçak yardımıyla küçültünüz ve sosun üzerine serpiniz",
      "İstediğiniz krakerlerle servis edebilirsiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Peynir ve sosu el blenderında pürüzsüz kıvam alıncaya kadar karıştırınız",
          "Çekirdekleriniz bıçak yardımıyla küçültünüz ve sosun üzerine serpiniz",
          "İstediğiniz krakerlerle servis edebilirsiniz"
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-dip",
    "sourceId": "gid://shopify/Article/606246764828",
    "aliases": [
      "baharatli-balkabagi-dip"
    ]
  },
  {
    "slug": "kremali-visne-iskin-pasta",
    "title": "Kremalı Vişne Işkın Pasta",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230013_1.jpg?v=1702030313",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "40 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 40 dk",
    "ingredients": [
      "370 ml süt",
      "3 yumurta sarısı",
      "25 gr tereyağ",
      "80 gr tozşeker",
      "20 gr un",
      "20 gr nişasta",
      "20 ml vanilya özütü",
      "3 adet baklavalık yufka",
      "10 gr erimiş tereyağ",
      "250 gr Freya Gurme Vişne Işkınotu sosu"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "370 ml süt",
          "3 yumurta sarısı",
          "25 gr tereyağ",
          "80 gr tozşeker",
          "20 gr un",
          "20 gr nişasta",
          "20 ml vanilya özütü",
          "3 adet baklavalık yufka",
          "10 gr erimiş tereyağ",
          "250 gr Freya Gurme Vişne Işkınotu sosu"
        ]
      }
    ],
    "steps": [
      "süt ve tereyağı bir tencerenin içerisine alınız ve kaynatmaya başlayınız",
      "Ayrı bir kapta şeker ve yumurtayı çırpınız",
      "Un, nişasta ve vanilya özütünü ilave edip çırpmaya devam ediniz",
      "Sütün yarısını karışıma koyunuz ve iyice karıştırınız",
      "Sonra kalan sütü ilave ediniz ve karıştırmaya devam ediniz",
      "Kremayı tekrar ocağa alınız ve 5 dk kadar karıştırarak pişiriniz",
      "Fırınızı 200 derece altüst ayara getiriniz",
      "Yufkalarınızı şeritler halinde kesiniz ve terayağı koyarak servis edeceğiniz kaba koyarak fırına veriniz",
      "10-12 dk kadar pişiriniz",
      "Üzerine kremanızı onun üzerinede Vişne Işkın sosunuzu koyarak servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "Pastacı kreması yapmak için",
        "items": [
          "süt ve tereyağı bir tencerenin içerisine alınız ve kaynatmaya başlayınız",
          "Ayrı bir kapta şeker ve yumurtayı çırpınız",
          "Un, nişasta ve vanilya özütünü ilave edip çırpmaya devam ediniz",
          "Sütün yarısını karışıma koyunuz ve iyice karıştırınız",
          "Sonra kalan sütü ilave ediniz ve karıştırmaya devam ediniz",
          "Kremayı tekrar ocağa alınız ve 5 dk kadar karıştırarak pişiriniz",
          "Fırınızı 200 derece altüst ayara getiriniz",
          "Yufkalarınızı şeritler halinde kesiniz ve terayağı koyarak servis edeceğiniz kaba koyarak fırına veriniz",
          "10-12 dk kadar pişiriniz",
          "Üzerine kremanızı onun üzerinede Vişne Işkın sosunuzu koyarak servis ediniz"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/kremali-visne-iskin-pasta",
    "sourceId": "gid://shopify/Article/606259904796",
    "aliases": [
      "kremali-visne-iskin-pasta"
    ]
  },
  {
    "slug": "visne-iskin-bite",
    "title": "Vişne Işkın Vegan Bite",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/VISNE_ISKIN_BITE.jpg?v=1712563023",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "30 dk"
      ]
    ],
    "time": "Hazırlama 30 dk",
    "ingredients": [
      "200 gr Freya Gurme Vişne Işkın sos",
      "45 gr chia",
      "20 ml akçaağaç şurubu",
      "180 gr vegan bitter çikolata",
      "10 gr hindistan cevizi yağı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr Freya Gurme Vişne Işkın sos",
          "45 gr chia",
          "20 ml akçaağaç şurubu",
          "180 gr vegan bitter çikolata",
          "10 gr hindistan cevizi yağı"
        ]
      }
    ],
    "steps": [
      "Chia , şurup ve sosunuzu karıştırınız",
      "Buzlukda 10 dk kıvam almasını bekleyiniz",
      "Çikolatanın içerisine hindistan cevizi yağı koyarak benmari usulü eritiniz",
      "Buzluktan çıkardığınız sosunuzu istediğiniz şekil vererek çikolatanın içerisine batırınız",
      "Daha sonra buzluğa tekrar koyunuz",
      "Servis edeceğiniz zamandan 5-10 dk öne çıkartınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Chia , şurup ve sosunuzu karıştırınız",
          "Buzlukda 10 dk kıvam almasını bekleyiniz",
          "Çikolatanın içerisine hindistan cevizi yağı koyarak benmari usulü eritiniz",
          "Buzluktan çıkardığınız sosunuzu istediğiniz şekil vererek çikolatanın içerisine batırınız",
          "Daha sonra buzluğa tekrar koyunuz",
          "Servis edeceğiniz zamandan 5-10 dk öne çıkartınız"
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskin-bite",
    "sourceId": "gid://shopify/Article/606293590300",
    "aliases": [
      "visne-iskin-bite"
    ]
  },
  {
    "slug": "tatli-patatesli-krostini",
    "title": "Tatlı Patatesli Crostini",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230155_1.jpg?v=1702637586",
    "productSlug": "",
    "product": "Yılbaşı Karışımı",
    "summary": "",
    "serves": "4-6 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 25 dk",
    "ingredients": [
      "2 büyük tatlı patates",
      "Zeytinyağ",
      "Tuz karabiber",
      "100 gr Freya Gurme Yılbaşı Karışımı",
      "Krem peynir"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 büyük tatlı patates",
          "Zeytinyağ",
          "Tuz karabiber",
          "100 gr Freya Gurme Yılbaşı Karışımı",
          "Krem peynir"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 200 derece altüst ayara getiriniz",
      "Patatesleri halka biçiminde doğrayınız",
      "Zeytinyağ, tuz ve karabiber dökün ve patatesleri iyice karıştırınız",
      "Fırın tepsisine alınız ve 20-25 dk fırınlayınız",
      "Çıkardıktan sonra üzerine önce krem peynir sonra",
      "Freya Gurme Yılbaşı Karışımını sürünüz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 200 derece altüst ayara getiriniz",
          "Patatesleri halka biçiminde doğrayınız",
          "Zeytinyağ, tuz ve karabiber dökün ve patatesleri iyice karıştırınız",
          "Fırın tepsisine alınız ve 20-25 dk fırınlayınız",
          "Çıkardıktan sonra üzerine önce krem peynir sonra",
          "Freya Gurme Yılbaşı Karışımını sürünüz"
        ]
      }
    ],
    "source": "Yılbaşı Karışımı Tarifler",
    "sourceBlog": "yilbasi-karisimi-tarifleri",
    "sourcePath": "/blogs/yilbasi-karisimi-tarifleri/tatli-patatesli-krostini",
    "sourceId": "gid://shopify/Article/606293655836",
    "aliases": [
      "tatli-patatesli-krostini"
    ]
  },
  {
    "slug": "visne-salsa-taco",
    "title": "Vişne & Salsa Taco",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230199.jpg?v=1702974385",
    "productSlug": "visne-salsa-sosu",
    "product": "Vişne & Salsa Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [],
    "ingredientGroups": [],
    "steps": [
      "Dilediğiniz taco malzemesiyle evinizde kolaylıkla hazırlayabilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Dilediğiniz taco malzemesiyle evinizde kolaylıkla hazırlayabilirsiniz."
        ]
      }
    ],
    "source": "Vişne & Salsa Soslu Tarifler",
    "sourceBlog": "visne-salsa-soslu-tarifler",
    "sourcePath": "/blogs/visne-salsa-soslu-tarifler/visne-salsa-taco",
    "sourceId": "gid://shopify/Article/606309482780",
    "aliases": [
      "visne-salsa-taco"
    ]
  },
  {
    "slug": "carkifelek-granola",
    "title": "Çarkıfelek & Granola",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_soslu_granola.jpg?v=1712563326",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [],
    "ingredientGroups": [],
    "steps": [
      "Dilediğiniz malzemelerle evinizde kolaylıkla hazırlayabilisiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Dilediğiniz malzemelerle evinizde kolaylıkla hazırlayabilisiniz."
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelek-granola",
    "sourceId": "gid://shopify/Article/606309515548",
    "aliases": [
      "carkifelek-granola"
    ]
  },
  {
    "slug": "baharatli-balkabakli-islak-kek",
    "title": "Baharatlı Balkabaklı Islak Kek",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/baharatli_balkabakli_islak_kek.jpg?v=1712562836",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "30 dk"
      ],
      [
        "Pişirme",
        "35 dk"
      ]
    ],
    "time": "Hazırlama 30 dk · Pişirme 35 dk",
    "ingredients": [
      "4 yumurta",
      "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
      "300 gr hindistan cevizi şekeri",
      "240 ml yağ",
      "1 çay kaşığı vanilya özütü",
      "280 gr un",
      "10 gr kabartma tozu",
      "1 çay kaşığı karbonat",
      "3-4 damla limon",
      "180 gr krem peynir",
      "80 gr pudra şekeri",
      "10 gr vanilya",
      "10 gr mısır nişastası"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "4 yumurta",
          "250 gr Freya Gurme Baharatlı Balkabağı Sosu",
          "300 gr hindistan cevizi şekeri",
          "240 ml yağ",
          "1 çay kaşığı vanilya özütü",
          "280 gr un",
          "10 gr kabartma tozu",
          "1 çay kaşığı karbonat",
          "3-4 damla limon",
          "180 gr krem peynir",
          "80 gr pudra şekeri",
          "10 gr vanilya",
          "10 gr mısır nişastası"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 180 derece altüst ayara getiriniz",
      "Tezgahüstü mikserde yumurta ve şekeri 10 dk çırpınız",
      "Balkabağı sosunuzu, yağınızı ve vanilya özütü koyunuz ve karıştırmaya devam ediniz",
      "Mikserinizin ayarını düşürünüz ve un, kabartma tozu, karbonatı ekleyip karıştırınız",
      "El blenderında krem peynir, pudra şekeri, mısır nişastası ve vanilyayı homojen kıvam alıncaya kadar çırpınız",
      "Kek kalıbınıza önce hamurunuzu sonra peynir sosunu ilave ediniz",
      "Bıçak yardımıyla şekil veriniz",
      "30 dk pişiriniz",
      "Ilık bir şekilde servis etmenizi öneririz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 180 derece altüst ayara getiriniz",
          "Tezgahüstü mikserde yumurta ve şekeri 10 dk çırpınız",
          "Balkabağı sosunuzu, yağınızı ve vanilya özütü koyunuz ve karıştırmaya devam ediniz",
          "Mikserinizin ayarını düşürünüz ve un, kabartma tozu, karbonatı ekleyip karıştırınız",
          "El blenderında krem peynir, pudra şekeri, mısır nişastası ve vanilyayı homojen kıvam alıncaya kadar çırpınız",
          "Kek kalıbınıza önce hamurunuzu sonra peynir sosunu ilave ediniz",
          "Bıçak yardımıyla şekil veriniz",
          "30 dk pişiriniz",
          "Ilık bir şekilde servis etmenizi öneririz."
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabakli-islak-kek",
    "sourceId": "gid://shopify/Article/606422565148",
    "aliases": [
      "baharatli-balkabakli-islak-kek"
    ]
  },
  {
    "slug": "carkifelek-soslu-karides-salata",
    "title": "Çarkıfelek Soslu Karides Salata",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/carkifelek_karides_salata.jpg?v=1712562210",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "350 g karışık akdeniz yeşillikleri",
      "100 g karides",
      "45 g Zeytinyağ",
      "30 g Freya Gurme Çarkıfelek",
      "25 g avakado",
      "25 g kurutulmuş edamame",
      "10 g Hardal",
      "15 g tuz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "350 g karışık akdeniz yeşillikleri",
          "100 g karides",
          "45 g Zeytinyağ",
          "30 g Freya Gurme Çarkıfelek",
          "25 g avakado",
          "25 g kurutulmuş edamame",
          "10 g Hardal",
          "15 g tuz"
        ]
      }
    ],
    "steps": [
      "Karidesleri zeytinyağ ve tuzla soteleyiniz.",
      "Bir kaba tüm yeşillikleri alınız. Sırasıyla salata malzemelerini koyunuz.",
      "Salata sosu için minik bir kapta zeytinyağ, hardal, çarkıfelek sos ve tuzu karıştırınız.",
      "Sosu salatanızın üzerine ekleyiniz.",
      "Dilerseniz besin değerini arttırmak için kinoa ya da siyah pirinç de ekleyebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Karidesleri zeytinyağ ve tuzla soteleyiniz.",
          "Bir kaba tüm yeşillikleri alınız. Sırasıyla salata malzemelerini koyunuz.",
          "Salata sosu için minik bir kapta zeytinyağ, hardal, çarkıfelek sos ve tuzu karıştırınız.",
          "Sosu salatanızın üzerine ekleyiniz.",
          "Dilerseniz besin değerini arttırmak için kinoa ya da siyah pirinç de ekleyebilirsiniz."
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelek-soslu-karides-salata",
    "sourceId": "gid://shopify/Article/606665048348",
    "aliases": [
      "carkifelek-soslu-karides-salata"
    ]
  },
  {
    "slug": "visne-iskin-fistik-krokan",
    "title": "Vişne Işkın & Fıstık Krokan",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230075_1.jpg?v=1712739091",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "6-8 kisilik",
    "times": [
      [
        "Hazırlanma",
        "20 dk"
      ]
    ],
    "time": "Hazırlanma 20 dk",
    "ingredients": [
      "200 gr seker",
      "85 gr fıstık içi",
      "100 gr Vişne Işkın Sos"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr seker",
          "85 gr fıstık içi",
          "100 gr Vişne Işkın Sos"
        ]
      }
    ],
    "steps": [
      "Şekeri tavaya koyunuz",
      "Karamelize oluncaya kadar orta kısık ateşte çeviriniz",
      "Karemelize olmaya başlayınca fıstık içlerinizi atınız ve çok hızlı şekilde karıştırınız",
      "Fırın kağıdının üzerine seriniz başka bir fırın kağıdını üzerine koyunuz ve merdane yardımıyla inceltiniz",
      "İstediğiniz şekilde kesebilirsiniz ."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Şekeri tavaya koyunuz",
          "Karamelize oluncaya kadar orta kısık ateşte çeviriniz",
          "Karemelize olmaya başlayınca fıstık içlerinizi atınız ve çok hızlı şekilde karıştırınız",
          "Fırın kağıdının üzerine seriniz başka bir fırın kağıdını üzerine koyunuz ve merdane yardımıyla inceltiniz",
          "İstediğiniz şekilde kesebilirsiniz ."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskin-fistik-krokan",
    "sourceId": "gid://shopify/Article/606764892444",
    "aliases": [
      "visne-iskin-fistik-krokan"
    ]
  },
  {
    "slug": "zencefil-acili-armut-soslu-cheesecake",
    "title": "Zencefil Acılı Armut Soslu Cheesecake",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230032.jpg?v=1713294601",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "1 saat"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 1 saat",
    "ingredients": [
      "2 paket yulaflı bisküvi",
      "125 gr eritilmiş soğutulmuş tereyağ",
      "3 yumurta",
      "600 gr krem peynir",
      "200 gr krema",
      "250 gr Freya Gurme Zencefil Acılı Armut",
      "165 gr toz şeker",
      "30 gr un",
      "30 gr nişasta",
      "1 çay kaşığı vanilya özütü",
      "1 limon rendesi"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 paket yulaflı bisküvi",
          "125 gr eritilmiş soğutulmuş tereyağ",
          "3 yumurta",
          "600 gr krem peynir",
          "200 gr krema",
          "250 gr Freya Gurme Zencefil Acılı Armut",
          "165 gr toz şeker",
          "30 gr un",
          "30 gr nişasta",
          "1 çay kaşığı vanilya özütü",
          "1 limon rendesi"
        ]
      }
    ],
    "steps": [
      "Fırınınızın içine bir kase su koyunuz ve 180 derece altüst moduna getiriniz",
      "Rondoda bisküvilerinizi ekmek kırıntısı olacak şekilde çırpınız",
      "Tereyağı üzerine dökünüz ve hamur kıvamı alıncaya kadar karıştırınız",
      "Cheesecake kabınıza koyunuz ve bir tarafa alınız",
      "Tezgahüstü çırpıcıda krem peynir ve kremayı pürüzsüz kıvam alıncaya kadar karıştırınız",
      "Şekeri ilave ediniz ve karıştırmaya devam ediniz",
      "Çırpıcının gücünü düşürünüz ve teker teker yumurtaları ilave ediniz",
      "Çırpıcıyı kapatınız ve diğer malzemeleri koyunuz ve spatula yardımı ile karıştırınız",
      "Bisküvi karışımınızın üzerine koyunuz ve fırına koyunuz",
      "30 dk boyunca 180 derecede pişiriniz",
      "Sonra dereceyi 150 ye getiriniz ve 30 dk daha pişirniz",
      "Piştikten sonra fırının kapağını açınız ve içinde ılımaya bırakınız",
      "İstediğiniz mevsim meyveleriyle süsleyip servis yapabilirsiniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızın içine bir kase su koyunuz ve 180 derece altüst moduna getiriniz",
          "Rondoda bisküvilerinizi ekmek kırıntısı olacak şekilde çırpınız",
          "Tereyağı üzerine dökünüz ve hamur kıvamı alıncaya kadar karıştırınız",
          "Cheesecake kabınıza koyunuz ve bir tarafa alınız",
          "Tezgahüstü çırpıcıda krem peynir ve kremayı pürüzsüz kıvam alıncaya kadar karıştırınız",
          "Şekeri ilave ediniz ve karıştırmaya devam ediniz",
          "Çırpıcının gücünü düşürünüz ve teker teker yumurtaları ilave ediniz",
          "Çırpıcıyı kapatınız ve diğer malzemeleri koyunuz ve spatula yardımı ile karıştırınız",
          "Bisküvi karışımınızın üzerine koyunuz ve fırına koyunuz",
          "30 dk boyunca 180 derecede pişiriniz",
          "Sonra dereceyi 150 ye getiriniz ve 30 dk daha pişirniz",
          "Piştikten sonra fırının kapağını açınız ve içinde ılımaya bırakınız",
          "İstediğiniz mevsim meyveleriyle süsleyip servis yapabilirsiniz"
        ]
      }
    ],
    "source": "Zencefil Acılı Armut Soslu Tarifler",
    "sourceBlog": "zencefil-acili-armut-soslu-tarifler",
    "sourcePath": "/blogs/zencefil-acili-armut-soslu-tarifler/zencefil-acili-armut-soslu-cheesecake",
    "sourceId": "gid://shopify/Article/606787895580",
    "aliases": [
      "zencefil-acili-armut-soslu-cheesecake"
    ]
  },
  {
    "slug": "zencefil-acili-armut-soslu-sandvic",
    "title": "Zencefil Acılı Armut Soslu Sandviç",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230288_1.jpg?v=1713295880",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Pişirme",
        "15 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Pişirme 15 dk",
    "ingredients": [
      "İsteğe göre iki dilim ekmek",
      "3 dilim isteğe göre soğuk et",
      "3 dilim kırmızı cheddar peynir",
      "1 küçük soğan",
      "İsteğe göre yeşillik",
      "20 gr Freya Gurme Zencefili Acılı Armut sosu",
      "Freya Gurme Acılı zeytinyağ",
      "Ayçiçek yağı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "İsteğe göre iki dilim ekmek",
          "3 dilim isteğe göre soğuk et",
          "3 dilim kırmızı cheddar peynir",
          "1 küçük soğan",
          "İsteğe göre yeşillik",
          "20 gr Freya Gurme Zencefili Acılı Armut sosu",
          "Freya Gurme Acılı zeytinyağ",
          "Ayçiçek yağı"
        ]
      }
    ],
    "steps": [
      "Soğanı ay şeklinde doğrayınız ve kızgın ayçiçek yağının içerisinde kızartınız ve bir kenara alınız",
      "Tavanıza FreyaGurme Acılı zeytinyağ koyunuz ve ekmekleriniz ısıtmaya başlayınız",
      "Arzunuza göre iç malzemeleri koyunuz",
      "FreyaGurme Zencefil Acılı Armut sosunuzu etinizin üzerine koyunuz ve ekmeği üst üste koyunuz",
      "Tavada her iki tarafıda kahverengi olacak şekilde çeviriniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Soğanı ay şeklinde doğrayınız ve kızgın ayçiçek yağının içerisinde kızartınız ve bir kenara alınız",
          "Tavanıza FreyaGurme Acılı zeytinyağ koyunuz ve ekmekleriniz ısıtmaya başlayınız",
          "Arzunuza göre iç malzemeleri koyunuz",
          "FreyaGurme Zencefil Acılı Armut sosunuzu etinizin üzerine koyunuz ve ekmeği üst üste koyunuz",
          "Tavada her iki tarafıda kahverengi olacak şekilde çeviriniz"
        ]
      }
    ],
    "source": "Zencefil Acılı Armut Soslu Tarifler",
    "sourceBlog": "zencefil-acili-armut-soslu-tarifler",
    "sourcePath": "/blogs/zencefil-acili-armut-soslu-tarifler/zencefil-acili-armut-soslu-sandvic",
    "sourceId": "gid://shopify/Article/606787961116",
    "aliases": [
      "zencefil-acili-armut-soslu-sandvic"
    ]
  },
  {
    "slug": "carkifelek-dip",
    "title": "Çarkıfelek Dip",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230282.jpg?v=1713296496",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "2-4 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 10 dk",
    "ingredients": [
      "1 küçük boy kırmızı soğan",
      "70 gr Freya Gurme Çarkıfelek sos",
      "20 gr hardal",
      "1 avokado",
      "10 gr taze kişniş",
      "10 gr toz parmesan"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 küçük boy kırmızı soğan",
          "70 gr Freya Gurme Çarkıfelek sos",
          "20 gr hardal",
          "1 avokado",
          "10 gr taze kişniş",
          "10 gr toz parmesan"
        ]
      }
    ],
    "steps": [
      "Soğanları küpküp küçük şekilde doğrayınız",
      "Avokado eziniz ve soğanları içine koyunuz",
      "Diğer malzemeleride koyunuz ve iyice karıştırınız."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Soğanları küpküp küçük şekilde doğrayınız",
          "Avokado eziniz ve soğanları içine koyunuz",
          "Diğer malzemeleride koyunuz ve iyice karıştırınız."
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/carkifelek-dip",
    "sourceId": "gid://shopify/Article/606788092188",
    "aliases": [
      "carkifelek-dip"
    ]
  },
  {
    "slug": "pancar-havlicanli-toplar",
    "title": "Pancar Havlıcan Topları",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230012.jpg?v=1713296921",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "20 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 20 dk",
    "ingredients": [
      "500 gr karnabahar çiçek kısmı",
      "250 gr Freya Gurme Pancar Havlıcan",
      "havlıcan sos",
      "200 gr keçi peyniri",
      "50 gr un",
      "1 bağ maydanoz kıyılmış",
      "250 gr süzme yoğurt",
      "20 gr dereotu",
      "2 diş sarımsak",
      "Tuz karabiber",
      "2 yumurta",
      "Yeterince panko",
      "Kızarmalık yağ"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "500 gr karnabahar çiçek kısmı",
          "250 gr Freya Gurme Pancar Havlıcan",
          "havlıcan sos",
          "200 gr keçi peyniri",
          "50 gr un",
          "1 bağ maydanoz kıyılmış",
          "250 gr süzme yoğurt",
          "20 gr dereotu",
          "2 diş sarımsak",
          "Tuz karabiber",
          "2 yumurta",
          "Yeterince panko",
          "Kızarmalık yağ"
        ]
      }
    ],
    "steps": [
      "Karnabahar rondoda küçük parçalar olana kadar çekiniz",
      "Pancar sosunuzu, peyniri, unu ve maydanozu ekleyip karıştırınız ve top şeklini veriniz",
      "Yumurtaları kırınız ve karıştırıp bir kasenin içine alınız diğer bir kaseye de panko koyunuz",
      "Kızarttığınız yağın içerisine toplarınızı atınız",
      "Bir kasenin içerisine yoğurdunuzu özeyiniz",
      "Ezdiğiniz sarımsak, dereotu ve tuz ekleyip yoğurtunuza koyunuz ve karıştırınız",
      "Kızarttığınız Pancar havlıcan toplarınız yoğurt dip ile servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Karnabahar rondoda küçük parçalar olana kadar çekiniz",
          "Pancar sosunuzu, peyniri, unu ve maydanozu ekleyip karıştırınız ve top şeklini veriniz",
          "Yumurtaları kırınız ve karıştırıp bir kasenin içine alınız diğer bir kaseye de panko koyunuz",
          "Kızarttığınız yağın içerisine toplarınızı atınız",
          "Bir kasenin içerisine yoğurdunuzu özeyiniz",
          "Ezdiğiniz sarımsak, dereotu ve tuz ekleyip yoğurtunuza koyunuz ve karıştırınız",
          "Kızarttığınız Pancar havlıcan toplarınız yoğurt dip ile servis edebilirsiniz."
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlicanli-toplar",
    "sourceId": "gid://shopify/Article/606788124956",
    "aliases": [
      "pancar-havlicanli-toplar"
    ]
  },
  {
    "slug": "cilek-jalepeno-peynir-kraker",
    "title": "Çilek Jalepeno & Peynir Kraker",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya-14.10.230225_kopyasi.jpg?v=1713297435",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "20 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 20 dk",
    "ingredients": [
      "175 gr un",
      "140 gr beyaz cheddar",
      "140 gr sarı cheddar",
      "100 gr parmesan",
      "115 gr soğuk tereyağ",
      "Tuz karabiber",
      "1 su bardağı soğuk su"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "175 gr un",
          "140 gr beyaz cheddar",
          "140 gr sarı cheddar",
          "100 gr parmesan",
          "115 gr soğuk tereyağ",
          "Tuz karabiber",
          "1 su bardağı soğuk su"
        ]
      }
    ],
    "steps": [
      "Tüm malzemeyi derin bir kabda karıştırınız",
      "İstenirse biraz daha su ilave edebilirsiniz",
      "Unlu bir yüzeyde hamurunuzu istediğiniz şekilde açınız ve karelere bölünüz",
      "Üzerlerini çatal yardımıyla deliniz",
      "Önceden ıstılmış 200 derece altüst ayarda fırınınızda pişiriniz",
      "Sosluğunuz içerisine çilek jalepeno sosunu koyarak sevis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tüm malzemeyi derin bir kabda karıştırınız",
          "İstenirse biraz daha su ilave edebilirsiniz",
          "Unlu bir yüzeyde hamurunuzu istediğiniz şekilde açınız ve karelere bölünüz",
          "Üzerlerini çatal yardımıyla deliniz",
          "Önceden ıstılmış 200 derece altüst ayarda fırınınızda pişiriniz",
          "Sosluğunuz içerisine çilek jalepeno sosunu koyarak sevis ediniz"
        ]
      }
    ],
    "source": "Şarap Eşlikçileri",
    "sourceBlog": "sarap-eslikcileri",
    "sourcePath": "/blogs/sarap-eslikcileri/cilek-jalepeno-peynir-kraker",
    "sourceId": "gid://shopify/Article/606788157724",
    "aliases": [
      "cilek-jalepeno-peynir-kraker"
    ]
  },
  {
    "slug": "cilek-jalepeno-soslu-kinoa-salata",
    "title": "Çilek Jalepeno Soslu Kinoa Salata",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya_Yeni1968.jpg?v=1713517476",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "4 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dakika"
      ],
      [
        "Pişirme",
        "15 dakika"
      ]
    ],
    "time": "Hazırlama 20 dakika · Pişirme 15 dakika",
    "ingredients": [
      "200 gr kinoa",
      "600 gr tatlı patates",
      "200 gr bebek ıspanak",
      "150 gr Freya Gurme Çilek Jalepeno Sos",
      "2 gr tuz",
      "2 gr karabiber",
      "2 gr kimyon",
      "10 ml limon suyu",
      "10 ml zeytinyağ",
      "40 gr hardal",
      "5 gr susam"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr kinoa",
          "600 gr tatlı patates",
          "200 gr bebek ıspanak",
          "150 gr Freya Gurme Çilek Jalepeno Sos",
          "2 gr tuz",
          "2 gr karabiber",
          "2 gr kimyon",
          "10 ml limon suyu",
          "10 ml zeytinyağ",
          "40 gr hardal",
          "5 gr susam"
        ]
      }
    ],
    "steps": [
      "Kinoayı haşlayınız",
      "Küp küp kesip, tuz, karabiber ve kimyonla harmanladığınız patateslerinizi tavada yumuşuncaya kadar soteleyiniz",
      "Küçük bir tavada susamı kavurunuz ve kenara alınız",
      "Sos kabına limon suyu, tuz, zeytinyağ, Çilek Jalepeno sosunu ve hardalı alıp karıştırınız",
      "Büyük bir salata kasesine ıspanakları, kinoayı ve tatlı patatesleri alıp karıştırınız",
      "Salata sosunu ekleyerek servis ediniz"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Kinoayı haşlayınız",
          "Küp küp kesip, tuz, karabiber ve kimyonla harmanladığınız patateslerinizi tavada yumuşuncaya kadar soteleyiniz",
          "Küçük bir tavada susamı kavurunuz ve kenara alınız",
          "Sos kabına limon suyu, tuz, zeytinyağ, Çilek Jalepeno sosunu ve hardalı alıp karıştırınız",
          "Büyük bir salata kasesine ıspanakları, kinoayı ve tatlı patatesleri alıp karıştırınız",
          "Salata sosunu ekleyerek servis ediniz"
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepeno-soslu-kinoa-salata",
    "sourceId": "gid://shopify/Article/606797037852",
    "aliases": [
      "cilek-jalepeno-soslu-kinoa-salata"
    ]
  },
  {
    "slug": "pancar-havlican-soslu-ezine-peynirli-salata",
    "title": "Pancar Havlıcan Soslu Ezine Peynirli Salata",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9087_3.jpg?v=1716307734",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 10 dk",
    "ingredients": [
      "Freya Gurme Pancar & Havlıcan sos",
      "Freya Gurme Acı Biberli Zeytinyağ",
      "Karışık maskolin",
      "Bebek ispanak",
      "Ezine peyniri",
      "Kavrulmuş ceviz içi",
      "1/2 adet limon",
      "Balzamik sirke",
      "Zeytinyağ"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Freya Gurme Pancar & Havlıcan sos",
          "Freya Gurme Acı Biberli Zeytinyağ",
          "Karışık maskolin",
          "Bebek ispanak",
          "Ezine peyniri",
          "Kavrulmuş ceviz içi",
          "1/2 adet limon",
          "Balzamik sirke",
          "Zeytinyağ"
        ]
      }
    ],
    "steps": [
      "Salata tabağına maskolin ve bebek ıspanakları yerleştiriniz. Üstüne cevizleri ve ezine peynirlerini ekleyiniz. Küçük bir tabakta Pancar & Havlican sosunu, zeytinyağı, limon suyu ve balzamik sirkesini karıştırıp salatanın üstüne döktükten sonra servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Salata tabağına maskolin ve bebek ıspanakları yerleştiriniz. Üstüne cevizleri ve ezine peynirlerini ekleyiniz. Küçük bir tabakta Pancar & Havlican sosunu, zeytinyağı, limon suyu ve balzamik sirkesini karıştırıp salatanın üstüne döktükten sonra servis edebilirsiniz."
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlican-soslu-ezine-peynirli-salata",
    "sourceId": "gid://shopify/Article/606913397020",
    "aliases": [
      "pancar-havlican-soslu-ezine-peynirli-salata"
    ]
  },
  {
    "slug": "zencefil-acili-armut-viski",
    "title": "Zencefil Acılı Armut & Viski",
    "cat": "kokteyl",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9481.jpg?v=1717922224",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlanma",
        "5 dk"
      ]
    ],
    "time": "Hazırlanma 5 dk",
    "ingredients": [
      "5 cl Viski",
      "5 cl Limon Suyu",
      "2,5 cl Şeker Şurubu",
      "20 gr Freya Gurme Zencefil Acılı Armut Sos",
      "1 Yumurta akı",
      "Buz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "5 cl Viski",
          "5 cl Limon Suyu",
          "2,5 cl Şeker Şurubu",
          "20 gr Freya Gurme Zencefil Acılı Armut Sos",
          "1 Yumurta akı",
          "Buz"
        ]
      }
    ],
    "steps": [
      "Yumurtanın akını shakera koyduktan sonra önce buzsuz çalkalayın, 15 saniye sonrasında shakerı açıp buz koyup geri kapatıp tekrar çalkalayın.",
      "Bu şekilde kokteyliniz yumurta kokmaz.",
      "Rafine şeker kullanmak istemezseniz şeker şurubu yerine agave şurubu da kullanabilirsiniz.",
      "Veganlar yumurta yerine bağlayıcılığı sağlamak için nohut suyu kullanabilir."
    ],
    "stepGroups": [
      {
        "title": "Püf noktası ve alternatif öneriler",
        "items": [
          "Yumurtanın akını shakera koyduktan sonra önce buzsuz çalkalayın, 15 saniye sonrasında shakerı açıp buz koyup geri kapatıp tekrar çalkalayın.",
          "Bu şekilde kokteyliniz yumurta kokmaz.",
          "Rafine şeker kullanmak istemezseniz şeker şurubu yerine agave şurubu da kullanabilirsiniz.",
          "Veganlar yumurta yerine bağlayıcılığı sağlamak için nohut suyu kullanabilir."
        ]
      }
    ],
    "source": "Kokteyller",
    "sourceBlog": "kokteyller",
    "sourcePath": "/blogs/kokteyller/zencefil-acili-armut-viski",
    "sourceId": "gid://shopify/Article/607029330204",
    "aliases": [
      "zencefil-acili-armut-viski"
    ],
    "notes": [
      "Püf noktası ve alternatif öneriler"
    ]
  },
  {
    "slug": "maviyemis-lavanta-soslu-saglikli-dondurma",
    "title": "Maviyemiş & Lavanta Soslu Sağlıklı Dondurma",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9275.jpg?v=1726743193",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "2-4 Kişilik",
    "times": [
      [
        "Bekleme",
        "Min 5 saat"
      ],
      [
        "Hazırlama",
        "5 dk"
      ]
    ],
    "time": "Bekleme Min 5 saat · Hazırlama 5 dk",
    "ingredients": [
      "80 gram Freya Gurme Maviyemiş & Lavanta",
      "2 adet dondurulmuş muz dilimleri (1 gece önceden dolaba koyunuz)",
      "10 gram bal",
      "Birkaç damla vanilya özütü (opsiyonel)",
      "Ekstra Maviyemiş & Lavanta, taze yaban mersini ve kuru lavanta"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "80 gram Freya Gurme Maviyemiş & Lavanta",
          "2 adet dondurulmuş muz dilimleri (1 gece önceden dolaba koyunuz)",
          "10 gram bal",
          "Birkaç damla vanilya özütü (opsiyonel)"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "Ekstra Maviyemiş & Lavanta, taze yaban mersini ve kuru lavanta"
        ]
      }
    ],
    "steps": [
      "Önce dondurulmuş muz dilimlerini dondurma kıvamına gelene kadar robotta çekiniz. Bal, Maviyemiş & Lavanta ve vanilyayı ekleyip karışana kadar robotu çekiniz. Hazırladığınız dondurmayı buzdolabında 3 saat bekletiniz. Servis ederken ekstra Maviyemiş & Lavanta sosu taze maviyemiş ve kuru lavanta ekleyip servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Önce dondurulmuş muz dilimlerini dondurma kıvamına gelene kadar robotta çekiniz. Bal, Maviyemiş & Lavanta ve vanilyayı ekleyip karışana kadar robotu çekiniz. Hazırladığınız dondurmayı buzdolabında 3 saat bekletiniz. Servis ederken ekstra Maviyemiş & Lavanta sosu taze maviyemiş ve kuru lavanta ekleyip servis ediniz."
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemis-lavanta-soslu-saglikli-dondurma",
    "sourceId": "gid://shopify/Article/607241273628",
    "aliases": [
      "maviyemis-lavanta-soslu-saglikli-dondurma"
    ]
  },
  {
    "slug": "visne-salsa-keci-peynirli-crostini-1",
    "title": "Vişne Salsa & Keçi Peynirli Crostini",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9249_520x500_1cadf72e-6cb3-4b01-aa34-fa760adad19c.webp?v=1719750459",
    "productSlug": "visne-salsa-sosu",
    "product": "Vişne & Salsa Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "5 Dakika"
      ],
      [
        "Pişirme",
        "7 Dakika"
      ]
    ],
    "time": "Hazırlama 5 Dakika · Pişirme 7 Dakika",
    "ingredients": [
      "1 adet Baget ekmegi",
      "150 gr Keçi Peyniri",
      "200 gr Kuru et",
      "Freya Gurme Acı Biberli Zeytinyağ",
      "100 gr Freya Gurme Vişne Salsa",
      "3 adet taze kekik"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 adet Baget ekmegi",
          "150 gr Keçi Peyniri",
          "200 gr Kuru et",
          "Freya Gurme Acı Biberli Zeytinyağ",
          "100 gr Freya Gurme Vişne Salsa",
          "3 adet taze kekik"
        ]
      }
    ],
    "steps": [
      "Fırınınızı 190 derece fanlı ayarda ısıtınız. Baget ekmeğini dilimleyip tepsiye yerleştiriniz. Üstüne fırçayla Freya Gurme Acı Biberli Zeytinyağı sürüp fırına koyunuz. 6-7 dakika kızardıktan sonra biraz soğumasını bekleyiniz ve üstlerine 1’er tatlı kaşığı Freya Gurme Vişne Salsa sosundan sürünüz. Kuru et dilimlerini ve keçi peynirini ekleyiniz. Üzerini taze kekik yapraklarıyla süsleyip servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı 190 derece fanlı ayarda ısıtınız. Baget ekmeğini dilimleyip tepsiye yerleştiriniz. Üstüne fırçayla Freya Gurme Acı Biberli Zeytinyağı sürüp fırına koyunuz. 6-7 dakika kızardıktan sonra biraz soğumasını bekleyiniz ve üstlerine 1’er tatlı kaşığı Freya Gurme Vişne Salsa sosundan sürünüz. Kuru et dilimlerini ve keçi peynirini ekleyiniz. Üzerini taze kekik yapraklarıyla süsleyip servis ediniz."
        ]
      }
    ],
    "source": "Vişne & Salsa Soslu Tarifler",
    "sourceBlog": "visne-salsa-soslu-tarifler",
    "sourcePath": "/blogs/visne-salsa-soslu-tarifler/visne-salsa-keci-peynirli-crostini-1",
    "sourceId": "gid://shopify/Article/607241863452",
    "aliases": [
      "visne-salsa-keci-peynirli-crostini-1"
    ]
  },
  {
    "slug": "visne-iskin-soslu-cikolatali-tart",
    "title": "Vişne & Işkın Soslu Çikolatalı Tart",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/visne.jpg?v=1726743300",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "8-10 kişilik",
    "times": [
      [
        "Hazırlama",
        "40 dk"
      ],
      [
        "Bekleme",
        "60 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 40 dk · Bekleme 60 dk",
    "ingredients": [
      "( Hepsi oda sıcaklığında olmalı )",
      "85 gr tereyağ",
      "65 gr pudra şekeri",
      "1 adet yumurta",
      "150 gr un",
      "30 gr badem unu",
      "20 gr kakao",
      "350 gr labne",
      "150 gr krema",
      "60 gr pudra şekeri",
      "1 tatlı kaşığı vanilya özütü",
      "200 gram Freya Gurme Vişne & Işkın Sos"
    ],
    "ingredientGroups": [
      {
        "title": "Hamur için",
        "items": [
          "( Hepsi oda sıcaklığında olmalı )",
          "85 gr tereyağ",
          "65 gr pudra şekeri",
          "1 adet yumurta",
          "150 gr un",
          "30 gr badem unu",
          "20 gr kakao"
        ]
      },
      {
        "title": "Dolgu için",
        "items": [
          "350 gr labne",
          "150 gr krema",
          "60 gr pudra şekeri",
          "1 tatlı kaşığı vanilya özütü",
          "200 gram Freya Gurme Vişne & Işkın Sos"
        ]
      }
    ],
    "steps": [
      "Hamuru 1 gece önceden yapıp buzdolabında dinlendiriniz. Tereyağ ve pudra şekerini çırptıktan sonra yumurtayı ekleyip karışana kadar çırpınız. Un, badem unu ve kakaoyu başka bir kapta karıştırdıktan sonra harca ekleyiniz ve hamur haline gelene kadar çırpınız.",
      "Elinizle disk şekline getirip streçleyiniz ve buzdolabında dinlenmeye bırakınız.",
      "2 yağlı kağıt arasında tart kalıbının ölçüsüne göre merdaneyle açtıktan sonra kalıba yerleştiriniz. Çatalla delikler açtıktan sonra buzlukta 1 saat bekletiniz.",
      "Fırını 180 derece fanlı ayarda ısıttıktan sonra tart hamurunu yaklaşık 20-25 dk pişiriniz ve tamamen soğumasını bekleyiniz. Bu sırada peynir, krema, pudra sekeri ve vanilya özütünü pürüzsüz bir kıvama gelene kadar çırpınız ve soğumuş tart hamurunun içine yayınız. Üstüne Vişne & Işkın sosunu döküp biraz daha buzdolabında soğuttuktan sonra servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Hamuru 1 gece önceden yapıp buzdolabında dinlendiriniz. Tereyağ ve pudra şekerini çırptıktan sonra yumurtayı ekleyip karışana kadar çırpınız. Un, badem unu ve kakaoyu başka bir kapta karıştırdıktan sonra harca ekleyiniz ve hamur haline gelene kadar çırpınız.",
          "Elinizle disk şekline getirip streçleyiniz ve buzdolabında dinlenmeye bırakınız.",
          "2 yağlı kağıt arasında tart kalıbının ölçüsüne göre merdaneyle açtıktan sonra kalıba yerleştiriniz. Çatalla delikler açtıktan sonra buzlukta 1 saat bekletiniz.",
          "Fırını 180 derece fanlı ayarda ısıttıktan sonra tart hamurunu yaklaşık 20-25 dk pişiriniz ve tamamen soğumasını bekleyiniz. Bu sırada peynir, krema, pudra sekeri ve vanilya özütünü pürüzsüz bir kıvama gelene kadar çırpınız ve soğumuş tart hamurunun içine yayınız. Üstüne Vişne & Işkın sosunu döküp biraz daha buzdolabında soğuttuktan sonra servis edebilirsiniz."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskin-soslu-cikolatali-tart",
    "sourceId": "gid://shopify/Article/608566346012",
    "aliases": [
      "visne-iskin-soslu-cikolatali-tart"
    ]
  },
  {
    "slug": "cilek-jalepeno-soslu-quesadillas",
    "title": "Çilek & Jalepeno Soslu Quesadillas",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9151.jpg?v=1727369383",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "2-4 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ],
      [
        "Pişirme",
        "8 dk"
      ]
    ],
    "time": "Hazırlama 5 dk · Pişirme 8 dk",
    "ingredients": [
      "2 adet lavaş",
      "200 gr haslanmış ve tiftiklenmiş tavuk göğsü",
      "60 gr rende mozzarella peyniri",
      "90 gr Freya Gurme Çilek & Jalepeno",
      "1 adet lime",
      "Servis için süzme yoğurt"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 adet lavaş",
          "200 gr haslanmış ve tiftiklenmiş tavuk göğsü",
          "60 gr rende mozzarella peyniri",
          "90 gr Freya Gurme Çilek & Jalepeno",
          "1 adet lime",
          "Servis için süzme yoğurt"
        ]
      }
    ],
    "steps": [
      "Tavayı orta ateşte ısıttıktan sonra 1 adet lavaşı yerleştiriniz ve üstüne Freya Gurme Çilek & Jalepeno sosunu yayınız. Tiftiklenmiş tavukları ve rende mozzarellayi ekleyip diğer lavaşı üstüne kapatınız. 3-4 dakika sonra spatula ya da tava kapağı yardımıyla ters çevirip, 3-4 dakika da bu şekilde pişiriniz. Dilimledikten sonra üstüne süzme yoğurt ve lime kabuğu rendesi ekleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tavayı orta ateşte ısıttıktan sonra 1 adet lavaşı yerleştiriniz ve üstüne Freya Gurme Çilek & Jalepeno sosunu yayınız. Tiftiklenmiş tavukları ve rende mozzarellayi ekleyip diğer lavaşı üstüne kapatınız. 3-4 dakika sonra spatula ya da tava kapağı yardımıyla ters çevirip, 3-4 dakika da bu şekilde pişiriniz. Dilimledikten sonra üstüne süzme yoğurt ve lime kabuğu rendesi ekleyiniz."
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepeno-soslu-quesadillas",
    "sourceId": "gid://shopify/Article/608624574748",
    "aliases": [
      "cilek-jalepeno-soslu-quesadillas"
    ]
  },
  {
    "slug": "visne-iskin-soslu-cin-tonik",
    "title": "Vişne & Işkın Soslu Cin Tonik",
    "cat": "kokteyl",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9389_2.jpg?v=1728413230",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ]
    ],
    "time": "Hazırlama 5 dk",
    "ingredients": [
      "Cin 5cl",
      "15 gr Vişne Işkın",
      "1 dilim lime",
      "120 ml tonik",
      "Buz"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Cin 5cl",
          "15 gr Vişne Işkın",
          "1 dilim lime",
          "120 ml tonik",
          "Buz"
        ]
      }
    ],
    "steps": [
      "Hepsini sıralayla shakera koyup karıştırınız.",
      "*Tonik yerine soda da kullanabilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Hepsini sıralayla shakera koyup karıştırınız.",
          "*Tonik yerine soda da kullanabilirsiniz."
        ]
      }
    ],
    "source": "Kokteyller",
    "sourceBlog": "kokteyller",
    "sourcePath": "/blogs/kokteyller/visne-iskin-soslu-cin-tonik",
    "sourceId": "gid://shopify/Article/608624607516",
    "aliases": [
      "visne-iskin-soslu-cin-tonik"
    ]
  },
  {
    "slug": "baharatli-balkabagi-soslu-banana-bread",
    "title": "Baharatlı Balkabağı Soslu Banana Bread",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Freya_2.jpg?v=1727970174",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "50-55 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 50-55 dk",
    "ingredients": [
      "2 yumurta",
      "115 gr oda sıcaklığında yağ",
      "300 gr un",
      "5 gr karbonat",
      "10 ml limon suyu",
      "10 gr kabartma tozu",
      "5 gr tuz",
      "15 ml vanilya özütü",
      "2 büyük olgunlaşmış muz",
      "150 gr Freya Gurme Baharatlı Balkabağı Sos",
      "150 gr Freya Gurme Hindistan Cevizi Şekeri",
      "100 gr bitter damla çikolata"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 yumurta",
          "115 gr oda sıcaklığında yağ",
          "300 gr un",
          "5 gr karbonat",
          "10 ml limon suyu",
          "10 gr kabartma tozu",
          "5 gr tuz",
          "15 ml vanilya özütü",
          "2 büyük olgunlaşmış muz",
          "150 gr Freya Gurme Baharatlı Balkabağı Sos",
          "150 gr Freya Gurme Hindistan Cevizi Şekeri",
          "100 gr bitter damla çikolata"
        ]
      }
    ],
    "steps": [
      "Fırınızı alt üst 180 derecede önceden ısıtınız. Geniş bir kabın içerisinde muzları çatalla eziniz. Yağı, şekeri, unu ekleyip el mikseriyle çırpınız. Yumurtaları ekleyip çırpmaya devam ediniz. Karbonatı bir kaşığa alınız ve limon suyu ekleyip karıştırınız. Sonrasında kek karışımına ekleyiniz. Freya Gurme Baharatlı Balkabağı sosunuzu ilave ettikten sonra tuz, vanilya özütü, kabartma tozunu da ekleyip karıştırınız. İstediğiniz kek kalıbına koyup üzerine damla çikolataları serpiniz. Isıttığınız fırında 50-55 dakika pişiriniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınızı alt üst 180 derecede önceden ısıtınız. Geniş bir kabın içerisinde muzları çatalla eziniz. Yağı, şekeri, unu ekleyip el mikseriyle çırpınız. Yumurtaları ekleyip çırpmaya devam ediniz. Karbonatı bir kaşığa alınız ve limon suyu ekleyip karıştırınız. Sonrasında kek karışımına ekleyiniz. Freya Gurme Baharatlı Balkabağı sosunuzu ilave ettikten sonra tuz, vanilya özütü, kabartma tozunu da ekleyip karıştırınız. İstediğiniz kek kalıbına koyup üzerine damla çikolataları serpiniz. Isıttığınız fırında 50-55 dakika pişiriniz."
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-soslu-banana-bread",
    "sourceId": "gid://shopify/Article/608663830812",
    "aliases": [
      "baharatli-balkabagi-soslu-banana-bread"
    ]
  },
  {
    "slug": "easy-spicy-pumpkin-roll",
    "title": "Easy Spicy Pumpkin Roll",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Layer_1.jpg?v=1729337773",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "6 Kişilik",
    "times": [
      [
        "Hazırlama",
        "35 dk"
      ],
      [
        "Bekleme",
        "150 dk"
      ],
      [
        "Pişirme",
        "40-50 dk"
      ]
    ],
    "time": "Hazırlama 35 dk · Bekleme 150 dk",
    "ingredients": [
      "200 gr un",
      "50 gr çavdar unu",
      "6 gr toz maya",
      "35 gr Freya Gurme Hindistan Cevizi Şekeri",
      "150 ml süt",
      "50 gr tereyağ, erimiş, soğumuş",
      "1 yumurta",
      "200 gr Freya Gurme Baharatlı Balkabağı Sosu",
      "30 gr Freya Gurme Hindistan Cevizi Şekeri"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 gr un",
          "50 gr çavdar unu",
          "6 gr toz maya",
          "35 gr Freya Gurme Hindistan Cevizi Şekeri",
          "150 ml süt",
          "50 gr tereyağ, erimiş, soğumuş",
          "1 yumurta"
        ]
      },
      {
        "title": "İç dolgusu",
        "items": [
          "200 gr Freya Gurme Baharatlı Balkabağı Sosu",
          "30 gr Freya Gurme Hindistan Cevizi Şekeri"
        ]
      }
    ],
    "steps": [
      "Fırınınızı alt üst 180 derecede ısıtınız ve hamuru hazırladığınızda kapatınız",
      "Geniş bir kabın içerisinde kuru malzemeleri karıştırırız",
      "Ortasına çukur açınız ve ıslak malzemeleri koyunuz",
      "Yavaş yavaş karıştırınız",
      "Temiz tezgahın üzerinde hamurunuzu 15-20 dk yoğurunuz",
      "Bir kabın içerisine hamurunuzu alınız ve ısıtılmış fırında üzerine temiz bir mutfak havlusu örterek yaklaşık 1,5 saat bekleyiniz",
      "Tezgahın üzerine un serperek hamurunuzu dikdörtgen şekilde açınız",
      "Freya Gurme Balkabağı sosunuzu üzerine ince bir tabaka şeklinde kenarlarından",
      "3-4 cm uzak mesafede sürünüz ve Freya Gurme Hindistan Cevizi Şekerini serpiniz",
      "Rulo yaparak kapatınız ve 6 eşit parçaya bölünüz",
      "Fırın kabınız içerisine pişirme kağıdını koyunuz ve rolllarınızı yerleştirip üzerine havlu örterek yaklaşık 1 saat daha dinlendirdikten sonra ısıttığınız fırına koyunuz",
      "40-50 dk pişiriniz",
      "Ilık servis yapılmasını öneririz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırınınızı alt üst 180 derecede ısıtınız ve hamuru hazırladığınızda kapatınız",
          "Geniş bir kabın içerisinde kuru malzemeleri karıştırırız",
          "Ortasına çukur açınız ve ıslak malzemeleri koyunuz",
          "Yavaş yavaş karıştırınız",
          "Temiz tezgahın üzerinde hamurunuzu 15-20 dk yoğurunuz",
          "Bir kabın içerisine hamurunuzu alınız ve ısıtılmış fırında üzerine temiz bir mutfak havlusu örterek yaklaşık 1,5 saat bekleyiniz",
          "Tezgahın üzerine un serperek hamurunuzu dikdörtgen şekilde açınız",
          "Freya Gurme Balkabağı sosunuzu üzerine ince bir tabaka şeklinde kenarlarından",
          "3-4 cm uzak mesafede sürünüz ve Freya Gurme Hindistan Cevizi Şekerini serpiniz",
          "Rulo yaparak kapatınız ve 6 eşit parçaya bölünüz",
          "Fırın kabınız içerisine pişirme kağıdını koyunuz ve rolllarınızı yerleştirip üzerine havlu örterek yaklaşık 1 saat daha dinlendirdikten sonra ısıttığınız fırına koyunuz",
          "40-50 dk pişiriniz",
          "Ilık servis yapılmasını öneririz."
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/easy-spicy-pumpkin-roll",
    "sourceId": "gid://shopify/Article/608664977692",
    "aliases": [
      "easy-spicy-pumpkin-roll"
    ]
  },
  {
    "slug": "cilek-jalepeno-thumbprint-cookies",
    "title": "Çilek Jalepeno &Thumbprint Cookies",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9307.jpg?v=1728742976",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Bekleme",
        "60 dk"
      ],
      [
        "Hazırlama",
        "30 dk"
      ]
    ],
    "time": "Bekleme 60 dk · Hazırlama 30 dk",
    "ingredients": [
      "180 gr un",
      "125 gr tereyağ",
      "70 gr esmer şeker",
      "1 adet yumurta sarısı",
      "15 ml vanilya özütü",
      "65 gr Freya Gurme Çilek & Jalepeno"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "180 gr un",
          "125 gr tereyağ",
          "70 gr esmer şeker",
          "1 adet yumurta sarısı",
          "15 ml vanilya özütü",
          "65 gr Freya Gurme Çilek & Jalepeno"
        ]
      }
    ],
    "steps": [
      "Tereyağ ve toz şekeri ortalama 5 dk çırpınız. Yumurta ve vanilyayı ekleyip biraz daha çırpınız sonra unu ekleyiniz ve hamur haline gelene kadar karıştırınız. Ceviz büyüklüğünde parçalar alıp elinizle yuvarlayınız yağlı kağıt serili tepsiye yerleştiriniz. Parmağınızla ya da çay kaşığın arkasıyla kurabiyelerin üzerine bastırarak Çilek Jalepeno sos için yer hazırlayınız. Bu şekilde buzlukta 1 saat bekletiniz. Fırını 180 derece fanlı ayarda ısıtınız. Kurabiyelerin üstüne Çilek & Jalepona sosunu sürünüz sonra fırına tekrar koyunuz ve ortalama 15 dakika daha pişiriniz. Tamamen soğuduktan sonra servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tereyağ ve toz şekeri ortalama 5 dk çırpınız. Yumurta ve vanilyayı ekleyip biraz daha çırpınız sonra unu ekleyiniz ve hamur haline gelene kadar karıştırınız. Ceviz büyüklüğünde parçalar alıp elinizle yuvarlayınız yağlı kağıt serili tepsiye yerleştiriniz. Parmağınızla ya da çay kaşığın arkasıyla kurabiyelerin üzerine bastırarak Çilek Jalepeno sos için yer hazırlayınız. Bu şekilde buzlukta 1 saat bekletiniz. Fırını 180 derece fanlı ayarda ısıtınız. Kurabiyelerin üstüne Çilek & Jalepona sosunu sürünüz sonra fırına tekrar koyunuz ve ortalama 15 dakika daha pişiriniz. Tamamen soğuduktan sonra servis edebilirsiniz."
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepeno-thumbprint-cookies",
    "sourceId": "gid://shopify/Article/608720027932",
    "aliases": [
      "cilek-jalepeno-thumbprint-cookies"
    ]
  },
  {
    "slug": "pancar-havlican-soslu-humus",
    "title": "Pancar Havlıcan Soslu Humus",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9223.jpg?v=1728925968",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 10 dk",
    "ingredients": [
      "400 gr haşlanmış nohut",
      "80 gr Freya Gurme Pancar & Havlıcan",
      "50 gr tahin",
      "35 gr zeytinyağı",
      "2 diş sarımsak",
      "1 adet limon",
      "Tuz",
      "Turp",
      "Dolmalık fıstık",
      "Freya Gurme Acı Biberli Zeytinyağı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "400 gr haşlanmış nohut",
          "80 gr Freya Gurme Pancar & Havlıcan",
          "50 gr tahin",
          "35 gr zeytinyağı",
          "2 diş sarımsak",
          "1 adet limon",
          "Tuz"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "Turp",
          "Dolmalık fıstık",
          "Freya Gurme Acı Biberli Zeytinyağı"
        ]
      }
    ],
    "steps": [
      "Tüm malzemeleri robotta pürüzsüz olana kadar cekiniz.",
      "Gerekirse bir kaç yemek kaşığı su ekleyebilirsiniz.",
      "Servis tabağına aldıktan sonra üstüne turp dilimlerini, turp yaprağını ve çam fıstığını ekleyiniz. En son Freya Gurme Acı Biberli Zeytinyağı gezdirdikten sonra servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Tüm malzemeleri robotta pürüzsüz olana kadar cekiniz.",
          "Gerekirse bir kaç yemek kaşığı su ekleyebilirsiniz.",
          "Servis tabağına aldıktan sonra üstüne turp dilimlerini, turp yaprağını ve çam fıstığını ekleyiniz. En son Freya Gurme Acı Biberli Zeytinyağı gezdirdikten sonra servis edebilirsiniz."
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlican-soslu-humus",
    "sourceId": "gid://shopify/Article/608725172508",
    "aliases": [
      "pancar-havlican-soslu-humus"
    ]
  },
  {
    "slug": "pancar-havlican-milfoy",
    "title": "Pancar Havlıcan Milföy",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A0244.jpg?v=1730213819",
    "productSlug": "pancar-havlican-sosu",
    "product": "Pancar & Havlıcan Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ],
      [
        "Pişirme",
        "25 dk"
      ]
    ],
    "time": "Hazırlama 10 dk · Pişirme 25 dk",
    "ingredients": [
      "4 adet milföy hamuru",
      "300 gr lor peyniri",
      "110 gr Freya Gurme Pancar Havlıcan",
      "1adet yumurta"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "4 adet milföy hamuru",
          "300 gr lor peyniri",
          "110 gr Freya Gurme Pancar Havlıcan"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "1adet yumurta"
        ]
      }
    ],
    "steps": [
      "Milföy hamurlarını birleştiriniz",
      "Merdane yardımıyla açınız",
      "Büyük karelere bölünüz",
      "Her kareye eşit bir şekilde peynir ve Pancar Havlıcan sosu koyunuz",
      "Uçlarından kapatınız. Fırına girmeden üzerine yumurta sürünüz",
      "180 derece fırında 25 dk pişiriz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Milföy hamurlarını birleştiriniz",
          "Merdane yardımıyla açınız",
          "Büyük karelere bölünüz",
          "Her kareye eşit bir şekilde peynir ve Pancar Havlıcan sosu koyunuz",
          "Uçlarından kapatınız. Fırına girmeden üzerine yumurta sürünüz",
          "180 derece fırında 25 dk pişiriz."
        ]
      }
    ],
    "source": "Pancar Havlıcan Soslu Tarifler",
    "sourceBlog": "pancar-havlican-soslu-tarifler",
    "sourcePath": "/blogs/pancar-havlican-soslu-tarifler/pancar-havlican-milfoy",
    "sourceId": "gid://shopify/Article/608812400924",
    "aliases": [
      "pancar-havlican-milfoy"
    ]
  },
  {
    "slug": "cilek-jalepeno-mescal",
    "title": "Çilek & Jalepeno Mescal",
    "cat": "kokteyl",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9549.jpg?v=1731479742",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "Tekila veya mescal 5 cl",
      "20 gr Çilek & Jalepeno",
      "Limon suyu 5 cl",
      "Agave şurubu 2 cl"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Tekila veya mescal 5 cl",
          "20 gr Çilek & Jalepeno",
          "Limon suyu 5 cl",
          "Agave şurubu 2 cl"
        ]
      }
    ],
    "steps": [
      "Hepsini sırasıyla shakera koyup karıştırınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Hepsini sırasıyla shakera koyup karıştırınız"
        ]
      }
    ],
    "source": "Kokteyller",
    "sourceBlog": "kokteyller",
    "sourcePath": "/blogs/kokteyller/cilek-jalepeno-mescal",
    "sourceId": "gid://shopify/Article/608909787420",
    "aliases": [
      "cilek-jalepeno-mescal"
    ]
  },
  {
    "slug": "zencefil-acili-armut-shot",
    "title": "Zencefil Acılı Armut Shot",
    "cat": "kokteyl",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A9646.jpg?v=1731480382",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "Limon suyu 10 cl",
      "10 gr bal",
      "15 gr Zencefil Acılı Armut sos",
      "Karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Limon suyu 10 cl",
          "10 gr bal",
          "15 gr Zencefil Acılı Armut sos",
          "Karabiber"
        ]
      }
    ],
    "steps": [
      "Hepsini sırasıyla shakera koyup karıştırınız"
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Hepsini sırasıyla shakera koyup karıştırınız"
        ]
      }
    ],
    "source": "Kokteyller",
    "sourceBlog": "kokteyller",
    "sourcePath": "/blogs/kokteyller/zencefil-acili-armut-shot",
    "sourceId": "gid://shopify/Article/608909852956",
    "aliases": [
      "zencefil-acili-armut-shot"
    ]
  },
  {
    "slug": "baharatli-balkabagi-corbasi",
    "title": "Baharatlı Balkabağı Çorbası",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A2891.jpg?v=1733160568",
    "productSlug": "baharatli-balkabagi-sosu",
    "product": "Baharatlı Balkabağı Sosu",
    "summary": "",
    "serves": "6-8 kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 30 dk",
    "ingredients": [
      "500 gr balkabağı",
      "85 gr Freya Gurme Baharatlı Balkabağı Sosu",
      "200 gr kuru soğan",
      "250 gr patates",
      "100 gr havuç",
      "150 gr tereyağ",
      "50 ml zeytinyağ",
      "1.5 lt sebze suyu",
      "Taze kekik",
      "Tuz",
      "Karabiber",
      "Kruton",
      "Frenk soğanı"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "500 gr balkabağı",
          "85 gr Freya Gurme Baharatlı Balkabağı Sosu",
          "200 gr kuru soğan",
          "250 gr patates",
          "100 gr havuç",
          "150 gr tereyağ",
          "50 ml zeytinyağ",
          "1.5 lt sebze suyu",
          "Taze kekik",
          "Tuz",
          "Karabiber"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "Kruton",
          "Frenk soğanı"
        ]
      }
    ],
    "steps": [
      "Balkabağı, patates, soğan ve havuçları iri küp şeklinde doğrayınız. Zeytinyağını tencerede ısıttıktan sonra soğanları kavurunuz. Arkasından diğer sebzeleri, baharatları ve Freya Gurme Baharatlı Balkabağı sosunu ekleyip karıştırınız.",
      "Sebzeler de kavrulduktan sonra üstlerini geçecek kadar sebze suyu ekleyip pişmeye bırakınız. El blenderından geçirdikten sonra kalan sebze suyu ile birlikte tekrar ocakta kaynayana kadar pişiriniz. En son ekstra lezzet ve kıvam için küp tereyağları ekledikten sonra kruton ve frenk soğanıyla servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Balkabağı, patates, soğan ve havuçları iri küp şeklinde doğrayınız. Zeytinyağını tencerede ısıttıktan sonra soğanları kavurunuz. Arkasından diğer sebzeleri, baharatları ve Freya Gurme Baharatlı Balkabağı sosunu ekleyip karıştırınız.",
          "Sebzeler de kavrulduktan sonra üstlerini geçecek kadar sebze suyu ekleyip pişmeye bırakınız. El blenderından geçirdikten sonra kalan sebze suyu ile birlikte tekrar ocakta kaynayana kadar pişiriniz. En son ekstra lezzet ve kıvam için küp tereyağları ekledikten sonra kruton ve frenk soğanıyla servis ediniz."
        ]
      }
    ],
    "source": "Baharatlı Balkabağı Sosu",
    "sourceBlog": "baharatli-balkabagi-sosu",
    "sourcePath": "/blogs/baharatli-balkabagi-sosu/baharatli-balkabagi-corbasi",
    "sourceId": "gid://shopify/Article/608979190044",
    "aliases": [
      "baharatli-balkabagi-corbasi"
    ]
  },
  {
    "slug": "cilek-jalepeno-bruksel-salata",
    "title": "Çilek Jalepeno & Brüksel Salata",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A2969.jpg?v=1733745259",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Hazırlam",
        "15 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ]
    ],
    "time": "Hazırlam 15 dk · Pişirme 30 dk",
    "ingredients": [
      "Freya Gurme Acı Biberli Zeytinyağı",
      "20 gr Freya Gurme Çilek Jalepeno",
      "500 gr brüksel lahanası",
      "300 gr tatlı patates",
      "100 gr pecan cevizi",
      "75 gr nar",
      "30 ml limon suyu",
      "30 ml portakal suyu",
      "30 ml balzamik sirke",
      "60 gr sıvı yağ",
      "Tuz",
      "Karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "Freya Gurme Acı Biberli Zeytinyağı",
          "20 gr Freya Gurme Çilek Jalepeno",
          "500 gr brüksel lahanası",
          "300 gr tatlı patates",
          "100 gr pecan cevizi",
          "75 gr nar",
          "30 ml limon suyu",
          "30 ml portakal suyu",
          "30 ml balzamik sirke",
          "60 gr sıvı yağ",
          "Tuz",
          "Karabiber"
        ]
      }
    ],
    "steps": [
      "Fırını 200c alt üst fanlı ayarda ısıtınız. Brüksel lahanalarını ortadan ikiye, tatlı patatesleri de küp şeklinde doğrayıp sıvı yağ ve tuz ile harmanlayınız. Yağlı kağıt serili tepside yaklaşık 30 dakika pişirip ılımaya bırakınız. Salata kasesinde diğer malzemelerle birlikte karıştırıp son olarak üzerine Freya Acı Zeytinyağı gezdirip servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 200c alt üst fanlı ayarda ısıtınız. Brüksel lahanalarını ortadan ikiye, tatlı patatesleri de küp şeklinde doğrayıp sıvı yağ ve tuz ile harmanlayınız. Yağlı kağıt serili tepside yaklaşık 30 dakika pişirip ılımaya bırakınız. Salata kasesinde diğer malzemelerle birlikte karıştırıp son olarak üzerine Freya Acı Zeytinyağı gezdirip servis ediniz."
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepeno-bruksel-salata",
    "sourceId": "gid://shopify/Article/609004618012",
    "aliases": [
      "cilek-jalepeno-bruksel-salata"
    ]
  },
  {
    "slug": "maviyemis-lavanta-ve-orman-meyveli-pavlova",
    "title": "Maviyemiş Lavanta Soslu Orman Meyveli Pavlova",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Pavlova.png?v=1734875511",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "6-8 Kişilik",
    "times": [
      [
        "Pişirme",
        "90 dk"
      ],
      [
        "Bekleme",
        "120 dk"
      ]
    ],
    "time": "Pişirme 90 dk · Bekleme 120 dk",
    "ingredients": [
      "240 gr yumurta beyazı",
      "300 gr toz şeker",
      "8 gr mısır nişastası",
      "8 gr elma sirkesi",
      "2 gr tuz",
      "250 ml süt",
      "60 gr yumurta sarısı",
      "45 gr toz şeker",
      "15 gr un",
      "15 gr mısır nişastası",
      "20 gr soğuk tereyağ",
      "6 gr vanilya özütü",
      "150 gr soğuk krema (min.%30 yağ oranlı)"
    ],
    "ingredientGroups": [
      {
        "title": "Mereng için",
        "items": [
          "240 gr yumurta beyazı",
          "300 gr toz şeker",
          "8 gr mısır nişastası",
          "8 gr elma sirkesi",
          "2 gr tuz"
        ]
      },
      {
        "title": "Diplomat Kreması için",
        "items": [
          "250 ml süt",
          "60 gr yumurta sarısı",
          "45 gr toz şeker",
          "15 gr un",
          "15 gr mısır nişastası",
          "20 gr soğuk tereyağ",
          "6 gr vanilya özütü",
          "150 gr soğuk krema (min.%30 yağ oranlı)"
        ]
      }
    ],
    "steps": [
      "Fırını 120c alt üst fanlı ayarda ısıtınız. Fırın tepsisine yağlı kağıt yerleştiriniz. Yumurta beyazlarını geniş bir kapta tuzla birlikte köpürene kadar çırpınız. Yüksek devirde çırpmaya devam ederken toz şekeri 1’er yemek kaşığı olacak şekilde yavaş yavaş ekleyiniz. Parmaklarınız arasında toz şekeri hissetmeyene kadar, yaklaşık 15 dakika çırpmaya devam ediniz. Şekerler yok olunca sirkeyi ve eleyerek mısır nişastası ekleyip homojen olana kadar karıştırınız. Başka bir kaşık alarak, 1’er dolu yemek kaşığı merengi fırın tepsisine alınız. Yaprak şeklini kaşıkla verdikten sonra fırına koyunuz. Kalan merengleri de istediğiniz şekillerde üstlerine toz tarçın veya portakal kabuğu rendesi ekleyerek başka bir tepside pişirebilirsiniz. Merengleri fırına koyduktan sonra 100 dereceye düşürüp 90 dakika boyunca fırının kapağını açmadan pişiriniz. Fırını kapattıktan sonra merengleri içeride bekletip 2 saat kurutunuz.",
      "Krema için bir kaseye yumurta sarılarını, şekeri, unu ve nişastayı alınız. Sütün 2-3 yemek kaşığı kadarını bu kaseye döküp kalanını vanilya ile birlikte sos tenceresinde ısıtmaya başlayınız. Yumurta karışımını çırpma teliyle pürüzsüz olana kadar çırptıktan sonra yavaşça ısınan sütü ekleyerek bir taraftan çırpmaya devam ediniz. Karışımı tekrar sos tenceresine alıp, baloncuklar çıkana kadar çırpma teliyle çırpmaya devam ediniz. En son soğuk tereyağı ekleyip pürüzsüz olana kadar karıştırınız ve hiç bir yeri hava almayacak şekilde streçleyip buzdolabında soğumaya bırakınız. 150 ml iyice soğutulmuş kremayla birlikte çırptıktan sonra diplomat kremanız kullanıma hazır olacaktır. Son birleştirme aşamasında merengleri diplomat kreması, Freya Gurme Maviyemiş & Lavanta, kırmızı orman meyvesiyle süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 120c alt üst fanlı ayarda ısıtınız. Fırın tepsisine yağlı kağıt yerleştiriniz. Yumurta beyazlarını geniş bir kapta tuzla birlikte köpürene kadar çırpınız. Yüksek devirde çırpmaya devam ederken toz şekeri 1’er yemek kaşığı olacak şekilde yavaş yavaş ekleyiniz. Parmaklarınız arasında toz şekeri hissetmeyene kadar, yaklaşık 15 dakika çırpmaya devam ediniz. Şekerler yok olunca sirkeyi ve eleyerek mısır nişastası ekleyip homojen olana kadar karıştırınız. Başka bir kaşık alarak, 1’er dolu yemek kaşığı merengi fırın tepsisine alınız. Yaprak şeklini kaşıkla verdikten sonra fırına koyunuz. Kalan merengleri de istediğiniz şekillerde üstlerine toz tarçın veya portakal kabuğu rendesi ekleyerek başka bir tepside pişirebilirsiniz. Merengleri fırına koyduktan sonra 100 dereceye düşürüp 90 dakika boyunca fırının kapağını açmadan pişiriniz. Fırını kapattıktan sonra merengleri içeride bekletip 2 saat kurutunuz.",
          "Krema için bir kaseye yumurta sarılarını, şekeri, unu ve nişastayı alınız. Sütün 2-3 yemek kaşığı kadarını bu kaseye döküp kalanını vanilya ile birlikte sos tenceresinde ısıtmaya başlayınız. Yumurta karışımını çırpma teliyle pürüzsüz olana kadar çırptıktan sonra yavaşça ısınan sütü ekleyerek bir taraftan çırpmaya devam ediniz. Karışımı tekrar sos tenceresine alıp, baloncuklar çıkana kadar çırpma teliyle çırpmaya devam ediniz. En son soğuk tereyağı ekleyip pürüzsüz olana kadar karıştırınız ve hiç bir yeri hava almayacak şekilde streçleyip buzdolabında soğumaya bırakınız. 150 ml iyice soğutulmuş kremayla birlikte çırptıktan sonra diplomat kremanız kullanıma hazır olacaktır. Son birleştirme aşamasında merengleri diplomat kreması, Freya Gurme Maviyemiş & Lavanta, kırmızı orman meyvesiyle süsleyiniz."
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/maviyemis-lavanta-ve-orman-meyveli-pavlova",
    "sourceId": "gid://shopify/Article/609049805084",
    "aliases": [
      "maviyemis-lavanta-ve-orman-meyveli-pavlova"
    ]
  },
  {
    "slug": "maviyemis-lavanta-soslu-hindistan-cevizi-granola",
    "title": "Maviyemiş Lavanta Soslu Hindistan Cevizi Granola",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/granolo.jpg?v=1736072854",
    "productSlug": "hindistan-cevizi-granola",
    "product": "Hindistan Cevizi Granola",
    "summary": "",
    "serves": "1-2 kişilik",
    "times": [
      [
        "Hazırlama",
        "5 dk"
      ]
    ],
    "time": "Hazırlama 5 dk",
    "ingredients": [
      "60 gr Freya Gurme Maviyemiş & Lavanta",
      "160 gr süzme yoğurt",
      "Freya Gurme Hindistan Cevizi Granola",
      "Muz",
      "Ahududu",
      "Maviyemiş",
      "Yenilebilir çiçek"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "60 gr Freya Gurme Maviyemiş & Lavanta",
          "160 gr süzme yoğurt"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "Freya Gurme Hindistan Cevizi Granola",
          "Muz",
          "Ahududu",
          "Maviyemiş",
          "Yenilebilir çiçek"
        ]
      }
    ],
    "steps": [
      "Süzme yoğurtla Freya Gurme Maviyemiş Lavanta sosu karıştırınız.",
      "Üzerine Hindistan Cevizi Granola ve dilediğiniz taze meyvelerle süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Süzme yoğurtla Freya Gurme Maviyemiş Lavanta sosu karıştırınız.",
          "Üzerine Hindistan Cevizi Granola ve dilediğiniz taze meyvelerle süsleyiniz."
        ]
      }
    ],
    "source": "Granola",
    "sourceBlog": "granola",
    "sourcePath": "/blogs/granola/maviyemis-lavanta-soslu-hindistan-cevizi-granola",
    "sourceId": "gid://shopify/Article/609086570780",
    "aliases": [
      "maviyemis-lavanta-soslu-hindistan-cevizi-granola"
    ]
  },
  {
    "slug": "vegan-sutlu-hindistan-cevizi-granola",
    "title": "Vegan Sütlü Hindistan Cevizi Granola",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/IMG_5393_520x500_520x500_520x500_280bdfb7-1e59-4a68-8799-91ee4bbcbddd.jpg?v=1737021704",
    "productSlug": "hindistan-cevizi-granola",
    "product": "Hindistan Cevizi Granola",
    "summary": "",
    "serves": "1-2 kişilik",
    "times": [
      [
        "Hazırlama",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 10 dk",
    "ingredients": [
      "200 ml konserve hindistan cevizi sütü",
      "50 gr hindistan cevizi kreması",
      "100 gr Freya Gurme Hindistan Cevizi Granola",
      "20 gr Freya Gurme Çarkıfelek Sos",
      "Çilek",
      "Ahududu",
      "Kivi",
      "Taze hindistan cevizi"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "200 ml konserve hindistan cevizi sütü",
          "50 gr hindistan cevizi kreması",
          "100 gr Freya Gurme Hindistan Cevizi Granola"
        ]
      },
      {
        "title": "Üzeri için",
        "items": [
          "20 gr Freya Gurme Çarkıfelek Sos",
          "Çilek",
          "Ahududu",
          "Kivi",
          "Taze hindistan cevizi"
        ]
      }
    ],
    "steps": [
      "Süt ve kremayı çırpınız.",
      "Meyve, granola ve sosla üzerini süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Süt ve kremayı çırpınız.",
          "Meyve, granola ve sosla üzerini süsleyiniz."
        ]
      }
    ],
    "source": "Granola",
    "sourceBlog": "granola",
    "sourcePath": "/blogs/granola/vegan-sutlu-hindistan-cevizi-granola",
    "sourceId": "gid://shopify/Article/609158856988",
    "aliases": [
      "vegan-sutlu-hindistan-cevizi-granola"
    ]
  },
  {
    "slug": "cilek-jalepeno-soslu-izgara-dana-bonfile-amp-tereyagli-patates-puresi-nbsp",
    "title": "Çilek Jalepeno Soslu Izgara Dana Bonfile & Tereyağlı Patates Püresi",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/IMG_8950_e969a242-9ddd-43fe-b15b-b3be0a6cf884.jpg?v=1739279730",
    "productSlug": "cilek-jalapeno-sosu",
    "product": "Çilek & Jalepeno Sosu",
    "summary": "",
    "serves": "2 kişilik",
    "times": [
      [
        "Hazırlama",
        "60 dk"
      ]
    ],
    "time": "Hazırlama 60 dk",
    "ingredients": [
      "350 gr dana bonfile",
      "25 gr zeytinyağı",
      "30 gr tereyağı",
      "Deniz tuzu",
      "Taze çekilmiş karabiber",
      "2 diş sarımsak (ezilmiş)",
      "2 dal taze kekik",
      "1 adet kuru soğan (ince doğranmış)",
      "15 gr zeytinyağı",
      "20 gr tereyağı",
      "Tuz, karabiber",
      "4 adet orta boy patates",
      "2 yemek kaşığı tereyağı",
      "100 ml süt",
      "Tuz, karabiber",
      "Taze kekik yaprakları",
      "Çilek Jalepeno"
    ],
    "ingredientGroups": [
      {
        "title": "Izgara Dana Bonfile İçin",
        "items": [
          "350 gr dana bonfile",
          "25 gr zeytinyağı",
          "30 gr tereyağı",
          "Deniz tuzu",
          "Taze çekilmiş karabiber",
          "2 diş sarımsak (ezilmiş)",
          "2 dal taze kekik"
        ]
      },
      {
        "title": "Karamelize Soğan (Püreye eklemek için)",
        "items": [
          "1 adet kuru soğan (ince doğranmış)",
          "15 gr zeytinyağı",
          "20 gr tereyağı",
          "Tuz, karabiber"
        ]
      },
      {
        "title": "Tereyağlı & Karamelize Soğanlı Patates Püres İçin",
        "items": [
          "4 adet orta boy patates",
          "2 yemek kaşığı tereyağı",
          "100 ml süt",
          "Tuz, karabiber"
        ]
      },
      {
        "title": "Servis için",
        "items": [
          "Taze kekik yaprakları",
          "Çilek Jalepeno"
        ]
      }
    ],
    "steps": [
      "Tavada tereyağı ve zeytinyağını eritiniz.",
      "İnce doğranmış soğanları ekleyiniz, kısık ateşte 15-20 dakika yavaşça pişiriniz.",
      "Tuz ve karabiber ile tatlandırıp ocaktan alınız.",
      "Patatesleri kabuklarıyla birlikte haşlayınız veya fırında yumuşayana kadar pişiriniz.",
      "Haşlandıktan sonra soyup pürüzsüz olana kadar eziniz.",
      "Tereyağını ekleyip karıştırınız, kıvamına göre süt ekleyerek pürüzsüz hale getiriniz.",
      "Tuz ve karabiber ekleyerek tatlandırınız.",
      "Bonfileleri oda sıcaklığına getiriniz, tuz ve karabiberle tatlandırınız. Tavayı yüksek ateşte ısıtıp zeytinyağını ekleyiniz.",
      "Etleri tavaya alınız ve her iki tarafını 2-3 dakika mühürleyiniz. Tereyağı, sarımsak ve taze kekiği ekleyerek kaşıkla yağı üzerine dökerek 1-2 dakika daha pişiriniz. Ocaktan alıp 3-4 dakika dinlendiriniz.",
      "Karamelize soğanlı patates püresini tabağa yayınız. Dilimlenmiş ızgara bonfileyi üzerine yerleştiriniz. Taze kekik yapraklarını serpiştiriniz. Üzerine Freya Gurme Çilek Jalepeno sos ile servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "Karamelize Soğan",
        "items": [
          "Tavada tereyağı ve zeytinyağını eritiniz.",
          "İnce doğranmış soğanları ekleyiniz, kısık ateşte 15-20 dakika yavaşça pişiriniz.",
          "Tuz ve karabiber ile tatlandırıp ocaktan alınız."
        ]
      },
      {
        "title": "Patates Püresi",
        "items": [
          "Patatesleri kabuklarıyla birlikte haşlayınız veya fırında yumuşayana kadar pişiriniz.",
          "Haşlandıktan sonra soyup pürüzsüz olana kadar eziniz.",
          "Tereyağını ekleyip karıştırınız, kıvamına göre süt ekleyerek pürüzsüz hale getiriniz.",
          "Tuz ve karabiber ekleyerek tatlandırınız."
        ]
      },
      {
        "title": "Izgara Dana Bonfile",
        "items": [
          "Bonfileleri oda sıcaklığına getiriniz, tuz ve karabiberle tatlandırınız. Tavayı yüksek ateşte ısıtıp zeytinyağını ekleyiniz.",
          "Etleri tavaya alınız ve her iki tarafını 2-3 dakika mühürleyiniz. Tereyağı, sarımsak ve taze kekiği ekleyerek kaşıkla yağı üzerine dökerek 1-2 dakika daha pişiriniz. Ocaktan alıp 3-4 dakika dinlendiriniz."
        ]
      },
      {
        "title": "Servis İçin",
        "items": [
          "Karamelize soğanlı patates püresini tabağa yayınız. Dilimlenmiş ızgara bonfileyi üzerine yerleştiriniz. Taze kekik yapraklarını serpiştiriniz. Üzerine Freya Gurme Çilek Jalepeno sos ile servis ediniz."
        ]
      }
    ],
    "source": "Çilek Jalapeno Soslu Tarifler",
    "sourceBlog": "cilek-jalapeno-soslu-tarifler",
    "sourcePath": "/blogs/cilek-jalapeno-soslu-tarifler/cilek-jalepeno-soslu-izgara-dana-bonfile-amp-tereyagli-patates-puresi-nbsp",
    "sourceId": "gid://shopify/Article/609252868380",
    "aliases": [
      "cilek-jalepeno-soslu-izgara-dana-bonfile-amp-tereyagli-patates-puresi-nbsp"
    ]
  },
  {
    "slug": "zencefil-acili-armut-soslu-fried-rice",
    "title": "Zencefil Acılı Armut Soslu Fried Rice",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Background.png?v=1739463048",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "2-3 Kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "30 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 30 dk",
    "ingredients": [
      "1 adet yumurta",
      "100 gr yasmin pirinç",
      "75 gr kuru soğan",
      "35 gr bezelye",
      "45 ml sıvı yağ",
      "60 gr Freya Gurme Zencefil Acılı Armut Sos",
      "Karabiber",
      "Tuz",
      "Frenk soğanı",
      "Freya Gurme Acı Biberli Zeytinyağı (opsiyonel)"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 adet yumurta",
          "100 gr yasmin pirinç",
          "75 gr kuru soğan",
          "35 gr bezelye",
          "45 ml sıvı yağ",
          "60 gr Freya Gurme Zencefil Acılı Armut Sos",
          "Karabiber",
          "Tuz"
        ]
      },
      {
        "title": "Servis için",
        "items": [
          "Frenk soğanı",
          "Freya Gurme Acı Biberli Zeytinyağı (opsiyonel)"
        ]
      }
    ],
    "steps": [
      "Pirinçleri bir kaç kez soğuk sudan geçirdikten sonra tuzlu suda 15 dakika kadar haşlayıp soğumaya bırakınız. Kuru soğanı küçük küp şeklinde doğrayınız. Yumurtayı küçük bir kasede çatalla çırpınız. Wok tavanızda 30 ml sıvı yağınızı yüksek ateşte ısıttıktan sonra yumurtayı devamlı karıştırarak kızartıp bir tabağa alınız. Tavaya kalan 15 ml sıvıyağı ekleyip soğanları kavurunuz. Arkasından bezelyeleri ekleyip biraz daha kavurduktan sonra sırayla pirinç, kızarmış yumurta, Zencefil Acılı Armut sos karabiber ve tuzu ekleyiniz. Pirinçler iyice kızarana kadar, yüksek ateşte tavayı sürekli sallayarak pişirdikten sonra üzerine frenk soğanı ve Freya Gurme Acı Biberli Zeytinyağı gezdirerek servis edebilirsiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Pirinçleri bir kaç kez soğuk sudan geçirdikten sonra tuzlu suda 15 dakika kadar haşlayıp soğumaya bırakınız. Kuru soğanı küçük küp şeklinde doğrayınız. Yumurtayı küçük bir kasede çatalla çırpınız. Wok tavanızda 30 ml sıvı yağınızı yüksek ateşte ısıttıktan sonra yumurtayı devamlı karıştırarak kızartıp bir tabağa alınız. Tavaya kalan 15 ml sıvıyağı ekleyip soğanları kavurunuz. Arkasından bezelyeleri ekleyip biraz daha kavurduktan sonra sırayla pirinç, kızarmış yumurta, Zencefil Acılı Armut sos karabiber ve tuzu ekleyiniz. Pirinçler iyice kızarana kadar, yüksek ateşte tavayı sürekli sallayarak pişirdikten sonra üzerine frenk soğanı ve Freya Gurme Acı Biberli Zeytinyağı gezdirerek servis edebilirsiniz."
        ]
      }
    ],
    "source": "Zencefil Acılı Armut Soslu Tarifler",
    "sourceBlog": "zencefil-acili-armut-soslu-tarifler",
    "sourcePath": "/blogs/zencefil-acili-armut-soslu-tarifler/zencefil-acili-armut-soslu-fried-rice",
    "sourceId": "gid://shopify/Article/609266925852",
    "aliases": [
      "zencefil-acili-armut-soslu-fried-rice"
    ]
  },
  {
    "slug": "zencefil-acili-armut-soslu-baget-sandvic",
    "title": "Zencefil Acılı Armut Soslu Baget Sandviç",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/Sandvic.jpg?v=1739962742",
    "productSlug": "zencefil-acili-armut-sosu",
    "product": "Zencefil & Acılı Armut Sosu",
    "summary": "",
    "serves": "1-2 Kişilik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "2-3 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 2-3 dk",
    "ingredients": [
      "1 adet Fransız baget",
      "80 gr keçi büş peyniri",
      "50 gr labne",
      "60 gr emmental peyniri",
      "5 dal taze kekik yaprağı",
      "1 adet limon kabuğu rendesi",
      "60 gr Freya Gurme Zencefil Acılı Armut Sos",
      "½ adet deveci armut, çok ince dilimlenmiş",
      "50 gr İtalyan salam",
      "50 gr füme kaburga",
      "50 gr roastbeef",
      "15 gr tereyağı (ekmeği çıtırlaştırmak için)",
      "½ çay kaşığı deniz tuzu & taze çekilmiş karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 adet Fransız baget",
          "80 gr keçi büş peyniri",
          "50 gr labne",
          "60 gr emmental peyniri",
          "5 dal taze kekik yaprağı",
          "1 adet limon kabuğu rendesi",
          "60 gr Freya Gurme Zencefil Acılı Armut Sos",
          "½ adet deveci armut, çok ince dilimlenmiş",
          "50 gr İtalyan salam",
          "50 gr füme kaburga",
          "50 gr roastbeef",
          "15 gr tereyağı (ekmeği çıtırlaştırmak için)",
          "½ çay kaşığı deniz tuzu & taze çekilmiş karabiber"
        ]
      }
    ],
    "steps": [
      "Keçi büş peyniri ve labneyi bir kasede iyice karıştırırınız. Hafif tuz ve karabiber ekleyiniz.",
      "Fransız bageti ortadan ikiye kesiniz. İç kısmını hafifçe boşaltarak daha fazla dolguya yer açınız. Tavada tereyağını eritiniz ve bagetin iç yüzeylerini hafifçe çıtırlaştırınız. Çıtırlaşan ekmeklerin alt ve üst parçalarına, peynir kreması, limon kabuğu rendesi, taze kekik yaprakları ve Freya Gurme Zencefil Acılı Armut Sos sürünüz. Sandviçin tabanına sosu sürdükten sonra üzerine emmental peyniri, şarküteri ürünlerini ve ince dilimlenmiş deveci armutu diziniz. Bagetin üst kısmını kapatarak hafifçe bastırınız. Sandviçi ortadan ikiye keserek servis ediniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Keçi büş peyniri ve labneyi bir kasede iyice karıştırırınız. Hafif tuz ve karabiber ekleyiniz.",
          "Fransız bageti ortadan ikiye kesiniz. İç kısmını hafifçe boşaltarak daha fazla dolguya yer açınız. Tavada tereyağını eritiniz ve bagetin iç yüzeylerini hafifçe çıtırlaştırınız. Çıtırlaşan ekmeklerin alt ve üst parçalarına, peynir kreması, limon kabuğu rendesi, taze kekik yaprakları ve Freya Gurme Zencefil Acılı Armut Sos sürünüz. Sandviçin tabanına sosu sürdükten sonra üzerine emmental peyniri, şarküteri ürünlerini ve ince dilimlenmiş deveci armutu diziniz. Bagetin üst kısmını kapatarak hafifçe bastırınız. Sandviçi ortadan ikiye keserek servis ediniz."
        ]
      }
    ],
    "source": "Zencefil Acılı Armut Soslu Tarifler",
    "sourceBlog": "zencefil-acili-armut-soslu-tarifler",
    "sourcePath": "/blogs/zencefil-acili-armut-soslu-tarifler/zencefil-acili-armut-soslu-baget-sandvic",
    "sourceId": "gid://shopify/Article/609282523420",
    "aliases": [
      "zencefil-acili-armut-soslu-baget-sandvic"
    ]
  },
  {
    "slug": "visne-iskin-soslu-chia-pancake",
    "title": "Vişne & Işkın Soslu Chia Pancake",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A0442.jpg?v=1741023011",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "1-2 Kişilik",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "10 dk"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 10 dk",
    "ingredients": [
      "200 ml badem sütü",
      "2 adet büyük yumurta",
      "80 gr un (50 gr beyaz un + 30 gr badem unu)",
      "15 gr chia tohumu",
      "15 gr eritilmiş tereyağı",
      "1 adet orta boy portakal kabuğu rendesi",
      "5 gr vanilya özütü",
      "1 çimdik tuz",
      "100 gr mascarpone",
      "50 gr süzme yoğurt",
      "20 gr akçaağaç şurubu",
      "1 adet limon kabuğu rendesi",
      "100 gr Freya Gurme Vişne & Işkın",
      "100 gr taze (yoksa dondurulmuş) vişne",
      "40 gr kavrulmuş file fındık",
      "Yenilebilir çiçekler"
    ],
    "ingredientGroups": [
      {
        "title": "Pancake hamuru için",
        "items": [
          "200 ml badem sütü",
          "2 adet büyük yumurta",
          "80 gr un (50 gr beyaz un + 30 gr badem unu)",
          "15 gr chia tohumu",
          "15 gr eritilmiş tereyağı",
          "1 adet orta boy portakal kabuğu rendesi",
          "5 gr vanilya özütü",
          "1 çimdik tuz"
        ]
      },
      {
        "title": "Dolgu kreması için",
        "items": [
          "100 gr mascarpone",
          "50 gr süzme yoğurt",
          "20 gr akçaağaç şurubu",
          "1 adet limon kabuğu rendesi"
        ]
      },
      {
        "title": "Sunum İçin",
        "items": [
          "100 gr Freya Gurme Vişne & Işkın",
          "100 gr taze (yoksa dondurulmuş) vişne",
          "40 gr kavrulmuş file fındık",
          "Yenilebilir çiçekler"
        ]
      }
    ],
    "steps": [
      "Chia tohumlarını badem sütü içinde 10 dakika bekletiniz, jel kıvamına gelmesini sağlayınız. Yumurta, un (beyaz un + badem unu), eritilmiş tereyağı, vanilya özütü, portakal kabuğu rendesi ve bir çimdik tuzu çırpınız, ardından chia karışımını ekleyerek pürüzsüz bir pancake hamuru elde ediniz.",
      "Hamuru 15 dakika dinlendiriniz bu sayede kıvamı oturur ve pişirme sırasında daha iyi yayılacaktır. Yapışmaz tavayı hafifçe yağlayınız, çok ince bir tabaka halinde dökerek kenarları hafif çıtır olana kadar pişiriniz. (30-40 saniye bir yüzü, 15 saniye diğer yüzü).Mascarpone ve süzme yoğurdu bal ve limon kabuğu rendesiyle çırpınız, hafif kremsi bir dolgu elde ediniz. Pancakeleri kat kat dizerek hazırlayınız, aralarına mascarpone kremasını, Freya Gurme Vişne & Işkın Otu ve vişneleri ince bir tabaka halinde sürünüz. Taze/donmuş vişneler, file fındıklar ve yenilebilir çiçeklerle süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Chia tohumlarını badem sütü içinde 10 dakika bekletiniz, jel kıvamına gelmesini sağlayınız. Yumurta, un (beyaz un + badem unu), eritilmiş tereyağı, vanilya özütü, portakal kabuğu rendesi ve bir çimdik tuzu çırpınız, ardından chia karışımını ekleyerek pürüzsüz bir pancake hamuru elde ediniz.",
          "Hamuru 15 dakika dinlendiriniz bu sayede kıvamı oturur ve pişirme sırasında daha iyi yayılacaktır. Yapışmaz tavayı hafifçe yağlayınız, çok ince bir tabaka halinde dökerek kenarları hafif çıtır olana kadar pişiriniz. (30-40 saniye bir yüzü, 15 saniye diğer yüzü).Mascarpone ve süzme yoğurdu bal ve limon kabuğu rendesiyle çırpınız, hafif kremsi bir dolgu elde ediniz. Pancakeleri kat kat dizerek hazırlayınız, aralarına mascarpone kremasını, Freya Gurme Vişne & Işkın Otu ve vişneleri ince bir tabaka halinde sürünüz. Taze/donmuş vişneler, file fındıklar ve yenilebilir çiçeklerle süsleyiniz."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskin-soslu-chia-pancake",
    "sourceId": "gid://shopify/Article/609294090524",
    "aliases": [
      "visne-iskin-soslu-chia-pancake"
    ]
  },
  {
    "slug": "visne-salsa-soslu-taco-shells",
    "title": "Vişne & Salsa Soslu Taco Shells",
    "cat": "ana",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A0511_1_10d51217-8916-4ef4-a8bb-80f48b88f882.jpg?v=1744989766",
    "productSlug": "visne-salsa-sosu",
    "product": "Vişne & Salsa Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "20 dk"
      ],
      [
        "Pişirme",
        "4-5 saat"
      ]
    ],
    "time": "Hazırlama 20 dk · Pişirme 4-5 saat",
    "ingredients": [
      "6 adet taco shell (fırınlanmış)",
      "3 adet olgun avokado",
      "1 adet limon",
      "300 gr tiftiklenmiş fırın dana kaburga",
      "200 gr tarla domates (küçük küp doğranmış)",
      "60 gr jalepeno (ince doğranmış)",
      "1 adet küçük boy kırmızı soğan (küçük küp doğranmış)",
      "1 adet lime (suyu)",
      "2 dal taze kişniş yaprağı",
      "50 ml zeytinyağı",
      "1 çimdik tuz",
      "60 gr Freya Gurme Vişne & Salsa Sos",
      "3 adet lime (dilimlenmiş)",
      "5 dal taze kişniş yaprağı"
    ],
    "ingredientGroups": [
      {
        "title": "6 adet taco için",
        "items": [
          "6 adet taco shell (fırınlanmış)",
          "3 adet olgun avokado",
          "1 adet limon",
          "300 gr tiftiklenmiş fırın dana kaburga",
          "200 gr tarla domates (küçük küp doğranmış)",
          "60 gr jalepeno (ince doğranmış)",
          "1 adet küçük boy kırmızı soğan (küçük küp doğranmış)",
          "1 adet lime (suyu)",
          "2 dal taze kişniş yaprağı",
          "50 ml zeytinyağı",
          "1 çimdik tuz",
          "60 gr Freya Gurme Vişne & Salsa Sos",
          "3 adet lime (dilimlenmiş)",
          "5 dal taze kişniş yaprağı"
        ]
      }
    ],
    "steps": [
      "Dana kaburgayı hazırlamak için öncelikle zeytinyağı, tuz, taze çekilmiş karabiber ile marine et. Lezzeti artırması için kuru soğan, sarımsak ve defne yaprağı ile harmanlayınız. 200°C fırında 4-5 saat boyunca üzeri kapalı şekilde, fırın tepsisine su ekleyerek, yumuşayıp liflerine ayrılacak kıvama gelene kadar pişiriniz",
      "Pişen kaburgayı fırından çıkarınız ve iki çatal yardımıyla didikleyerek tiftik haline getiririniz.",
      "Olgun avokadoları bir kaba alıp çatal yardımıyla eziniz. Üzerine limon suyu ve bir çimdik tuz ekleyerek pürüzsüz bir kıvam alana kadar karıştırınız.",
      "Küçük küp doğranmış domates, kırmızı soğan ve halka doğranmış jalepenoyu bir kasede birleştiriniz. Üzerine lime suyu, zeytinyağı ve tuz ekleyerek karıştırınız. En son ince doğranmış taze kişniş yapraklarını ekleyerek salsayı tamamlayınımız.",
      "Her taco shell’in içine birer tatlı kaşığı limonlu avokado püresi, dana kaburgayı, ve salsa sosu sürünüz. En son taze jalepeno, lime, kişniş yapraklarıyla süsleyeniz."
    ],
    "stepGroups": [
      {
        "title": "Fırın Dana Kaburga Yapılışı",
        "items": [
          "Dana kaburgayı hazırlamak için öncelikle zeytinyağı, tuz, taze çekilmiş karabiber ile marine et. Lezzeti artırması için kuru soğan, sarımsak ve defne yaprağı ile harmanlayınız. 200°C fırında 4-5 saat boyunca üzeri kapalı şekilde, fırın tepsisine su ekleyerek, yumuşayıp liflerine ayrılacak kıvama gelene kadar pişiriniz",
          "Pişen kaburgayı fırından çıkarınız ve iki çatal yardımıyla didikleyerek tiftik haline getiririniz."
        ]
      },
      {
        "title": "Taco İç Malzemelerinin Yapılışı",
        "items": [
          "Olgun avokadoları bir kaba alıp çatal yardımıyla eziniz. Üzerine limon suyu ve bir çimdik tuz ekleyerek pürüzsüz bir kıvam alana kadar karıştırınız.",
          "Küçük küp doğranmış domates, kırmızı soğan ve halka doğranmış jalepenoyu bir kasede birleştiriniz. Üzerine lime suyu, zeytinyağı ve tuz ekleyerek karıştırınız. En son ince doğranmış taze kişniş yapraklarını ekleyerek salsayı tamamlayınımız."
        ]
      },
      {
        "title": "Sunum için",
        "items": [
          "Her taco shell’in içine birer tatlı kaşığı limonlu avokado püresi, dana kaburgayı, ve salsa sosu sürünüz. En son taze jalepeno, lime, kişniş yapraklarıyla süsleyeniz."
        ]
      }
    ],
    "source": "Vişne & Salsa Soslu Tarifler",
    "sourceBlog": "visne-salsa-soslu-tarifler",
    "sourcePath": "/blogs/visne-salsa-soslu-tarifler/visne-salsa-soslu-taco-shells",
    "sourceId": "gid://shopify/Article/609479459100",
    "aliases": [
      "visne-salsa-soslu-taco-shells"
    ]
  },
  {
    "slug": "carkifelek-soslu-karides-kanepe",
    "title": "Çarkıfelek Soslu Karides Kanepe",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/IMG_9498_4feabf1b-0390-4b33-a6bb-cf185698c67d.jpg?v=1746084748",
    "productSlug": "carkifelek-sosu",
    "product": "Çarkıfelek Sosu",
    "summary": "",
    "serves": "9 Kişlik",
    "times": [
      [
        "Hazırlama",
        "15 dk"
      ],
      [
        "Pişirme",
        "3-4 dk"
      ]
    ],
    "time": "Hazırlama 15 dk · Pişirme 3-4 dk",
    "ingredients": [
      "9 adet Alman ekmeği (halka kesilmiş)",
      "150 g süzme yoğurt",
      "80 gr labne",
      "¼ bağ dereotu (ince kıyılmış)",
      "½ adet limon (kabuğu rendelenmiş, suyu sıkılmış)",
      "1 çimdik tuz",
      "1 çimdik taze çekilmiş karabiber",
      "90 gr Freya Gurme Çarkıfelek Sos",
      "9 adet jumbo karides",
      "3 adet baby turp (ince halka doğranmış)",
      "Mikro filizler"
    ],
    "ingredientGroups": [
      {
        "title": "9 adet kanepe için",
        "items": [
          "9 adet Alman ekmeği (halka kesilmiş)",
          "150 g süzme yoğurt",
          "80 gr labne",
          "¼ bağ dereotu (ince kıyılmış)",
          "½ adet limon (kabuğu rendelenmiş, suyu sıkılmış)",
          "1 çimdik tuz",
          "1 çimdik taze çekilmiş karabiber",
          "90 gr Freya Gurme Çarkıfelek Sos",
          "9 adet jumbo karides"
        ]
      },
      {
        "title": "Süsleme İçin",
        "items": [
          "3 adet baby turp (ince halka doğranmış)",
          "Mikro filizler"
        ]
      }
    ],
    "steps": [
      "Jumbo karidesleri temizleyerek kabuklarını soyunuz (kuyruk kısmını bırakabilirsiniz). Tuz ve karabiber ile hafifçe tatlandırınız. Tavayı orta ateşte ısıtınız, biraz zeytinyağı ekleyerek karidesleri 1-2 dakika her iki tarafı hafif kızarana kadar pişiriniz. Pişen karidesleri bir kenara alınız ve dinlendiriniz. Süzme yoğurt, labne, kıyılmış dereotu, limon kabuğu ve limon suyunu bir kasede iyice karıştırınız. Tuz ve karabiber ekleyerek lezzet dengesini ayarlayınız.",
      "Alman ekmeği dilimlerini hafifçe kızartarak çıtır hale getiriniz. Üzerine yoğurtlu kremi ve Freya Gurme Çarkıfelek sosu eşit şekilde sürünüz. İnce doğranmış baby turpları düzenli şekilde kremanın üzerine yerleştiriniz. Üzerine birer adet pişmiş jumbo karides ekleyeniz. Mikro filiz ve ince dilimlenmiş baby turplarla üzerini süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Jumbo karidesleri temizleyerek kabuklarını soyunuz (kuyruk kısmını bırakabilirsiniz). Tuz ve karabiber ile hafifçe tatlandırınız. Tavayı orta ateşte ısıtınız, biraz zeytinyağı ekleyerek karidesleri 1-2 dakika her iki tarafı hafif kızarana kadar pişiriniz. Pişen karidesleri bir kenara alınız ve dinlendiriniz. Süzme yoğurt, labne, kıyılmış dereotu, limon kabuğu ve limon suyunu bir kasede iyice karıştırınız. Tuz ve karabiber ekleyerek lezzet dengesini ayarlayınız.",
          "Alman ekmeği dilimlerini hafifçe kızartarak çıtır hale getiriniz. Üzerine yoğurtlu kremi ve Freya Gurme Çarkıfelek sosu eşit şekilde sürünüz. İnce doğranmış baby turpları düzenli şekilde kremanın üzerine yerleştiriniz. Üzerine birer adet pişmiş jumbo karides ekleyeniz. Mikro filiz ve ince dilimlenmiş baby turplarla üzerini süsleyiniz."
        ]
      }
    ],
    "source": "Çarkıfelek Soslu Tarifler",
    "sourceBlog": "carkifelekli-somon-ceviche",
    "sourcePath": "/blogs/carkifelekli-somon-ceviche/carkifelek-soslu-karides-kanepe",
    "sourceId": "gid://shopify/Article/609536639260",
    "aliases": [
      "carkifelek-soslu-karides-kanepe"
    ]
  },
  {
    "slug": "visne-iskin-soslu-brownie",
    "title": "Vişne Işkın Soslu Brownie",
    "cat": "tatli",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/0Z3A0500_1_c6b0d967-30eb-45d8-86c7-ff2f904637ff.jpg?v=1747150564",
    "productSlug": "visne-iskin-otu-sosu",
    "product": "Vişne & Işkın Otu Sosu",
    "summary": "",
    "serves": "",
    "times": [
      [
        "Hazırlama",
        "30 dk"
      ],
      [
        "Bekleme",
        "120 dk"
      ],
      [
        "Pişirme",
        "40 dk"
      ]
    ],
    "time": "Hazırlama 30 dk · Bekleme 120 dk",
    "ingredients": [
      "2 yumurta",
      "90 gr (2/3 sb) un",
      "50 gr (1/2 sb) kakao",
      "115 gr (1/2 sb) tereyag",
      "150 gr (3/4 sb) toz seker",
      "170 gr (1 sb) bitter çikolata",
      "1/2 tatli k. tuz",
      "1/2 tatli k. kabartma tozu",
      "1/2 tatli k. espresso",
      "100 gr Freya Gurme Vişne",
      "Yenilebilir Çiçekler"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "2 yumurta",
          "90 gr (2/3 sb) un",
          "50 gr (1/2 sb) kakao",
          "115 gr (1/2 sb) tereyag",
          "150 gr (3/4 sb) toz seker",
          "170 gr (1 sb) bitter çikolata",
          "1/2 tatli k. tuz",
          "1/2 tatli k. kabartma tozu",
          "1/2 tatli k. espresso"
        ]
      },
      {
        "title": "Üzerini süslemek için",
        "items": [
          "100 gr Freya Gurme Vişne",
          "Yenilebilir Çiçekler"
        ]
      }
    ],
    "steps": [
      "Fırını 180 derece fanlı ayar ısıtmaya başlayınız kalıbına da yağlı kağıt yerleştiriniz hazır da bekletiniz. Tereyağ ve çikolataları sospane alıp eritmeye başlayınız. Çikolatanın yüksek ısı da yanmamasına dikkat ediniz.",
      "Tamamen eridiklerinde toz şekeri ekleyiniz. Şekerde eriyene kadar kısık ateşte pişiriniz. 1-2 dk sürmesi lazım, derecesi olanlar 50-60 derece arasına gelince alabilirsiniz.",
      "Başka bir kapta yumurtaları, kakao, kahve, tuz ve kabartma tozunu çırpma teliyle pürüzsüzleşene kadar çırpınız. Yine devamlı çırparak sospendekileri yumurtalı karışımına ekleyiniz, en son unu ilave edip tamamen karıştırdıktan sonra harcın yarısını kalıba dökünüz. Arasına çikolata karışımını dökünüz, kalan harcı üstüne dökünüz. Spatulayla biraz üstünü düzelttikten sonra 25-30 dk arası pişiriniz. Fırından çıkınca tamamen soğumasını bekleyiniz, 1-2 saat buzdolabında dinlenmesini tavsiye ederiz. Dinlendikten sonra üzerine Freya Gurme Vişne Işkın sosu ve yenilebilir taze çiçeklerle süsleyiniz."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Fırını 180 derece fanlı ayar ısıtmaya başlayınız kalıbına da yağlı kağıt yerleştiriniz hazır da bekletiniz. Tereyağ ve çikolataları sospane alıp eritmeye başlayınız. Çikolatanın yüksek ısı da yanmamasına dikkat ediniz.",
          "Tamamen eridiklerinde toz şekeri ekleyiniz. Şekerde eriyene kadar kısık ateşte pişiriniz. 1-2 dk sürmesi lazım, derecesi olanlar 50-60 derece arasına gelince alabilirsiniz.",
          "Başka bir kapta yumurtaları, kakao, kahve, tuz ve kabartma tozunu çırpma teliyle pürüzsüzleşene kadar çırpınız. Yine devamlı çırparak sospendekileri yumurtalı karışımına ekleyiniz, en son unu ilave edip tamamen karıştırdıktan sonra harcın yarısını kalıba dökünüz. Arasına çikolata karışımını dökünüz, kalan harcı üstüne dökünüz. Spatulayla biraz üstünü düzelttikten sonra 25-30 dk arası pişiriniz. Fırından çıkınca tamamen soğumasını bekleyiniz, 1-2 saat buzdolabında dinlenmesini tavsiye ederiz. Dinlendikten sonra üzerine Freya Gurme Vişne Işkın sosu ve yenilebilir taze çiçeklerle süsleyiniz."
        ]
      }
    ],
    "source": "Vişne & Işkınotu Tarifler",
    "sourceBlog": "visne-iskinotlu-tarifler",
    "sourcePath": "/blogs/visne-iskinotlu-tarifler/visne-iskin-soslu-brownie",
    "sourceId": "gid://shopify/Article/609577500956",
    "aliases": [
      "visne-iskin-soslu-brownie"
    ]
  },
  {
    "slug": "ejder-meyveli-matcha-bowl",
    "title": "Ejder Meyveli Matcha Bowl",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/ejder-meyveli-matcha-bowl_8cd744f4-68ea-4bdb-a6dd-9a06d23108da.jpg?v=1789149337",
    "productSlug": "matcha-granola",
    "product": "Matcha Granola",
    "summary": "",
    "serves": "1 kişilik",
    "times": [],
    "time": "",
    "ingredients": [
      "180 g süzme yoğurt",
      "2 yemek kaşığı Freya Gurme Ejder Meyvesi Sosu",
      "40–45 g Freya Gurme Matcha Granola",
      "20 g Antep fıstığı",
      "15–20 g beyaz çikolata",
      "4–5 parça kuru mango"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "180 g süzme yoğurt",
          "2 yemek kaşığı Freya Gurme Ejder Meyvesi Sosu",
          "40–45 g Freya Gurme Matcha Granola",
          "20 g Antep fıstığı",
          "15–20 g beyaz çikolata",
          "4–5 parça kuru mango"
        ]
      }
    ],
    "steps": [
      "Süzme yoğurdu Freya Gurme Ejder Meyvesi Sosu ile karıştırıp pembe ve kremsi bir baz hazırlayın. Üzerine Freya Gurme Matcha Granola, Antep fıstığı, beyaz çikolata parçaları ve kuru mangoyu ekleyin."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Süzme yoğurdu Freya Gurme Ejder Meyvesi Sosu ile karıştırıp pembe ve kremsi bir baz hazırlayın. Üzerine Freya Gurme Matcha Granola, Antep fıstığı, beyaz çikolata parçaları ve kuru mangoyu ekleyin."
        ]
      }
    ],
    "source": "Granola",
    "sourceBlog": "granola",
    "sourcePath": "/blogs/granola/ejder-meyveli-matcha-bowl",
    "sourceId": "gid://shopify/Article/612918886684",
    "aliases": [
      "ejder-meyveli-matcha-bowl"
    ]
  },
  {
    "slug": "cikolatali-granola-bowl",
    "title": "Çikolatalı Granola",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/freya-gurme-cikolatali-granola_fbda6eda-77e7-4dbd-94f9-5fb1cd6cd403.jpg?v=1789149428",
    "productSlug": "cikolatali-granola",
    "product": "Çikolatalı Granola",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "180 g süzme yoğurt",
      "45 g Freya Gurme Çikolatalı Granola",
      "1 dolu tatlı kaşığı badem ezmesi",
      "15 g kavrulmuş badem",
      "40–50 g taze maviyemiş",
      "8–10 g bitter çikolata, ince rendelenmiş"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "180 g süzme yoğurt",
          "45 g Freya Gurme Çikolatalı Granola",
          "1 dolu tatlı kaşığı badem ezmesi",
          "15 g kavrulmuş badem",
          "40–50 g taze maviyemiş",
          "8–10 g bitter çikolata, ince rendelenmiş"
        ]
      }
    ],
    "steps": [
      "Süzme yoğurdu kasenin tabanına yayın. Üzerine Freya Gurme Çikolatalı Granolayı bolca serpiştirin. Taze maviyemişleri ve kavrulmuş bademleri ekleyin.",
      "Badem ezmesini hafifçe akışkan hale getirip kasenin üzerine gezdirin. Son dokunuş olarak bitter çikolatayı ince ince rendeleyin."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Süzme yoğurdu kasenin tabanına yayın. Üzerine Freya Gurme Çikolatalı Granolayı bolca serpiştirin. Taze maviyemişleri ve kavrulmuş bademleri ekleyin.",
          "Badem ezmesini hafifçe akışkan hale getirip kasenin üzerine gezdirin. Son dokunuş olarak bitter çikolatayı ince ince rendeleyin."
        ]
      }
    ],
    "source": "Granola",
    "sourceBlog": "granola",
    "sourcePath": "/blogs/granola/cikolatali-granola",
    "sourceId": "gid://shopify/Article/612919083292",
    "aliases": [
      "cikolatali-granola"
    ]
  },
  {
    "slug": "kuru-meyveli-granola-kumkuat-bowl",
    "title": "Kuru Meyveli Granola & Kumkat Bowl",
    "cat": "kahvalti",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/kuru-meyveli-granola-kumkuat-bowl_7560efb2-bf72-4c59-8b6f-05d4c30255f3.jpg?v=1789149533",
    "productSlug": "kuru-meyveli-granola",
    "product": "Kuru Meyveli Granola",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "180 g süzme yoğurt",
      "1 yemek kaşığı tahin",
      "15 g file Antep fıstığı",
      "40–45 g Freya Gurme Kuru Meyveli Granola",
      "3–4 adet taze kumkuat"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "180 g süzme yoğurt",
          "1 yemek kaşığı tahin",
          "15 g file Antep fıstığı",
          "40–45 g Freya Gurme Kuru Meyveli Granola",
          "3–4 adet taze kumkuat"
        ]
      }
    ],
    "steps": [
      "Süzme yoğurdu tahin ve file Antep fıstığının bir kısmıyla karıştırıp kasenin tabanına yayın. Üzerine Freya Gurme Kuru Meyveli Granola ekleyin.",
      "Kumkuatları kabuklarıyla birlikte ince halkalar halinde dilimleyip üzerine yerleştirin. Kalan file Antep fıstığını serpiştirerek tamamlayın."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Süzme yoğurdu tahin ve file Antep fıstığının bir kısmıyla karıştırıp kasenin tabanına yayın. Üzerine Freya Gurme Kuru Meyveli Granola ekleyin.",
          "Kumkuatları kabuklarıyla birlikte ince halkalar halinde dilimleyip üzerine yerleştirin. Kalan file Antep fıstığını serpiştirerek tamamlayın."
        ]
      }
    ],
    "source": "Granola",
    "sourceBlog": "granola",
    "sourcePath": "/blogs/granola/kuru-meyveli-granola-kumkat-bowl",
    "sourceId": "gid://shopify/Article/612919116060",
    "aliases": [
      "kuru-meyveli-granola-kumkat-bowl"
    ]
  },
  {
    "slug": "maviyemis-lavanta-soslu-ilik-patates-salatasi",
    "title": "Freya Gurme Maviyemiş & Lavanta Soslu Ilık Patates Salatası",
    "cat": "salata",
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/articles/maviyemis-lavanta-soslu-ilik-patates-salatasi.jpg?v=1789149599",
    "productSlug": "maviyemis-lavanta-sosu",
    "product": "Maviyemiş & Lavanta Sosu",
    "summary": "",
    "serves": "",
    "times": [],
    "time": "",
    "ingredients": [
      "1 kg baby patates",
      "1 bağ kuşkonmaz",
      "50 g kavrulmuş badem",
      "50–60 g parmesan, bolca rendelenmiş",
      "1 yemek kaşığı kapari",
      "½ demet dereotu",
      "Taze kekik",
      "Taze rendelenmiş muskat",
      "Tuz, karabiber",
      "Zeytinyağı",
      "150 g Freya Gurme Maviyemiş & Lavanta Sosu",
      "2–3 yemek kaşığı zeytinyağı",
      "Tuz",
      "Taze çekilmiş karabiber"
    ],
    "ingredientGroups": [
      {
        "title": "",
        "items": [
          "1 kg baby patates",
          "1 bağ kuşkonmaz",
          "50 g kavrulmuş badem",
          "50–60 g parmesan, bolca rendelenmiş",
          "1 yemek kaşığı kapari",
          "½ demet dereotu",
          "Taze kekik",
          "Taze rendelenmiş muskat",
          "Tuz, karabiber",
          "Zeytinyağı"
        ]
      },
      {
        "title": "Maviyemiş & Lavanta sosu için",
        "items": [
          "150 g Freya Gurme Maviyemiş & Lavanta Sosu",
          "2–3 yemek kaşığı zeytinyağı",
          "Tuz",
          "Taze çekilmiş karabiber"
        ]
      }
    ],
    "steps": [
      "Baby patatesleri ortadan ikiye kesin ve tuzlu suda tamamen yumuşamadan, hafif diri kalacak şekilde ön haşlama yapın. Süzüp birkaç dakika dinlendirin.",
      "Patatesleri zeytinyağı, tuz, karabiber ve taze rendelenmiş muskat ile harmanlayın. Fırına verip dışları güzelce kızarıp çıtırlaşana kadar pişirin.",
      "Kuşkonmazları iri parçalar halinde kesip kısa süre soteleyin ve hafif diri bırakın.",
      "Ayrı bir sos kabında Freya Gurme Maviyemiş & Lavanta Sosu, zeytinyağı, tuz ve taze çekilmiş karabiberi çırparak akışkan bir sos kıvamına getirin.",
      "Fırından çıkan sıcak patatesleri kuşkonmaz, kapari ve kavrulmuş bademle birleştirin. Hazırladığınız maviyemişli sosu üzerine gezdirip nazikçe harmanlayın.",
      "İnce kıyılmış dereotu ve taze kekiği ekleyin. Servis tabağına aldıktan sonra üzerine bolca parmesan rendeleyerek tamamlayın."
    ],
    "stepGroups": [
      {
        "title": "",
        "items": [
          "Baby patatesleri ortadan ikiye kesin ve tuzlu suda tamamen yumuşamadan, hafif diri kalacak şekilde ön haşlama yapın. Süzüp birkaç dakika dinlendirin.",
          "Patatesleri zeytinyağı, tuz, karabiber ve taze rendelenmiş muskat ile harmanlayın. Fırına verip dışları güzelce kızarıp çıtırlaşana kadar pişirin.",
          "Kuşkonmazları iri parçalar halinde kesip kısa süre soteleyin ve hafif diri bırakın.",
          "Ayrı bir sos kabında Freya Gurme Maviyemiş & Lavanta Sosu, zeytinyağı, tuz ve taze çekilmiş karabiberi çırparak akışkan bir sos kıvamına getirin.",
          "Fırından çıkan sıcak patatesleri kuşkonmaz, kapari ve kavrulmuş bademle birleştirin. Hazırladığınız maviyemişli sosu üzerine gezdirip nazikçe harmanlayın.",
          "İnce kıyılmış dereotu ve taze kekiği ekleyin. Servis tabağına aldıktan sonra üzerine bolca parmesan rendeleyerek tamamlayın."
        ]
      }
    ],
    "source": "Maviyemiş Lavanta Soslu Tarifler",
    "sourceBlog": "maviyemis-lavanta-soslu-tarifler",
    "sourcePath": "/blogs/maviyemis-lavanta-soslu-tarifler/freya-gurme-maviyemis-lavanta-soslu-ilik-patates-salatasi",
    "sourceId": "gid://shopify/Article/612919148828",
    "aliases": [
      "freya-gurme-maviyemis-lavanta-soslu-ilik-patates-salatasi"
    ]
  }
];
(function(){
  const approved=(window.FREYA_RECIPES||[]).filter(r=>r.steps?.length && r.ingredients?.length);
  const imported=window.FREYA_IMPORTED_RECIPES;
  const matched=new Set();
  window.FREYA_RECIPES=approved.map(r=>{
    const live=imported.find(n=>n.slug===r.slug || n.aliases.includes(r.slug));
    if(!live)return r;
    matched.add(live.sourceId);
    return {...r,sourceId:live.sourceId,sourcePath:live.sourcePath,sourceBlog:live.sourceBlog,aliases:live.aliases};
  }).concat(imported.filter(r=>!matched.has(r.sourceId)));
})();
